module.exports = (function() {

    const EXAMPLE_REQUEST_REGEX_DELETE = {
        'entries': [
            {
                'patternName': 'ssn',
            }
        ]
    };

    const EXAMPLE_REQUEST_REGEX_VALIDATE = {
        'entries': [
            {
                'patternName': 'ssn',
                'patternConfig': {
                    'entityType': 'SSN',
                    'extractionConfidence': 0.75,
                    'description': 'Pattern for social security numbers',
                    'pattern': '[0-9]{3}\\-[0-9]{2}\\-[0-9]{3}'
                }
            },
            {
                'patternName': 'SSN',
                'patternConfig': {
                    'entityType': 'SSN',
                    'extractionConfidence': 0.75,
                    'description': 'Tests a pattern that already exists',
                    'pattern': '[0-9]{3}\\-[0-9]{2}\\-[0-9]{3}'
                }
            },
            {
                'patternName': 'ipv4',
                'patternConfig': {
                    'entityType': 'IPV4',
                    'description': 'Tests a pattern without a confidence',
                    'pattern': '[0-9]{1,3}[\\.][0-9]{1,3}[\\.][0-9]{1,3}[\\.][0-9]{1,3}'
                }
            },
            {
                'patternName': 'measurement',
                'patternConfig': {
                    'extractionConfidence': 0.75,
                    'description': 'Tests a user pattern missing a type',
                    'pattern': '[1-9]+\\s(mm|cm|inches)'
                }
            },
            {
                'patternName': 'foobar',
                'patternConfig': {
                    'entityType': 'SOURCE',
                    'extractionConfidence': 0.75,
                    'description': 'Tests a invalid regex',
                    'pattern': '(?P<type>***'
                }
            },
            {
                'patternName': 'foobar2',
                'patternConfig': {
                    'entityType': '123',
                    'extractionConfidence': 0.75,
                    'description': 'Tests an invalid entity type',
                    'pattern': '[Hh]ello\\s[Ww]orld'
                }
            }
        ]
    };

    const EXAMPLE_REQUEST_REGEX_INSERT = {
        'entries': [
            {
                'patternName': 'trending_hashtag',
                'patternConfig': {
                    'entityType': 'HASHTAG',
                    'extractionConfidence': 0.75,
                    'description': 'A simple pattern for trending hashtags',
                    'pattern': '#(?P<tag>\\w{1,139})\\b'
                }
            },
            {
                'patternName': 'ssn',
                'patternConfig': {
                    'entityType': 'SSN',
                    'extractionConfidence': 0.75,
                    'description': 'A simple social security pattern with static attributes',
                    'pattern': '[0-9]{3}\\-[0-9]{2}\\-[0-9]{4}',
                    'removeAllOverlap': true
                }
            }
        ]
    };
    
    const EXAMPLE_RESPONSE_REGEX_INSERT = {
        'code': '200',
        'message': 'Sucessfully added all patterns',
        'details': []
    };

    const EXAMPLE_RESPONSE_REGEX_INSERT_ERROR = {
        'code': '400',
        'message': 'No patterns added',
        'details': [
            '[ipv4] - Pattern with name \'ipv4\' already exists in the list',
            '[source] - Pattern with name \'source\' already exists in the list',
            '[url] - Pattern with name \'url\' already exists in the list',
            '[ssn] - Pattern with name \'ssn\' already exists in the list'
        ]
    };

    const EXAMPLE_RESPONSE_REGEX_VALIDATE_DETAILS = {
        'code': '250',
        'message': 'Patterns are invalid',
        'details': [
            '[ssn] - Pattern \'SSN\' already exists for normalized key \'ssn\'',
            '[ipv4] - Pattern \'ipv4\' is missing \'extractionConfidence\' object',
            '[measurement] - Pattern \'measurement\' is missing \'entityType\' object',
            '[foobar] - Pattern \'foobar\' failed a compile test; ensure proper re2 syntax before submitting',
            '[foobar2] - Entity type \'123\' contains invalid characters'
        ]
    };

    const EXAMPLE_RESPONSE_REGEX_VALIDATE_NO_DETAILS = {
        'code': '200',
        'message': 'All patterns are valid',
        'details': []
    };

    const EXAMPLE_RESPONSE_REGEX_DELETE_ALL = {
        'code': '200',
        'message': 'User patterns cleared',
        'details': []
    };

    const EXAMPLE_RESPONSE_REGEX_DELETE = {
        'code': '200',
        'message': 'Sucessfully removed all patterns',
        'details': []
    };

    const EXAMPLE_RESPONSE_REGEX_DELETE_WARNING = {
        'code': '250',
        'message': 'Some patterns were not removed',
        'details': [
            '[foobar] - No pattern exists'
        ]
    };

    const EXAMPLE_RESPONSE_REGEX_DELETE_ERROR = {
        'code': '400',
        'message': 'No patterns were removed',
        'details': [
            '[foobar1] - No entry exists',
            '[foobar2] - No entry exists',
            '[foobar3] - No entry exists'
        ]
    };
    
    const EXAMPLE_BASIC_REGEX = {
        'entries': [
            {
                'patternName': 'ssn',
                'patternConfig': {
                    'entityType': 'SSN',
                    'extractionConfidence': 0.75,
                    'description': 'A social security pattern with static attributes',
                    'pattern': '[0-9]{3}\\-[0-9]{2}\\-[0-9]{4}',
                    'metadata': {
                        'private': true,
                        'full': 'social security number',
                        'entityTypeId': 314897
                    },
                    'removeAllOverlap': true
                }
            }
        ]
    }
    
    const EXAMPLE_ADVANCED_REGEX = {
        'entries': [
            {
                'patternName': 'trending_hashtag',
                'patternConfig': {
                    'entityType': 'HASHTAG',
                    'extractionConfidence': 0.75,
                    'description': 'A simple pattern for trending hashtags',
                    'pattern': '#(?P<tag>\\w{1,139})\\b'
                }
            }
        ]
    }
    
    
    
    const EXAMPLE_RESPONSE_EXTRACTION_INSERT  = {
        'code': '200',
        'message': 'Sucessfully added all entries',
        'details': []
    }

    const EXAMPLE_RESPONSE_EXTRACTION_INSERT_ERROR  = {
        'code': '400',
        'message': 'No entries added',
        'details': [
            '[123][entry name] - The matchText \'Entry Name\' is a duplicate key after normalization',
            '[456][other entry name] - The matchText \'Other Entry Name\' is a duplicate key after normalization',
        ]
    }

    const EXAMPLE_RESPONSE_EXTRACTION_VALIDATE_DETAILS = {
        'code': '250',
        'message': 'Entries are invalid',
        'details': [
            '[1][watch on max] - Recognized attribute \'entitySubString\' but \'hbo\' was not a substring of \'watch on Max\'',
            '[3][leader] - The matchText \'leader\' is a duplicate key after normalization',
            '[4][the] - The key \'The\' is a common word and is prohibited; this cannot be used to prevent unknown downstream side effects',
            '[5][my place] - Adding GEO \'My Place\' is prohibited, please use the MetaCarta custom gazetteer instead',
            '[3][john deere] - Normalized entry for \'John Deere\' already exists in dictionary'
        ]
    }
    
    const EXAMPLE_RESPONSE_EXTRACTION_VALIDATE_NO_DETAILS = {
        'code': '200',
        'message': 'All entries are valid',
        'details': []
    }

    const EXAMPLE_RESPONSE_EXTRACTION_DELETE = {
        'code': '200',
        'message': 'Sucessfully removed all entries',
        'details': []
    }
    
    const EXAMPLE_RESPONSE_EXTRACTION_DELETE_WARNING = {
        'code': '250',
        'message': 'Some entries were not removed',
        'details': [
            '[0][leader] - No entry exists',
            '[2][news10] - No entry exists'
        ]
    }

    const EXAMPLE_RESPONSE_EXTRACTION_DELETE_ERROR = {
        'code': '400',
        'message': 'No entries were removed',
        'details': [
            '[0][leader] - No entry exists',
            '[1][abc] - No entry exists',
            '[2][news10] - No entry exists'
        ]
    }

    const EXAMPLE_RESPONSE_EXTRACTION_DELETE_ALL = {
        'code': '200',
        'message': 'User dictionary cleared',
        'details': []
    }    

    const EXAMPLE_RESPONSE_ACRONYM = {
        'entities': [
            {
                'count': 2,
                'disambiguated': {
                    'id': '13107869253634',
                    'permIds': [
                        '4295913002'
                    ]
                },
                'label': 'Cray',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.6215570738934248,
                        'extractedText': 'Cray Inc.',
                        'extractionConfidence': 0.999807006431,
                        'position': [
                            28,
                            37
                        ]
                    },
                    {
                        'disambiguationConfidence': 0.603680714213931,
                        'extractedText': 'Cray',
                        'extractionConfidence': 0.995946728733,
                        'position': [
                            302,
                            306
                        ]
                    }
                ],
                'type': 'ORGANIZATION/COMPANY'
            },
            {
                'attributes': {
                    'longForm': 'Artificial Intelligence',
                    'shortForm': 'AI'
                },
                'count': 2,
                'disambiguated': {
                    'id': '1323063772142'
                },
                'label': 'artificial intelligence',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.6606521124785505,
                        'extractedText': 'Artificial Intelligence (AI)',
                        'extractionConfidence': 1,
                        'position': [
                            77,
                            105
                        ]
                    },
                    {
                        'disambiguationConfidence': 0.6323723999035005,
                        'extractedText': 'AI',
                        'extractionConfidence': 1,
                        'position': [
                            224,
                            226
                        ]
                    }
                ],
                'type': 'THING/TECHNOLOGY'
            },
            {
                'attributes': {
                    'longForm': 'deep learning',
                    'shortForm': 'DL'
                },
                'count': 3,
                'disambiguated': {
                    'id': '1323292034030'
                },
                'label': 'deep learning',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.7229941116063959,
                        'extractedText': 'deep learning (DL)',
                        'extractionConfidence': 1,
                        'position': [
                            189,
                            207
                        ]
                    },
                    {
                        'disambiguationConfidence': 0.721661175232629,
                        'extractedText': 'DL',
                        'extractionConfidence': 1,
                        'position': [
                            231,
                            233
                        ]
                    },
                    {
                        'disambiguationConfidence': 0.6534273271281765,
                        'extractedText': 'DL',
                        'extractionConfidence': 1,
                        'position': [
                            395,
                            397
                        ]
                    }
                ],
                'type': 'THING/TECHNOLOGY'
            }
        ],
        'requestId': 'a9f0e06d-56bf-44aa-83e9-754a954a03a8',
        'text': 'Global supercomputer leader Cray Inc. today announced a comprehensive set of Artificial Intelligence (AI) products and programs that will empower customers to learn, start, and scale their deep learning (DL) initiatives. As AI and DL continue to transform entire industries and scientific disciplines, Cray is leveraging its supercomputing expertise, technologies, and best practices to advance DL adoption. '
    };

    const EXAMPLE_RESPONSE_DATETIME1 = {
        'entities': [
            {
                'attributes': {
                    'hour': 10,
                    'minute': 10
                },
                'count': 1,
                'label': '10:10:00',
                'mentions': [
                    {
                        'extractedText': '10:10 am',
                        'extractionConfidence': 0.975,
                        'position': [
                            0,
                            8
                        ]
                    }
                ],
                'type': 'DATETIME'
            }
        ],
        'requestId': 'dbff0948-91e5-4c18-836a-de20d5603123',
        'text': '10:10 am'
    };

    const EXAMPLE_RESPONSE_DATETIME2 = {
        'entities': [
            {
                'attributes': {
                    'dayOfMonth': 4,
                    'hour': 14,
                    'minute': 0,
                    'monthOfYear': 10,
                    'timeZone': 'Eastern Daylight Time',
                    'year': 2006
                },
                'count': 1,
                'label': '2006-10-04T14:00:00-04:00',
                'mentions': [
                    {
                        'extractedText': 'Wednesday, October 4, 2006 02:00 PM EDT',
                        'extractionConfidence': 0.975,
                        'position': [
                            0,
                            39
                        ]
                    }
                ],
                'type': 'DATETIME'
            }
        ],
        'requestId': 'ee225057-e4f9-4633-940d-e13dfec1bc82',
        'text': 'Wednesday, October 4, 2006 02:00 PM EDT'
    };

    const EXAMPLE_RESPONSE_DATETIME3 = {
        'entities': [
            {
                'attributes': {
                    'dayOfMonth': 26,
                    'estimated': true,
                    'monthOfYear': 2,
                    'year': 2019
                },
                'count': 1,
                'label': '2019-02-26',
                'mentions': [
                    {
                        'extractedText': 'next Tuesday',
                        'extractionConfidence': 0.975,
                        'position': [
                            20,
                            32
                        ]
                    }
                ],
                'type': 'DATETIME'
            }
        ],
        'requestId': '8bcc2a18-80a0-448c-90f3-89895584dd19',
        'text': 'The meeting will be next Tuesday'
    };

    const EXAMPLE_RESPONSE_DATETIMERANGE1 = {
        'entities': [
            {
                'attributes': {
                    'endDate': {
                        'dayOfMonth': 31,
                        'monthOfYear': 7,
                        'normalizedText': '2006-07-31',
                        'year': 2006
                    },
                    'period': 'P1M30D',
                    'startDate': {
                        'dayOfMonth': 1,
                        'monthOfYear': 6,
                        'normalizedText': '2006-06-01',
                        'year': 2006
                    }
                },
                'count': 1,
                'label': '2006-06-01 to 2006-07-31',
                'mentions': [
                    {
                        'extractedText': 'June through July 2006',
                        'extractionConfidence': 0.975,
                        'position': [
                            0,
                            22
                        ]
                    }
                ],
                'type': 'DATETIME_RANGE'
            }
        ],
        'requestId': '29aabce7-3b27-4da0-a9df-629a25fd954e',
        'text': 'June through July 2006'
    };

    const EXAMPLE_RESPONSE_DATETIMERANGE2 = {
        'entities': [
            {
                'attributes': {
                    'endDate': {
                        'dayOfMonth': 31,
                        'monthOfYear': 12,
                        'normalizedText': '1989-12-31',
                        'year': 1989
                    },
                    'period': 'P9Y11M30D',
                    'startDate': {
                        'dayOfMonth': 1,
                        'monthOfYear': 1,
                        'normalizedText': '1980-01-01',
                        'year': 1980
                    }
                },
                'count': 1,
                'label': '1980-01-01 to 1989-12-31',
                'mentions': [
                    {
                        'extractedText': '1980s',
                        'extractionConfidence': 0.975,
                        'position': [
                            0,
                            5
                        ]
                    }
                ],
                'type': 'DATETIME_RANGE'
            }
        ],
        'requestId': 'f882b1a6-502a-4df0-8d97-9ae0dbb1516a',
        'text': '1980s'
    };

    const EXAMPLE_RESPONSE_DATETIMERANGE3 = {
        'entities': [
            {
                'attributes': {
                    'endDate': {
                        'dayOfMonth': 31,
                        'monthOfYear': 3,
                        'normalizedText': '2018-03-31',
                        'year': 2018
                    },
                    'estimated': true,
                    'period': 'P30D',
                    'startDate': {
                        'dayOfMonth': 1,
                        'monthOfYear': 3,
                        'normalizedText': '2018-03-01',
                        'year': 2018
                    }
                },
                'count': 1,
                'label': '2018-03-01 to 2018-03-31',
                'mentions': [
                    {
                        'extractedText': 'last March',
                        'extractionConfidence': 0.975,
                        'position': [
                            21,
                            31
                        ]
                    }
                ],
                'type': 'DATETIME_RANGE'
            }
        ],
        'requestId': '13fad55c-7bb1-432c-9281-81db9db796e4',
        'text': 'The results are from last March'
    };

    const EXAMPLE_RESPONSE_EMAIL1 = {
        'entities': [
            {
                'attributes': {
                    'domain': {
                        'domainName': 'energy.state.ca.us'
                    },
                    'localPart': 'mediaoffice'
                },
                'count': 1,
                'label': 'mediaoffice@energy.state.ca.us',
                'mentions': [
                    {
                        'extractedText': 'mediaoffice@energy.state.ca.us',
                        'extractionConfidence': 0.94999999999,
                        'position': [
                            62,
                            92
                        ]
                    }
                ],
                'type': 'EMAIL'
            }
        ],
        'requestId': '448b0d54-6f8b-4529-b361-ed32d5990888',
        'text': '..Assistant Executive Director for Communications e-mail at: [mediaoffice@energy.state.ca.us]. Information concerning the status of the project, as well as notices and other relevant documents...'
    };

    const EXAMPLE_RESPONSE_EMAIL2 = {
        'entities': [
            {
                'attributes': {
                    'domain': {
                        'domainName': 'alaskapublic.org'
                    },
                    'localPart': 'talk'
                },
                'count': 1,
                'label': 'talk@alaskapublic.org',
                'mentions': [
                    {
                        'extractedText': 'talk [at] alaskapublic [dot] org',
                        'extractionConfidence': 0.65074999999315,
                        'position': [
                            18,
                            50
                        ]
                    }
                ],
                'type': 'EMAIL'
            }
        ],
        'requestId': '223d7bcd-8b64-4709-a102-6d111cdacbb5',
        'text': '...Send e-mail to talk [at] alaskapublic [dot] org (comments may be read on air)...'
    };

    const EXAMPLE_RESPONSE_GEO1 = {
        'entities': [
            {
                'count': 1,
                'disambiguated': {
                    'id': '1319683096578',
                    'permIds': [
                        '4295905298'
                    ]
                },
                'label': 'Walmart',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.7807914871735293,
                        'extractedText': 'Walmart',
                        'extractionConfidence': 0.990764589609,
                        'position': [
                            0,
                            7
                        ]
                    }
                ],
                'type': 'ORGANIZATION/COMPANY'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '48732569600',
                    'location': {
                        'admin1Fips': 'US05',
                        'admin1Genc': 'US-AR',
                        'admin1Label': 'Arkansas',
                        'countryFips': 'US',
                        'countryGenc2': 'US',
                        'countryGenc3': 'USA',
                        'countryGencCode': '840',
                        'countryLabel': 'United States',
                        'dsgFeatureClass': 'P',
                        'dsgFeatureCode': 'PPL',
                        'latitude': 36.3729,
                        'longitude': -94.2088,
                        'population': 19730
                    }
                },
                'label': 'Bentonville',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.634944,
                        'extractedText': 'Bentonville',
                        'extractionConfidence': 0.981367,
                        'position': [
                            28,
                            39
                        ]
                    }
                ],
                'type': 'GEO'
            }
        ],
        'requestId': 'e6553269-da1d-4314-a34a-69e9eb3155bb',
        'text': 'Walmart is headquartered in Bentonville.'
    };

    const EXAMPLE_RESPONSE_GEO2 = {
        'entities': [
            {
                'count': 1,
                'disambiguated': {
                    'id': '5281218560',
                    'location': {
                        'admin1Fips': 'IZ15',
                        'admin1Genc': 'IQ-NI',
                        'admin1Label': 'Ninawa',
                        'countryFips': 'IZ',
                        'countryGenc2': 'IQ',
                        'countryGenc3': 'IRQ',
                        'countryGencCode': '368',
                        'countryLabel': 'Iraq',
                        'dsgFeatureClass': 'P',
                        'dsgFeatureCode': 'PPLA',
                        'latitude': 36.1667,
                        'longitude': 42.5833,
                        'population': 1694284
                    }
                },
                'label': 'Mosul',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.655286,
                        'extractedText': 'Mosul',
                        'extractionConfidence': 0.89685,
                        'position': [
                            17,
                            22
                        ]
                    }
                ],
                'type': 'GEO'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '21343698944',
                    'location': {
                        'admin1Fips': 'SY04',
                        'admin1Genc': 'SY-RA',
                        'admin1Label': 'Ar Raqqah',
                        'countryFips': 'SY',
                        'countryGenc2': 'SY',
                        'countryGenc3': 'SYR',
                        'countryGencCode': '760',
                        'countryLabel': 'Syria',
                        'dsgFeatureClass': 'P',
                        'dsgFeatureCode': 'PPLA',
                        'latitude': 35.9528,
                        'longitude': 39.0079,
                        'population': 736313
                    }
                },
                'label': 'Ar Raqqah',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.717481,
                        'extractedText': 'Raqqa',
                        'extractionConfidence': 0.933411,
                        'position': [
                            49,
                            54
                        ]
                    }
                ],
                'type': 'GEO'
            },
            {
                'attributes': {
                    'firstName': 'ABU BAKR',
                    'gender': 'M',
                    'lastName': 'AL-BAGHDADI'
                },
                'count': 1,
                'disambiguated': {
                    'id': '535387635713'
                },
                'label': 'Abu Bakr al-Baghdadi',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.8052548015018126,
                        'extractedText': 'Abu Bakr al-Baghdadi',
                        'extractionConfidence': 0.992457624355,
                        'position': [
                            95,
                            115
                        ]
                    }
                ],
                'type': 'PERSON'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '6553605636098'
                },
                'label': 'Islamic State of Iraq and the Levant',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.8746048914116757,
                        'extractedText': 'ISIL',
                        'extractionConfidence': 1,
                        'position': [
                            117,
                            121
                        ]
                    }
                ],
                'type': 'ORGANIZATION/CRIMINAL'
            }
        ],
        'requestId': 'c43cc21b-2ec0-4cf6-bd01-8287ebb26bd4',
        'text': 'With the fall of Mosul, the impending capture of Raqqa, and the confirmed death of its leader, Abu Bakr al-Baghdadi, ISIL\'s days as a caliphate are numbered.'
    };

    const EXAMPLE_RESPONSE_IPV41 = {
        'entities': [
            {
                'attributes': {
                    'accuracyRadius': 1000,
                    'address': '22.101.241.153',
                    'continentLabel': 'North America',
                    'countryIso': 'US',
                    'countryLabel': 'United States',
                    'latitude': 37.751,
                    'legitimateProxy': false,
                    'longitude': -97,
                    'metroCode': 0
                },
                'count': 1,
                'label': '22.101.241.153',
                'mentions': [
                    {
                        'extractedText': '0x16.0x65.0xF1.0x99',
                        'extractionConfidence': 0.95,
                        'position': [
                            46,
                            65
                        ]
                    }
                ],
                'type': 'IPV4'
            },
            {
                'attributes': {
                    'accuracyRadius': 1000,
                    'address': '22.101.31.153',
                    'continentLabel': 'North America',
                    'countryIso': 'US',
                    'countryLabel': 'United States',
                    'latitude': 37.751,
                    'legitimateProxy': false,
                    'longitude': -97,
                    'metroCode': 0
                },
                'count': 1,
                'label': '22.101.31.153',
                'mentions': [
                    {
                        'extractedText': '026.0145.037.0231',
                        'extractionConfidence': 0.95,
                        'position': [
                            83,
                            100
                        ]
                    }
                ],
                'type': 'IPV4'
            },
            {
                'attributes': {
                    'port': 8080
                },
                'count': 1,
                'label': '127.0.0.1:8080',
                'mentions': [
                    {
                        'extractedText': '127.0.0.1:8080',
                        'extractionConfidence': 0.95,
                        'position': [
                            119,
                            133
                        ]
                    }
                ],
                'type': 'IPV4'
            }
        ],
        'requestId': 'd58565ef-2893-4211-8a2c-7181e7ace982',
        'text': '...can ping the servers over at qmachine-1 on 0x16.0x65.0xF1.0x99 or qmachine-2 on 026.0145.037.0231 or run locally on 127.0.0.1:8080 with the exception that...'
    };

    const EXAMPLE_RESPONSE_IPV42 = {
        'requestId': 'f92294fc-9fd9-4a9a-ba8d-c463cee7b870',
        'text': 'The IP 144. 0. 241. 198 has just been banned by Fail2Ban after 5 attempts.'
    };

    const EXAMPLE_RESPONSE_MEASURE1 = {
        'entities': [
            {
                'attributes': {
                    'ieeeBand': 'VHF',
                    'ituBand': 'VHF',
                    'natoBand': 'A',
                    'normalizedValue': 80000000,
                    'type': 'frequency',
                    'units': 'Hz'
                },
                'count': 1,
                'label': '80000000 Hz',
                'mentions': [
                    {
                        'extractedText': '80 MHz',
                        'extractionConfidence': 1,
                        'position': [
                            105,
                            111
                        ]
                    }
                ],
                'type': 'MEASUREMENT'
            }
        ],
        'requestId': '1266be08-d31e-4acd-8343-ea55dcfd31e6',
        'text': 'The chip is the first product to implement the full ITU-T G.hn specification with MIMO support and up to 80 MHz.'
    };

    const EXAMPLE_RESPONSE_MEASURE2 = {
        'entities': [
            {
                'attributes': {
                    'endValue': 3000000000000,
                    'startValue': 3,
                    'type': 'frequency',
                    'units': 'Hz'
                },
                'count': 1,
                'label': '3 Hz - 3E+12 Hz',
                'mentions': [
                    {
                        'extractedText': '3 Hz to 3 THz',
                        'extractionConfidence': 1,
                        'position': [
                            85,
                            98
                        ]
                    }
                ],
                'type': 'MEASUREMENT'
            }
        ],
        'requestId': 'fde2eaaa-7561-4b15-815b-2d407ce5a912',
        'text': 'The radio spectrum is the part of the electromagnetic spectrum with frequencies from 3 Hz to 3 THz.'
    };

    const EXAMPLE_RESPONSE_MEASURE3 = {
        'entities': [
            {
                'attributes': {
                    'change': '+',
                    'normalizedValue': 0.2,
                    'type': 'percent'
                },
                'count': 1,
                'label': '+0.2%',
                'mentions': [
                    {
                        'extractedText': '0.2 percent',
                        'extractionConfidence': 0.99,
                        'position': [
                            57,
                            68
                        ]
                    }
                ],
                'type': 'MEASUREMENT'
            },
            {
                'attributes': {
                    'change': '+',
                    'normalizedValue': 1.2,
                    'type': 'percent'
                },
                'count': 1,
                'label': '+1.2%',
                'mentions': [
                    {
                        'extractedText': '1.2 percent',
                        'extractionConfidence': 0.99,
                        'position': [
                            91,
                            102
                        ]
                    }
                ],
                'type': 'MEASUREMENT'
            }
        ],
        'requestId': '76785b36-e7c7-4757-bbd6-fd4765416184',
        'text': 'In terms of data, the euro zone registered a growth rate 0.2 percent on the quarter and of 1.2 percent on the year at the end of 2018.'
    };

    const EXAMPLE_RESPONSE_MONEY1 = {
        'entities': [
            {
                'attributes': {
                    'amount': '38.38',
                    'currencyCode': [
                        'USD',
                        'ARS',
                        'AUD',
                        'BBD',
                        'BMD',
                        'BND',
                        'BSD',
                        'BZD',
                        'CAD',
                        'CLP',
                        'COP',
                        'CUC',
                        'CUP',
                        'DOP',
                        'FJD',
                        'GYD',
                        'HKD',
                        'JMD',
                        'KYD',
                        'LRD',
                        'MXN',
                        'NAD',
                        'NZD',
                        'SBD',
                        'SGD',
                        'SRD',
                        'TTD',
                        'TWD',
                        'XCD',
                        'ZWL'
                    ],
                    'normalizedAmount': 38.38,
                    'symbol': '$'
                },
                'count': 1,
                'label': '$38.38',
                'mentions': [
                    {
                        'extractedText': '$38.38',
                        'extractionConfidence': 0.95,
                        'position': [
                            0,
                            6
                        ]
                    }
                ],
                'type': 'MONEY'
            }
        ],
        'requestId': 'bdf6668f-7eaf-4644-9d06-a83fb3f67f53',
        'text': '$38.38'
    };

    const EXAMPLE_RESPONSE_MONEY2 = {
        'entities': [
            {
                'attributes': {
                    'amount': '156',
                    'amountModifier': 'billion',
                    'normalizedAmount': 156000000000,
                    'term': 'rubles'
                },
                'count': 1,
                'label': '156 billion rubles',
                'mentions': [
                    {
                        'extractedText': '156 billion rubles',
                        'extractionConfidence': 0.97,
                        'position': [
                            0,
                            18
                        ]
                    }
                ],
                'type': 'MONEY'
            }
        ],
        'requestId': 'a0c0d3c6-5b39-452c-976e-5dd8f91928e3',
        'text': '156 billion rubles'
    };

    const EXAMPLE_RESPONSE_LANGUAGE = {
        'entities': [
           {
              'count': 1,
              'disambiguated': {
                 'id': '216531992576',
                 'location': {
                    'admin1Fips': 'IN09',
                    'admin1Genc': 'IN-GJ',
                    'admin1Label': 'Gujarat',
                    'countryFips': 'IN',
                    'countryGenc2': 'IN',
                    'countryGenc3': 'IND',
                    'countryGencCode': '356',
                    'countryLabel': 'India',
                    'dsgFeatureClass': 'S',
                    'dsgFeatureCode': 'MNMT',
                    'latitude': 22.994,
                    'longitude': 72.505
                 }
              },
              'label': 'Sarkhej Roza',
              'mentions': [
                 {
                    'disambiguationConfidence': 1,
                    'extractedText': 'Sarkhej Roza',
                    'extractionConfidence': 0.7958,
                    'position': [
                       0,
                       12
                    ]
                 }
              ],
              'type': 'GEO'
           },
           {
              'count': 1,
              'disambiguated': {
                 'id': '107322736640',
                 'location': {
                    'countryFips': 'GV',
                    'countryGenc2': 'GN',
                    'countryGenc3': 'GIN',
                    'countryGencCode': '324',
                    'countryLabel': 'Guinea',
                    'dsgFeatureClass': 'P',
                    'dsgFeatureCode': 'PPL',
                    'latitude': 11.2,
                    'longitude': -14.1667
                 }
              },
              'label': 'Hidaya',
              'mentions': [
                 {
                    'disambiguationConfidence': 0.5254,
                    'extractedText': 'Hidaya',
                    'extractionConfidence': 0.2388,
                    'position': [
                       96,
                       102
                    ]
                 }
              ],
              'type': 'GEO'
           },
           {
              'count': 1,
              'label': 'Persian',
              'mentions': [
                 {
                    'extractedText': 'Persian',
                    'extractionConfidence': 0.9899,
                    'position': [
                       129,
                       136
                    ]
                 }
              ],
              'type': 'LANGUAGE'
           },
           {
              'count': 1,
              'label': 'Urdu',
              'mentions': [
                 {
                    'extractedText': 'Urdu',
                    'extractionConfidence': 0.9899,
                    'position': [
                       141,
                       145
                    ]
                 }
              ],
              'type': 'LANGUAGE'
           },
           {
              'count': 1,
              'label': 'Naskh script',
              'mentions': [
                 {
                    'extractedText': 'Naskh script',
                    'extractionConfidence': 0.9899,
                    'position': [
                       245,
                       257
                    ]
                 }
              ],
              'type': 'LANGUAGE'
           }
        ],
        'requestId': 'requestUserName=asiens@finchcomputing.com;97af71cb-0bf4-4f1e-be86-594dfe4854ec',
        'text': 'Sarkhej Roza houses incomplete yet beautifully handwritten copies of the Quran, a manuscript of Hidaya, and a printed Quran with Persian and Urdu translations. Additionally, an old handwritten copy of the Quran, completed in 1649 in the elegant Naskh script, remains one of the site\'s treasured possessions.'
     }

    const EXAMPLE_RESPONSE_NATIONALITY = {
        'entities': [
            {
                'attributes': {
                    'firstName': 'EDWARD',
                    'gender': 'M',
                    'lastName': 'SNOWDEN'
                },
                'count': 2,
                'disambiguated': {
                    'id': '497583325185'
                },
                'label': 'Edward Snowden',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.6910408090536575,
                        'extractedText': 'Edward Snowden',
                        'extractionConfidence': 0.999736079981,
                        'position': [
                            0,
                            14
                        ]
                    },
                    {
                        'disambiguationConfidence': 0.687199120116438,
                        'extractedText': 'Snowden',
                        'extractionConfidence': 0.996515238778,
                        'position': [
                            380,
                            387
                        ]
                    }
                ],
                'type': 'PERSON'
            },
            {
                'count': 2,
                'label': 'Russian',
                'mentions': [
                    {
                        'extractedText': 'Russian',
                        'extractionConfidence': 1,
                        'position': [
                            40,
                            47
                        ]
                    },
                    {
                        'extractedText': 'Russian',
                        'extractionConfidence': 1,
                        'position': [
                            305,
                            312
                        ]
                    }
                ],
                'type': 'NATIONALITY'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '217972736',
                    'location': {
                        'admin1Fips': 'RS48',
                        'admin1Genc': 'RU-MOW',
                        'admin1Label': 'Moscow City',
                        'countryFips': 'RS',
                        'countryGenc2': 'RU',
                        'countryGenc3': 'RUS',
                        'countryGencCode': '643',
                        'countryLabel': 'Russia',
                        'dsgFeatureClass': 'P',
                        'dsgFeatureCode': 'PPLC',
                        'latitude': 55.7522,
                        'longitude': 37.6156,
                        'population': 12165704
                    }
                },
                'label': 'Moscow',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.965434,
                        'extractedText': 'Moscow',
                        'extractionConfidence': 0.999067,
                        'position': [
                            76,
                            82
                        ]
                    }
                ],
                'type': 'GEO'
            },
            {
                'count': 2,
                'label': 'Ecuadorean',
                'mentions': [
                    {
                        'extractedText': 'Ecuadorean',
                        'extractionConfidence': 1,
                        'position': [
                            130,
                            140
                        ]
                    },
                    {
                        'extractedText': 'Ecuadorean',
                        'extractionConfidence': 1,
                        'position': [
                            526,
                            536
                        ]
                    }
                ],
                'type': 'NATIONALITY'
            },
            {
                'attributes': {
                    'firstName': 'RAFAEL',
                    'gender': 'M',
                    'lastName': 'CORREA'
                },
                'count': 2,
                'disambiguated': {
                    'id': '18347065345'
                },
                'label': 'Rafael Correa',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.6155813098672143,
                        'extractedText': 'Rafael Correa',
                        'extractionConfidence': 0.999838344031,
                        'position': [
                            151,
                            164
                        ]
                    },
                    {
                        'disambiguationConfidence': 0.617140371951086,
                        'extractedText': 'Correa',
                        'extractionConfidence': 0.973720837032,
                        'position': [
                            451,
                            457
                        ]
                    }
                ],
                'type': 'PERSON'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '13125231378434',
                    'permIds': [
                        '4296851292'
                    ]
                },
                'label': 'National Security Agency',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.5815952581716666,
                        'extractedText': 'National Security Agency',
                        'extractionConfidence': 0.332637386469,
                        'position': [
                            249,
                            273
                        ]
                    }
                ],
                'type': 'ORGANIZATION/GOVERNMENT'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '832094928896',
                    'location': {
                        'countryFips': 'EC',
                        'countryGenc2': 'EC',
                        'countryGenc3': 'ECU',
                        'countryGencCode': '218',
                        'countryLabel': 'Ecuador',
                        'dsgFeatureClass': 'A',
                        'dsgFeatureCode': 'PCLI',
                        'latitude': -1.25,
                        'longitude': -78.25,
                        'population': 16144000
                    }
                },
                'label': 'Ecuador',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.999928,
                        'extractedText': 'Ecuador',
                        'extractionConfidence': 0.997212,
                        'position': [
                            296,
                            303
                        ]
                    }
                ],
                'type': 'GEO'
            },
            {
                'attributes': {
                    'firstName': 'VLADIMIR',
                    'gender': 'M',
                    'lastName': 'PUTIN'
                },
                'count': 1,
                'disambiguated': {
                    'id': '40820146177'
                },
                'label': 'Vladimir Putin',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.7932977306606841,
                        'extractedText': 'Vladimir Putin',
                        'extractionConfidence': 0.99997380002,
                        'position': [
                            323,
                            337
                        ]
                    }
                ],
                'type': 'PERSON'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '832233668608',
                    'location': {
                        'countryFips': 'RS',
                        'countryGenc2': 'RU',
                        'countryGenc3': 'RUS',
                        'countryGencCode': '643',
                        'countryLabel': 'Russia',
                        'dsgFeatureClass': 'A',
                        'dsgFeatureCode': 'PCLI',
                        'latitude': 60,
                        'longitude': 100,
                        'population': 143457000
                    }
                },
                'label': 'Russia',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.999396,
                        'extractedText': 'Russia',
                        'extractionConfidence': 0.99358,
                        'position': [
                            399,
                            405
                        ]
                    }
                ],
                'type': 'GEO'
            },
            {
                'count': 1,
                'label': 'Cuban',
                'mentions': [
                    {
                        'extractedText': 'Cuban',
                        'extractionConfidence': 1,
                        'position': [
                            417,
                            422
                        ]
                    }
                ],
                'type': 'NATIONALITY'
            },
            {
                'attributes': {
                    'firstName': 'FIDEL',
                    'gender': 'M',
                    'lastName': 'CASTRO'
                },
                'count': 1,
                'disambiguated': {
                    'id': '40835284993'
                },
                'label': 'Fidel Castro',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.630940118455792,
                        'extractedText': 'Fidel Castro',
                        'extractionConfidence': 0.999971676133,
                        'position': [
                            430,
                            442
                        ]
                    }
                ],
                'type': 'PERSON'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '1454894350338',
                    'permIds': [
                        '4298499928'
                    ]
                },
                'label': 'Associated Press',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.5897060888997614,
                        'extractedText': 'AP',
                        'extractionConfidence': 1,
                        'position': [
                            588,
                            590
                        ]
                    }
                ],
                'type': 'ORGANIZATION/NEWS'
            }
        ],
        'requestId': 'e7fc8ce0-32b4-43d8-8f16-f89ed70a7ec0',
        'text': 'Edward Snowden is under the care of the Russian authorities and can\'t leave Moscow\'s international airport without their consent, Ecuadorean President Rafael Correa has said in an interview telegraphing the slim and diminishing possibility that the National Security Agency leaker will end up in Ecuador. Russian President Vladimir Putin has distanced himself from the case since Snowden arrived in Russia last week. Cuban leader Fidel Castro praised Correa\'s rejection of US trade pressure, expressing his sympathies for the Ecuadorean leader in a Sunday editorial in the state press. - AP.'
    };

    const EXAMPLE_RESPONSE_ORG1 = {
        'entities': [
            {
                'count': 1,
                'label': 'Alabama Entrepreneurial Research Network',
                'mentions': [
                    {
                        'extractedText': 'Alabama Entrepreneurial Research Network',
                        'extractionConfidence': 0.40000000596,
                        'position': [
                            5,
                            45
                        ]
                    }
                ],
                'type': 'ORGANIZATION/EDUCATIONAL'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '5635375104',
                    'location': {
                        'admin1Fips': 'US01',
                        'admin1Genc': 'US-AL',
                        'admin1Label': 'Alabama',
                        'countryFips': 'US',
                        'countryGenc2': 'US',
                        'countryGenc3': 'USA',
                        'countryGencCode': '840',
                        'countryLabel': 'United States',
                        'dsgFeatureClass': 'S',
                        'dsgFeatureCode': 'SCHC',
                        'latitude': 33.2144,
                        'longitude': -87.5458
                    }
                },
                'label': 'University of Alabama',
                'mentions': [
                    {
                        'disambiguationConfidence': 1,
                        'extractedText': 'the University of Alabama',
                        'extractionConfidence': 0.31945,
                        'position': [
                            49,
                            74
                        ]
                    }
                ],
                'type': 'GEO'
            },
            {
                'attributes': {
                    'amount': '50,000',
                    'currencyCode': [
                        'USD',
                        'ARS',
                        'AUD',
                        'BBD',
                        'BMD',
                        'BND',
                        'BSD',
                        'BZD',
                        'CAD',
                        'CLP',
                        'COP',
                        'CUC',
                        'CUP',
                        'DOP',
                        'FJD',
                        'GYD',
                        'HKD',
                        'JMD',
                        'KYD',
                        'LRD',
                        'MXN',
                        'NAD',
                        'NZD',
                        'SBD',
                        'SGD',
                        'SRD',
                        'TTD',
                        'TWD',
                        'XCD',
                        'ZWL'
                    ],
                    'normalizedAmount': 50000,
                    'symbol': '$'
                },
                'count': 1,
                'label': '$50,000.00',
                'mentions': [
                    {
                        'extractedText': '$50,000',
                        'extractionConfidence': 0.95,
                        'position': [
                            90,
                            97
                        ]
                    }
                ],
                'type': 'MONEY'
            },
            {
                'count': 1,
                'label': 'U.S. Department of Agriculture&apos;s Delta Regional Authority',
                'mentions': [
                    {
                        'extractedText': 'U.S. Department of Agriculture&apos;s Delta Regional Authority',
                        'extractionConfidence': 0.166614318054,
                        'position': [
                            113,
                            175
                        ]
                    }
                ],
                'type': 'ORGANIZATION/GOVERNMENT'
            }
        ],
        'requestId': '64cafa66-80c0-4b51-980a-e38f93625704',
        'text': '.The Alabama Entrepreneurial Research Network at the University of Alabama has received a $50,000 grant from the U.S. Department of Agriculture&apos;s Delta Regional Authority...'
    };

    const EXAMPLE_RESPONSE_ORG2 = {
        'entities': [
            {
                'count': 1,
                'disambiguated': {
                    'id': '4641918156802',
                    'permIds': [
                        '4296702190'
                    ]
                },
                'label': 'Purdue Pharma',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.508672936670874,
                        'extractedText': 'Purdue Pharma',
                        'extractionConfidence': 0.996641784006,
                        'position': [
                            34,
                            47
                        ]
                    }
                ],
                'type': 'ORGANIZATION/COMPANY'
            },
            {
                'attributes': {
                    'longForm': 'Allergan',
                    'shortForm': 'AGN'
                },
                'count': 1,
                'disambiguated': {
                    'id': '1317767348226',
                    'permIds': [
                        '5040050523'
                    ]
                },
                'label': 'Allergan, Plc',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.7194407395441551,
                        'extractedText': 'Allergan (AGN)',
                        'extractionConfidence': 0.989606318526,
                        'position': [
                            50,
                            64
                        ]
                    }
                ],
                'type': 'ORGANIZATION/COMPANY'
            },
            {
                'attributes': {
                    'longForm': 'Johnson & Johnson',
                    'shortForm': 'JNJ'
                },
                'count': 1,
                'disambiguated': {
                    'id': '13116065906690',
                    'permIds': [
                        '4295904341'
                    ]
                },
                'label': 'Johnson & Johnson',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.6995146304918589,
                        'extractedText': 'Johnson & Johnson (JNJ)',
                        'extractionConfidence': 1,
                        'position': [
                            69,
                            92
                        ]
                    }
                ],
                'type': 'ORGANIZATION/COMPANY'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '1840513024',
                    'location': {
                        'admin1Fips': 'US53',
                        'admin1Genc': 'US-WA',
                        'admin1Label': 'Washington',
                        'countryFips': 'US',
                        'countryGenc2': 'US',
                        'countryGenc3': 'USA',
                        'countryGencCode': '840',
                        'countryLabel': 'United States',
                        'dsgFeatureClass': 'P',
                        'dsgFeatureCode': 'PPL',
                        'latitude': 47.6062,
                        'longitude': -122.332,
                        'population': 563374
                    }
                },
                'label': 'Seattle',
                'mentions': [
                    {
                        'disambiguationConfidence': 1,
                        'extractedText': 'city of Seattle, WA',
                        'extractionConfidence': 0.95215,
                        'position': [
                            116,
                            135
                        ]
                    }
                ],
                'type': 'GEO'
            }
        ],
        'requestId': '7590412b-e7f2-4e29-b37f-0980e463a14b',
        'text': 'A handful of companies, including Purdue Pharma,  Allergan (AGN) and Johnson & Johnson (JNJ), have been sued by the city of Seattle, WA related to OxyContin.'
    };

    const EXAMPLE_RESPONSE_ORG3 = {
        'entities': [
            {
                'attributes': {
                    'stockExchange': 'NYSE',
                    'stockSymbol': 'EGY'
                },
                'count': 2,
                'disambiguated': {
                    'id': '13132021039106'
                },
                'label': 'Vaalco Energy',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.6428698616353503,
                        'extractedText': 'VAALCO Energy, Inc.',
                        'extractionConfidence': 0.999952810646,
                        'position': [
                            0,
                            19
                        ]
                    },
                    {
                        'disambiguationConfidence': 0.6108635448756901,
                        'extractedText': 'NYSE: EGY',
                        'extractionConfidence': 1,
                        'position': [
                            21,
                            30
                        ]
                    }
                ],
                'type': 'ORGANIZATION/COMPANY'
            },
            {
                'attributes': {
                    'dayOfMonth': 30,
                    'monthOfYear': 11,
                    'year': 2016
                },
                'count': 1,
                'label': '2016-11-30',
                'mentions': [
                    {
                        'extractedText': 'November 30, 2016',
                        'extractionConfidence': 0.975,
                        'position': [
                            79,
                            96
                        ]
                    }
                ],
                'type': 'DATETIME'
            },
            {
                'count': 4,
                'disambiguated': {
                    'id': '1454891925506',
                    'permIds': [
                        '8589934165'
                    ]
                },
                'label': 'New York Stock Exchange',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.8097031383544315,
                        'extractedText': 'New York Stock Exchange',
                        'extractionConfidence': 0.498628188903,
                        'position': [
                            107,
                            130
                        ]
                    },
                    {
                        'disambiguationConfidence': 0.8097031383544315,
                        'extractedText': 'NYSE',
                        'extractionConfidence': 0.997813963051,
                        'position': [
                            133,
                            137
                        ]
                    },
                    {
                        'disambiguationConfidence': 0.7787690404839,
                        'extractedText': 'NYSE',
                        'extractionConfidence': 0.997813963051,
                        'position': [
                            202,
                            206
                        ]
                    },
                    {
                        'disambiguationConfidence': 0.7522232687934458,
                        'extractedText': 'NYSE',
                        'extractionConfidence': 0.997813963051,
                        'position': [
                            292,
                            296
                        ]
                    }
                ],
                'type': 'ORGANIZATION/COMPANY'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '4608919470082'
                },
                'label': 'VAALCO Energy Inc',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.5728906555585461,
                        'extractedText': 'VAALCO',
                        'extractionConfidence': 0.966799182999,
                        'position': [
                            237,
                            243
                        ]
                    }
                ],
                'type': 'ORGANIZATION'
            },
            {
                'attributes': {
                    'amount': '50',
                    'amountModifier': 'million',
                    'currencyCode': [
                        'USD',
                        'ARS',
                        'AUD',
                        'BBD',
                        'BMD',
                        'BND',
                        'BSD',
                        'BZD',
                        'CAD',
                        'CLP',
                        'COP',
                        'CUC',
                        'CUP',
                        'DOP',
                        'FJD',
                        'GYD',
                        'HKD',
                        'JMD',
                        'KYD',
                        'LRD',
                        'MXN',
                        'NAD',
                        'NZD',
                        'SBD',
                        'SGD',
                        'SRD',
                        'TTD',
                        'TWD',
                        'XCD',
                        'ZWL'
                    ],
                    'normalizedAmount': 50000000,
                    'symbol': '$'
                },
                'count': 2,
                'label': '$50,000,000.00',
                'mentions': [
                    {
                        'extractedText': '$50 million',
                        'extractionConfidence': 0.97,
                        'position': [
                            360,
                            371
                        ]
                    },
                    {
                        'extractedText': '$50 million',
                        'extractionConfidence': 0.97,
                        'position': [
                            479,
                            490
                        ]
                    }
                ],
                'type': 'MONEY'
            }
        ],
        'requestId': 'a51c0db6-0ad0-44cc-b924-79dd28ea6163',
        'text': 'VAALCO Energy, Inc. (NYSE: EGY) announced that it had received notification on November 30, 2016, from the New York Stock Exchange (\'NYSE\') that the Company\'s market capitalization had fallen below the NYSE\'s continued listing standard. VAALCO is considered below criteria established by the NYSE because the Company\'s average market capitalization fell below $50 million over a trailing consecutive 30 trading-day period and its last reported stockholders\' equity was less than $50 million.'
    };

    const EXAMPLE_RESPONSE_PERSON1 = {
        'entities': [
            {
                'attributes': {
                    'firstName': 'RICHARD',
                    'gender': 'M',
                    'lastName': 'STEVENSON'
                },
                'count': 1,
                'label': 'Richard Stevenson',
                'mentions': [
                    {
                        'extractedText': 'Richard Stevenson',
                        'extractionConfidence': 0.999943360107,
                        'position': [
                            12,
                            29
                        ]
                    }
                ],
                'type': 'PERSON'
            },
            {
                'attributes': {
                    'firstName': 'JAY',
                    'gender': 'M',
                    'lastName': 'SMITH',
                    'middleName': 'X'
                },
                'count': 1,
                'label': 'Jay X Smith',
                'mentions': [
                    {
                        'extractedText': 'Jay X Smith',
                        'extractionConfidence': 0.999699630306,
                        'position': [
                            44,
                            55
                        ]
                    }
                ],
                'type': 'PERSON'
            }
        ],
        'requestId': 'f812c9df-4535-4de4-bed6-c707b7a97a02',
        'text': '...show Dr. Richard Stevenson presented Mr. Jay X Smith with a diagnosis..'
    };

    const EXAMPLE_RESPONSE_PERSON2 = {
        'entities': [
            {
                'attributes': {
                    'longForm': 'Centre for Drug Research and Development',
                    'shortForm': 'CDRD'
                },
                'count': 1,
                'disambiguated': {
                    'id': '1315969302530',
                    'permIds': [
                        '5035526400'
                    ]
                },
                'label': 'Centre for Drug Research and Development',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.44229819638813983,
                        'extractedText': 'Centre for Drug Research and Development (CDRD)',
                        'extractionConfidence': 1,
                        'position': [
                            17,
                            64
                        ]
                    }
                ],
                'type': 'ORGANIZATION/COMPANY'
            },
            {
                'attributes': {
                    'firstName': 'BARRY',
                    'gender': 'M',
                    'lastName': 'GEE',
                    'suffixDescription': 'DIRECTOR'
                },
                'count': 1,
                'label': 'Barry Gee',
                'mentions': [
                    {
                        'extractedText': 'Barry Gee Director',
                        'extractionConfidence': 0.865222554724,
                        'position': [
                            65,
                            83
                        ]
                    }
                ],
                'type': 'PERSON'
            }
        ],
        'requestId': 'acc6d7f0-2b70-4a57-a0f4-6d550982c781',
        'text': '...Contacts: The Centre for Drug Research and Development (CDRD) Barry Gee Director,'
    };

    const EXAMPLE_RESPONSE_PERSON3 = {
        'entities': [
            {
                'attributes': {
                    'firstName': 'EDWARD',
                    'gender': 'M',
                    'lastName': 'SNOWDEN'
                },
                'count': 1,
                'disambiguated': {
                    'id': '497583325185'
                },
                'label': 'Edward Snowden',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.6646038811324264,
                        'extractedText': 'Edward Snowden',
                        'extractionConfidence': 0.999885687946,
                        'position': [
                            0,
                            14
                        ]
                    }
                ],
                'type': 'PERSON'
            },
            {
                'count': 1,
                'label': 'Russian',
                'mentions': [
                    {
                        'extractedText': 'Russian',
                        'extractionConfidence': 1,
                        'position': [
                            41,
                            48
                        ]
                    }
                ],
                'type': 'NATIONALITY'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '217972736',
                    'location': {
                        'admin1Fips': 'RS48',
                        'admin1Genc': 'RU-MOW',
                        'admin1Label': 'Moscow City',
                        'countryFips': 'RS',
                        'countryGenc2': 'RU',
                        'countryGenc3': 'RUS',
                        'countryGencCode': '643',
                        'countryLabel': 'Russia',
                        'dsgFeatureClass': 'P',
                        'dsgFeatureCode': 'PPLC',
                        'latitude': 55.7522,
                        'longitude': 37.6156,
                        'population': 12165704
                    }
                },
                'label': 'Moscow',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.937429,
                        'extractedText': 'Moscow',
                        'extractionConfidence': 0.998323,
                        'position': [
                            83,
                            89
                        ]
                    }
                ],
                'type': 'GEO'
            }
        ],
        'requestId': '9d929a91-8d87-43e3-815b-0300c8b53f76',
        'text': 'Edward Snowden is \'under the care of the Russian authorities\' and can&apos;t leave Moscow&apos;s international airport without their consent...'
    };

    const EXAMPLE_RESPONSE_PHONE1 = {
        'entities': [
            {
                'attributes': {
                    'areaCode': '800',
                    'areaCodeType': 'Easily Recognizable Code',
                    'exchangeCode': '659',
                    'stationCode': '0059'
                },
                'count': 1,
                'label': '800-659-0059',
                'mentions': [
                    {
                        'extractedText': '800/659-0059',
                        'extractionConfidence': 0.9702000000000001,
                        'position': [
                            14,
                            26
                        ]
                    }
                ],
                'type': 'PHONE'
            },
            {
                'attributes': {
                    'firstName': 'KATHLEEN',
                    'gender': 'F'
                },
                'count': 1,
                'label': 'Kathleen',
                'mentions': [
                    {
                        'extractedText': 'Kathleen',
                        'extractionConfidence': 0.603925756346,
                        'position': [
                            27,
                            35
                        ]
                    }
                ],
                'type': 'PERSON'
            }
        ],
        'requestId': 'f94ff2d9-1151-4d52-93cf-8ab0cdc57971',
        'text': '...Toll Free: 800/659-0059 Kathleen A. Sauvé - Media Relations...'
    };

    const EXAMPLE_RESPONSE_PHONE2 = {
        'entities': [
            {
                'attributes': {
                    'firstName': 'GARY',
                    'gender': 'M',
                    'lastName': 'LAURENCE'
                },
                'count': 1,
                'label': 'Gary Laurence',
                'mentions': [
                    {
                        'extractedText': 'Gary Laurence',
                        'extractionConfidence': 0.999882080143,
                        'position': [
                            11,
                            24
                        ]
                    }
                ],
                'type': 'PERSON'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '1322587784174'
                },
                'label': 'Douglas XFD',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.4889779558988978,
                        'extractedText': 'XFD',
                        'extractionConfidence': 0.494591261026,
                        'position': [
                            26,
                            29
                        ]
                    }
                ],
                'type': 'THING/PRODUCT'
            },
            {
                'attributes': {
                    'exchangeCode': '2',
                    'exchangeCodeType': 'Shorthand Exchange Code',
                    'stationCode': '9670'
                },
                'count': 1,
                'label': '2-9670',
                'mentions': [
                    {
                        'extractedText': '2-9670',
                        'extractionConfidence': 0.703836,
                        'position': [
                            39,
                            45
                        ]
                    }
                ],
                'type': 'PHONE'
            }
        ],
        'requestId': '2c97206d-247a-45ff-bd86-1378a26d10c4',
        'text': '...contact Gary Laurence (XFD) at ext. 2-9670...'
    };

    const EXAMPLE_RESPONSE_POSITION1 = {
        'entities': [
            {
                'label': 'President and Chief Executive Officer',
                'type': 'POSITION',
                'count': 2,
                'mentions': [
                    {
                        'position': [
                            34,
                            49
                        ],
                        'extractedText': 'President & CEO',
                        'extractionConfidence': 0.9789
                    },
                    {
                        'position': [
                            302,
                            339
                        ],
                        'extractedText': 'President and Chief Executive Officer',
                        'extractionConfidence': 0.9489
                    }
                ]
            },
            {
                'label': 'Chairman of the Board of Directors',
                'type': 'POSITION',
                'count': 1,
                'mentions': [
                    {
                        'position': [
                            93,
                            127
                        ],
                        'extractedText': 'Chairman of the Board of Directors',
                        'extractionConfidence': 0.9988
                    }
                ]
            },
            {
                'label': 'Chief Operating Officer',
                'type': 'POSITION',
                'count': 1,
                'mentions': [
                    {
                        'position': [
                            262,
                            285
                        ],
                        'extractedText': 'Chief Operating Officer',
                        'extractionConfidence': 0.9988
                    }
                ]
            },
            {
                'label': 'Company Director',
                'type': 'POSITION',
                'count': 1,
                'mentions': [
                    {
                        'position': [
                            427,
                            443
                        ],
                        'extractedText': 'Company Director',
                        'extractionConfidence': 0.9988
                    }
                ]
            },
            {
                'label': 'Chairman',
                'type': 'POSITION',
                'count': 1,
                'mentions': [
                    {
                        'position': [
                            455,
                            463
                        ],
                        'extractedText': 'Chairman',
                        'extractionConfidence': 0.889
                    }
                ]
            },
            {
                'label': 'Chief Executive Officer',
                'type': 'POSITION',
                'count': 1,
                'mentions': [
                    {
                        'position': [
                            514,
                            517
                        ],
                        'extractedText': 'CEO',
                        'extractionConfidence': 0.9789
                    }
                ]
            },
            {
                'label': 'Company Founder',
                'type': 'POSITION',
                'count': 1,
                'mentions': [
                    {
                        'position': [
                            536,
                            551
                        ],
                        'extractedText': 'company founder',
                        'extractionConfidence': 0.9988
                    }
                ]
            },
            {
                'label': 'Chairman of the Executive Committee',
                'type': 'POSITION',
                'count': 1,
                'mentions': [
                    {
                        'position': [
                            637,
                            672
                        ],
                        'extractedText': 'Chairman of the Executive Committee',
                        'extractionConfidence': 0.9988
                    }
                ]
            }
        ]
    };

    const EXAMPLE_RESPONSE_THING = {
        'entities': [
            {
                'count': 1,
                'disambiguated': {
                    'id': '13122678685698',
                    'permIds': [
                        '4295905573'
                    ]
                },
                'label': 'Apple Inc.',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.7389569750666394,
                        'extractedText': 'Apple',
                        'extractionConfidence': 0.996891403725,
                        'position': [
                            45,
                            50
                        ]
                    }
                ],
                'type': 'ORGANIZATION/COMPANY'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '1323063313390'
                },
                'label': 'iPhone X',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.80281586739664,
                        'extractedText': 'iPhone X',
                        'extractionConfidence': 1,
                        'position': [
                            53,
                            61
                        ]
                    }
                ],
                'type': 'THING/PRODUCT'
            }
        ],
        'requestId': 'a6867175-e3f5-4235-9157-085412efe71a',
        'text': 'The front of both new phones look similar to Apple\'s iPhone X, with the screen engulfing nearly the entire phone.'
    };

    const EXAMPLE_RESPONSE_TWITTER = {
        'entities': [
            {
                'attributes': {
                    'gender': 'M',
                    'twitterScreenName': 'POTUS',
                    'twitterUrl': 'https://www.twitter.com/POTUS'
                },
                'count': 1,
                'disambiguated': {
                    'id': '2938437633'
                },
                'label': 'Donald Trump',
                'mentions': [
                    {
                        'disambiguationConfidence': 1,
                        'extractedText': '@POTUS',
                        'extractionConfidence': 0.95,
                        'position': [
                            35,
                            41
                        ]
                    }
                ],
                'type': 'PERSON'
            }
        ],
        'requestId': '2280280d-4779-4279-9d26-ca83eac67bf1',
        'text': 'I will not attend the meeting with @POTUS'
    };

    const EXAMPLE_RESPONSE_URI1 = {
        'entities': [
            {
                'attributes': {
                    'host': 'onbroadway.com',
                    'ipAddress': {
                        'accuracyRadius': 1000,
                        'address': '184.168.221.6',
                        'admin1Iso': 'AZ',
                        'admin1Label': 'Arizona',
                        'cityLabel': 'Scottsdale',
                        'continentLabel': 'North America',
                        'countryIso': 'US',
                        'countryLabel': 'United States',
                        'latitude': 33.6013,
                        'legitimateProxy': false,
                        'longitude': -111,
                        'metroCode': 753,
                        'postalCode': '85260',
                        'timeZone': 'America/Phoenix'
                    }
                },
                'count': 1,
                'label': 'OnBroadway.com',
                'mentions': [
                    {
                        'extractedText': 'OnBroadway.com',
                        'extractionConfidence': 0.95,
                        'position': [
                            0,
                            14
                        ]
                    }
                ],
                'type': 'URI'
            }
        ],
        'requestId': '999a7d54-9319-44d4-b80c-e6951b8fa444',
        'text': 'OnBroadway.com sells tickets for many plays, musicals, and other shows.'
    };

    const EXAMPLE_RESPONSE_URI2 = {
        'entities': [
            {
                'attributes': {
                    'host': 'www.homegridforum.org',
                    'ipAddress': {
                        'accuracyRadius': 1000,
                        'address': '173.236.252.224',
                        'admin1Iso': 'VA',
                        'admin1Label': 'Virginia',
                        'cityLabel': 'Ashburn',
                        'continentLabel': 'North America',
                        'countryIso': 'US',
                        'countryLabel': 'United States',
                        'latitude': 39.018,
                        'legitimateProxy': false,
                        'longitude': -77,
                        'metroCode': 511,
                        'postalCode': '20147',
                        'timeZone': 'America/New_York'
                    },
                    'path': '/content/pages.php',
                    'query': 'pg=certified_systems',
                    'scheme': 'http'
                },
                'count': 1,
                'label': 'http://www.homegridforum.org/content/pages.php?pg=certified_systems',
                'mentions': [
                    {
                        'extractedText': 'http://www.homegridforum.org/content/pages.php?pg=certified_systems',
                        'extractionConfidence': 0.95,
                        'position': [
                            78,
                            145
                        ]
                    }
                ],
                'type': 'URI'
            }
        ],
        'requestId': '4e099e4a-69bd-435a-b0e6-4212406e284b',
        'text': 'Full details of all certified products are available on the forum website at: http://www.homegridforum.org/content/pages.php?pg=certified_systems .'
    };

    const EXAMPLE_REQUEST_INSERT = {
        'entries': [
            {
                'matchText': 'News10',
                'entityType': 'THING/PROGRAM',
                'action': 'ADD',
                'unrelated': true,
                'removeAllOverlap': true,
                'label': 'News 10 ABC',
                'metadata': {
                    'location': 'Albany, NY',
                    'broadcaster': 'WTEN'
                }
            },
            {
                'matchText': 'Henry Ford',
                'entityType': 'PERSON',
                'action': 'ADD',
                'metadata': {
                    'firstName': 'HENRY',
                    'lastName': 'FORD'
                }
            },
            {
                'matchText': 'ABC',
                'entityType': 'ORGANIZATION/NEWS',
                'action': 'ADD',
                'unrelated': true,
                'matchCase': true,
                'metadata': {}
            },
            {
                'matchText': 'leader',
                'entityType': 'POSITION',
                'action': 'REMOVE'
            }
        ]
    }

    const EXAMPLE_REQUEST_VALIDATE = {
        'entries': [
            {
                'matchText': 'John Deere',
                'entityType': 'ORGANIZATION/COMPANY',
                'action': 'ADD',
                'removeAllOverlap': true
            },
            {
                'matchText': 'watch on Max',
                'entityType': 'STREAMING',
                'action': 'ADD',
                'entitySubString': 'hbo'
            },
            {
                'matchText': 'leader',
                'entityType': 'POSITION',
                'action': 'REMOVE',
                'ignoreSubtye': true
            },
            {
                'matchText': 'leader',
                'entityType': 'POSITION',
                'action': 'ADD'
            },
            {
                'matchText': 'The',
                'entityType': 'WORD',
                'action': 'ADD'
            },
            {
                'matchText': 'My Place',
                'entityType': 'GEO',
                'action': 'ADD'
            }
        ]
    }

    const EXAMPLE_REQUEST_DELETE = {
        'entries': [
            {
                'matchText': 'News10',
                'entityType': 'THING/PROGRAM',
                'action': 'ADD'
            },
            {
                'matchText': 'ABC',
                'entityType': 'ORGANIZATION/NEWS',
                'action': 'ADD'
            },
            {
                'matchText': 'leader',
                'entityType': 'POSITION',
                'action': 'REMOVE'
            }
        ]
    }

    const EXAMPLE_RESPONSE_V2_CONVERT_DOC = {
        'elements': [
            {
                'type': 'ListItem',
                'element_id': '2fc6edec7c5b75fd3e1049aa91e14d55',
                'text': 'Agile Test Summary Report Template',
                'metadata': {
                    'category_depth': 0,
                    'languages': [
                        'eng'
                    ],
                    'file_directory': '/tmp/tmpsxinnt3y',
                    'filetype': 'application/octet-stream'
                },
                'start': 0,
                'stop': 34
            },
            {
                'type': 'Title',
                'element_id': 'b605350bc00209520b7cd8f546322663',
                'text': 'Introduction',
                'metadata': {
                    'category_depth': 0,
                    'emphasized_text_contents': [
                        'Introduction'
                    ],
                    'emphasized_text_tags': [
                        'b'
                    ],
                    'languages': [
                        'eng'
                    ],
                    'file_directory': '/tmp/tmpsxinnt3y',
                    'filetype': 'application/octet-stream'
                },
                'start': 35,
                'stop': 47
            }
        ],
        'text': 'Agile Test Summary Report Template\nIntroduction'
    }

    const EXAMPLE_REQUEST_CORRECT_TEXT = {
        'text': 'donald trump congratulates President Uhuru Kenyatta on his re-election.',
        'languageCode': 'en',
        'textCorrections': ['case', 'punctuation']
    };

    const EXAMPLE_RESPONSE_CORRECT_TEXT = {
        'correctedText': 'Donald Trump congratulates President Uhuru Kenyatta on his re-election.'
    };

    const EXAMPLE_REQUEST_DETECT_LANGUAGE1 = {
        'text': 'On Sunday night (Oct. 7), a SpaceX Falcon 9 rocket successfully launched the SAOCOM 1A Earth-observation satellite from Vandenberg Air Force Base on California\'s Central Coast.'
    };

    const EXAMPLE_RESPONSE_DETECT_LANGUAGE1 =  {
        'languages': [
            {
                'en': 0.9999
            }
        ]
    };

    const EXAMPLE_REQUEST_DETECT_LANGUAGE2 =  {
        'text': 'On Sunday night (Oct. 7), a SpaceX Falcon 9 rocket successfully launched the SAOCOM 1A Earth-observation satellite from Vandenberg Air Force Base on California\'s Central Coast. GroenLinks grote winnaar in Utrecht GroenLinks is de grote winnaar in Utrecht. D\'estate il connubio tra tasso di umidità e temperature elevate, unito a infiltrazioni di aria fresca da nord-ovest può dare vita a rari ma intensi fenomeni temporaleschi; questa situazione si protrae fino al mese di ottobre, le cui infiltrazioni di aria via via più fresca incontrano un mare ancora molto caldo. Durante il resto dell\'anno si alternano periodi più asciutti a periodi moderatamente piovosi, con picchi massimi nei mesi di novembre, dicembre e aprile. Der Vertrag ist einer der Pariser Vorortverträge, die den Ersten Weltkrieg formal beendeten, und wurde zwischen Österreich und 27 alliierten und assoziierten Mitgliedern abgeschlossen. Zu den Signatarmächten zählten neben Österreich die USA.  Two of President Donald Trump\'s former rivals for the GOP White House nomination won Senate confirmation Thursday to join his administration. Retired neurosurgeon Ben Carson was confirmed as secretary of the Department of House and Urban  Development on a vote of 58-41.  GroenLinks grote winnaar in Utrecht GroenLinks is de grote winnaar in Utrecht. Volgens de exitpoll van Ipsos heeft een kwart van het Utrechtse electoraat op GroenLinks gestemd. Der Vertrag ist einer der Pariser Vorortverträge, die den Ersten Weltkrieg formal beendeten, und wurde zwischen Österreich und 27 alliierten und assoziierten Mitgliedern abgeschlossen. Zu den Signatarmächten zählten neben Österreich die USA.'
    };

    const EXAMPLE_RESPONSE_DETECT_LANGUAGE2 = {
        'languages': [
            {
                'it': 0.4285
            },
            {
                'en': 0.2857
            },
            {
                'de': 0.1428
            },
            {
                'nl': 0.1428
            }
        ]
    };

    const EXAMPLE_REQUEST_DETECT_LANGUAGE2_1 = {
        'text': 'У меня большая семья из шести человек: я, мама, папа, старшая сестра, бабушка и дедушка. Мы живем все вместе с собакой Бимом и кошкой Муркой в большом доме в деревне. Мой папа встает раньше всех, потому что ему рано на работу. Он работает доктором. Обычно бабушка готовит нам завтрак. Я обожаю овсяную кашу, а моя сестра Аня – блины.'    
    };

    const EXAMPLE_RESPONSE_DETECT_LANGUAGE2_1 =  {
        'languages': [
            {
                'language': 'Russian',
                'iso639_1': 'ru',
                'iso639_3': 'rus',
                'confidence': 1.00
            }
        ]
    };

    const EXAMPLE_REQUEST_DETECT_LANGUAGES = {
        'text': 'On Sunday night (Oct. 7), a SpaceX Falcon 9 rocket successfully launched the SAOCOM 1A Earth-observation satellite from Vandenberg Air Force Base on California\'s Central Coast. GroenLinks grote winnaar in Utrecht GroenLinks is de grote winnaar in Utrecht. D\'estate il connubio tra tasso di umidità e temperature elevate, unito a infiltrazioni di aria fresca da nord-ovest può dare vita a rari ma intensi fenomeni temporaleschi; questa situazione si protrae fino al mese di ottobre, le cui infiltrazioni di aria via via più fresca incontrano un mare ancora molto caldo. Durante il resto dell\'anno si alternano periodi più asciutti a periodi moderatamente piovosi, con picchi massimi nei mesi di novembre, dicembre e aprile. Der Vertrag ist einer der Pariser Vorortverträge, die den Ersten Weltkrieg formal beendeten, und wurde zwischen Österreich und 27 alliierten und assoziierten Mitgliedern abgeschlossen. Zu den Signatarmächten zählten neben Österreich die USA.  Two of President Donald Trump\'s former rivals for the GOP White House nomination won Senate confirmation Thursday to join his administration. Retired neurosurgeon Ben Carson was confirmed as secretary of the Department of House and Urban  Development on a vote of 58-41.  GroenLinks grote winnaar in Utrecht GroenLinks is de grote winnaar in Utrecht. Volgens de exitpoll van Ipsos heeft een kwart van het Utrechtse electoraat op GroenLinks gestemd. Der Vertrag ist einer der Pariser Vorortverträge, die den Ersten Weltkrieg formal beendeten, und wurde zwischen Österreich und 27 alliierten und assoziierten Mitgliedern abgeschlossen. Zu den Signatarmächten zählten neben Österreich die USA.'
    };

    const EXAMPLE_RESPONSE_DETECT_LANGUAGES = {
        'segments': [
           {
              'language': 'English',
              'iso639_1': 'en',
              'iso639_3': 'eng',
              'position': {
                 'start': 0,
                 'length': 176
              },
              'text': 'On Sunday night (Oct. 7), a SpaceX Falcon 9 rocket successfully launched the SAOCOM 1A Earth-observation satellite from Vandenberg Air Force Base on California\'s Central Coast.'
           },
           {
              'language': 'Dutch',
              'iso639_1': 'nl',
              'iso639_3': 'nld',
              'position': {
                 'start': 176,
                 'length': 79
              },
              'text': ' GroenLinks grote winnaar in Utrecht GroenLinks is de grote winnaar in Utrecht.'
           },
           {
              'language': 'Italian',
              'iso639_1': 'it',
              'iso639_3': 'ita',
              'position': {
                 'start': 255,
                 'length': 467
              },
              'text': ' D\'estate il connubio tra tasso di umidità e temperature elevate, unito a infiltrazioni di aria fresca da nord-ovest può dare vita a rari ma intensi fenomeni temporaleschi; questa situazione si protrae fino al mese di ottobre, le cui infiltrazioni di aria via via più fresca incontrano un mare ancora molto caldo. Durante il resto dell\'anno si alternano periodi più asciutti a periodi moderatamente piovosi, con picchi massimi nei mesi di novembre, dicembre e aprile.'
           },
           {
              'language': 'German',
              'iso639_1': 'de',
              'iso639_3': 'deu',
              'position': {
                 'start': 722,
                 'length': 242
              },
              'text': ' Der Vertrag ist einer der Pariser Vorortverträge, die den Ersten Weltkrieg formal beendeten, und wurde zwischen Österreich und 27 alliierten und assoziierten Mitgliedern abgeschlossen. Zu den Signatarmächten zählten neben Österreich die USA.'
           },
           {
              'language': 'English',
              'iso639_1': 'en',
              'iso639_3': 'eng',
              'position': {
                 'start': 964,
                 'length': 272
              },
              'text': '  Two of President Donald Trump\'s former rivals for the GOP White House nomination won Senate confirmation Thursday to join his administration. Retired neurosurgeon Ben Carson was confirmed as secretary of the Department of House and Urban  Development on a vote of 58-41.'
           },
           {
              'language': 'Dutch',
              'iso639_1': 'nl',
              'iso639_3': 'nld',
              'position': {
                 'start': 1236,
                 'length': 178
              },
              'text': '  GroenLinks grote winnaar in Utrecht GroenLinks is de grote winnaar in Utrecht. Volgens de exitpoll van Ipsos heeft een kwart van het Utrechtse electoraat op GroenLinks gestemd.'
           },
           {
              'language': 'German',
              'iso639_1': 'de',
              'iso639_3': 'deu',
              'position': {
                 'start': 1414,
                 'length': 242
              },
              'text': ' Der Vertrag ist einer der Pariser Vorortverträge, die den Ersten Weltkrieg formal beendeten, und wurde zwischen Österreich und 27 alliierten und assoziierten Mitgliedern abgeschlossen. Zu den Signatarmächten zählten neben Österreich die USA.'
           }
        ]
    };

    const EXAMPLE_REQUEST_TRANSLATE = {
        'text': '我的弟弟叫罗宾，他十五岁了。他有一头长长的棕色头发和一双蓝色的眼睛。他看起来很像我。',
        'targetLanguage': 'en'
    };

    const EXAMPLE_RESPONSE_TRANSLATE = {
        'detectedSourceLanguage': 'nl',
        'translatedText': 'My brother\'s name is Robin. He\'s 15 years old. He\'s got long, brown hair and blue eyes. He\'s a lot like me.'
    }

    const EXAMPLE_RESPONSE_V1_ENTITIES1 = {
        'attendedSchools': [
            {
                'finchId': 1454828814338,
                'label': 'Princeton University',
                'permId': 4297381328
            },
            {
                'finchId': 1318348193794,
                'label': 'Miami Palmetto High School'
            }
        ],
        'birthDate': '1964-01-13',
        'birthLocation': {
            'admin1Label': 'New Mexico',
            'countryLabel': 'United States of America',
            'latitude': 35.12,
            'longitude': -106.62,
            'name': 'Albuquerque',
            'postalCode': '87196'
        },
        'birthName': 'Jeffrey Preston Jorgensen',
        'categories': [
            'american computer businesspeople',
            'people in the space industry',
            'american technology chief executives',
            'american libertarians',
            '1964 births',
            'tau beta pi',
            'american investors',
            'american hedge fund managers',
            'american billionaires',
            'online retailer founders',
            'princeton university alumni 198089',
            'princeton university alumni 1980 1989',
            'amazoncom people',
            'businesspeople from new mexico',
            'phi beta kappa',
            'fellows of the american academy of arts and sciences',
            'the washington post publishers',
            'people from albuquerque new mexico',
            'american mass media owners',
            'living people',
            'ted speakers',
            'american chairmen of corporations',
            'american technology company founders',
            'blue origin',
            '21st century american businesspeople',
            'american people of scandinavian descent',
            'amazon com people',
            'american adoptees',
            'american internet company founders',
            'american computer scientists',
            'princeton university alumni',
            'american online retailer founders',
            'businesspeople from albuquerque new mexico',
            'life extensionists',
            'phi beta kappa members',
            '21st-century american businesspeople',
            'amazon.com people',
            'businesspeople from albuquerque, new mexico',
            'blue origin people',
            'american aerospace businesspeople',
            'american philanthropists',
            'space advocates'
        ],
        'citizenshipCountries': [
            'United States of America'
        ],
        'contextKeywords': [
            '1000000000 number',
            '1997',
            '1997 equity',
            '1 academies',
            '1 academies fund',
            '1 families',
            '1 families fund',
            '1click',
            '2011',
            '2011 bilderberg',
            '2013',
            '2013 bilderberg conference',
            '2018',
            '2018 axel',
            '2018 axel springer',
            '21stcentury american businesspeople',
            '43 things',
            'a9com',
            'abebooks',
            'academies',
            'address',
            'advisory',
            'advisory board',
            'aerospace',
            'aerospace company',
            'aerospace company blue',
            'alexa internet',
            'also',
            'amapedia',
            'amazon appstore',
            'amazon breakthrough novel award',
            'amazon china',
            'amazon cloud drive',
            'amazon cloudfront',
            'amazon dash',
            'amazon digital game store',
            'amazon dynamodb',
            'amazon echo',
            'amazon elastic block store',
            'amazon elastic compute cloud',
            'amazon fire tv',
            'amazon fishbowl',
            'amazon flexible payments service',
            'amazon glacier',
            'amazon instant video',
            'amazon kindle',
            'amazon light',
            'amazon locker',
            'amazon machine image',
            'amazon marketplace',
            'amazon mechanical turk',
            'amazon music',
            'amazon payments',
            'amazon prime',
            'amazon product advertising api',
            'amazon publishing',
            'amazon relational database service',
            'amazon s3',
            'amazon silk',
            'amazon simple email service',
            'amazon simple queue service',
            'amazon simpledb',
            'amazon standard identification number',
            'amazon studios',
            'amazon tax',
            'amazon vine',
            'amazon virtual private cloud',
            'amazon warehouse',
            'amazon web',
            'amazoncom',
            'amazoncom controversies',
            'amazonfresh',
            'amazons best books of the year',
            'american',
            'american technology',
            'analytics',
            'apollo 11',
            'apple inc',
            'arm',
            'ash carter',
            'askville',
            'atomic',
            'attended',
            'audiblecom',
            'august',
            'australia',
            'award',
            'axel',
            'axel springer',
            'axel springer award',
            'bachelor of science in engineering',
            'bankers',
            'became',
            'best',
            'bezos d',
            'bezos dzhieff',
            'bezos dzhieffri',
            'bezos dzhiefri',
            'bezos expeditions',
            'bezoss',
            'biezos dzhieff',
            'biezos dzhieffri',
            'bike',
            'bike shop',
            'bilderberg',
            'bilderberg conference',
            'billionaires',
            'billionaires index',
            'bloomberg billionaires',
            'bloomberg billionaires index',
            'blue',
            'blue origin test',
            'board',
            'boom',
            'bownsville',
            'bownsville herald',
            'box office mojo',
            'brian',
            'brian krueger',
            'brian mcbride director',
            'brian valentine',
            'business',
            'business insider',
            'business magnate',
            'business review',
            'businesspeople',
            'businessperson',
            'campaign',
            'campaign finance',
            'capital',
            'capital fund',
            'capital vehicle',
            'carbonado java',
            'care',
            'care centers',
            'carnegie',
            'cdnow',
            'centers',
            'chain',
            'chain routes',
            'channels',
            'childhood',
            'christopher north businessman',
            'clock of the long now',
            'cloud',
            'cloud infrastructure',
            'college',
            'college scholarship',
            'columbia',
            'comixology',
            'commercialization',
            'commission',
            'committee',
            'company blue',
            'company blue origin',
            'company distribution',
            'computer',
            'confederation',
            'conference',
            'council',
            'country',
            'country singer',
            'country singer george',
            'court',
            'cspan',
            'cuban people',
            'culture',
            'customer',
            'd bezos',
            'dallas',
            'dallas morning news the',
            'darpa',
            'database',
            'david ho scientist',
            'david risher',
            'day',
            'day 1',
            'day 1 academies',
            'day 1 families',
            'day care',
            'defense',
            'defense advanced research projects agency',
            'defense innovation',
            'defense innovation advisory',
            'degrees',
            'department of defense',
            'depletion',
            'diaperscom',
            'digital photography review',
            'distribution',
            'district',
            'donald e graham',
            'double helix games',
            'dynamo storage system',
            'dzhieff bezos',
            'dzhieff biezos',
            'dzhieffri bezos',
            'dzhieffri biezos',
            'dzhiefri bezos',
            'early',
            'earth',
            'ecommerce',
            'economy',
            'editorial',
            'education',
            'electrical engineering and computer science',
            'elementary',
            'elementary school',
            'email',
            'employees',
            'endlesscom',
            'energy',
            'engineering',
            'equity',
            'equity offering',
            'executive',
            'exploration',
            'f w de klerk',
            'face',
            'face recognition',
            'families',
            'finance records',
            'fire',
            'fire os',
            'fire phone',
            'first',
            'flight',
            'food',
            'food economy',
            'forbes list of billionaires',
            'forbes magazine',
            'forbes wealth',
            'forbes wealth index',
            'fortune magazine',
            'founded',
            'founders',
            'fund',
            'galactic',
            'game',
            'game simulations',
            'goodreads',
            'graubnden',
            'group',
            'group new',
            'group new food',
            'gurupa',
            'harvard',
            'harvard business',
            'headquarters',
            'headquarters tour',
            'health',
            'healthcare',
            'hedge',
            'hedge fund',
            'herald',
            'high',
            'high school',
            'holdings',
            'home',
            'honolulu staradvertiser',
            'honorary doctorate',
            'human spaceflight',
            'immigrants',
            'imperialistic',
            'imperialistic business',
            'inc',
            'including',
            'income',
            'income tax',
            'increase',
            'index',
            'infant bed',
            'infrastructure',
            'infrastructure services',
            'innovation',
            'innovation advisory',
            'innovation advisory board',
            'integrated authority file',
            'interests',
            'international',
            'international standard book number',
            'international trade',
            'international trade union',
            'internet',
            'internet movie database',
            'investments',
            'invitation',
            'jeff besos',
            'jeff jorgensen',
            'jeff preston bezos',
            'jeffery bezos',
            'jeffrey bezos',
            'jeffrey khalil jorgensen',
            'jeffrey p bezos',
            'jeffrey pbezos',
            'jeffrey preston jeff bezos',
            'jersey',
            'jobs',
            'july',
            'jungleecom',
            'kindle',
            'kindle fire',
            'kindle fire hd',
            'kindle fire hdx',
            'kingdom',
            'known',
            'lab126',
            'labor',
            'lasalle county',
            'leadership',
            'lech wa sa',
            'lexcycle',
            'library of congress control number',
            'librarything',
            'life',
            'liquavista',
            'list',
            'listing',
            'livingsocial',
            'logistik hall of fame',
            'lovefilm',
            'mackenzie besos',
            'magazine',
            'market',
            'meetings',
            'mellon',
            'mexico',
            'miami palmetto',
            'miami palmetto high',
            'micromanager',
            'miguel mike bezos',
            'mike bezos',
            'million',
            'minneapolis startribune',
            'mobipocket',
            'mohammed bin salman',
            'morning',
            'named',
            'narendra modi',
            'nash',
            'national',
            'national diet library',
            'national merit scholarship program',
            'nelson mandela',
            'new food',
            'new shepard space',
            'new south wales',
            'news',
            'newspace',
            'newspaper',
            'night',
            'nndb',
            'number',
            'oaks',
            'oaks elementary',
            'oaks elementary school',
            'obidos software',
            'online',
            'opportunities',
            'origin',
            'origin test',
            'origin test flight',
            'outlets',
            'outstripped',
            'owner',
            'palmetto',
            'palmetto high',
            'palmetto high school',
            'paul allen',
            'peace makers',
            'people from medina washington',
            'perfect 10 inc v amazoncom inc',
            'person',
            'personal',
            'personal computer',
            'philosophy',
            'piece',
            'planetall',
            'pope john paul ii',
            'practices',
            'prioritize',
            'private spaceflight',
            'profile',
            'program',
            'quill corp v north dakota',
            'ram shriram',
            'recognition',
            'records',
            'reflexive entertainment',
            'report',
            'resource',
            'retailer',
            'review',
            'rick dalzell',
            'rights',
            'river',
            'river oaks',
            'river oaks elementary',
            'river oaks elementary houston',
            'rocket',
            'rocketdyne f1',
            'room',
            'routes',
            'ruhollah khomeini',
            's1c',
            'said',
            'sales',
            'saturn v',
            'scale',
            'scholarship',
            'scholarship fund',
            'school',
            'science',
            'science training',
            'science training program',
            'sellaband',
            'senior',
            'service',
            'services',
            'services arm',
            'sharan burrow',
            'shawn mccoy',
            'shelfari',
            'shelters',
            'shepard space',
            'shepard space vehicle',
            'shop',
            'shop owner',
            'silver knight awards',
            'simulations',
            'singer',
            'singer george',
            'singer george strait',
            'slatecom',
            'software',
            'songza',
            'south',
            'space vehicle',
            'spaceflight',
            'spaceflight startup',
            'spent',
            'springer',
            'springer award',
            'st moritz',
            'stacy palmer',
            'startribune',
            'startup',
            'startup company',
            'state',
            'state income',
            'state income tax',
            'states',
            'statistically improbable phrases',
            'street',
            'strikes',
            'student',
            'student science',
            'student science training',
            'students for the exploration and development of space',
            'style',
            'supply',
            'supply chain',
            'supreme',
            'syst me universitaire de documentation',
            'tail',
            'tasked',
            'tax',
            'technology entrepreneur',
            'ted conference',
            'test',
            'test flight',
            'the',
            'the book depository',
            'the business council',
            'the dallas morning news',
            'the economist',
            'the new york times',
            'the seattle times',
            'tickets',
            'time person of the year',
            'times',
            'times piece',
            'tom szkutak',
            'tony hsieh',
            'tour',
            'tour invitation',
            'trade union',
            'trade union confederation',
            'training',
            'training program',
            'travel',
            'trust',
            'twitchtv',
            'undocumented',
            'union',
            'union confederation',
            'united',
            'united states atomic energy commission',
            'university',
            'us atomic energy commission',
            'us government',
            'us news world report',
            'us supreme court',
            'valladolid',
            'valladolid spain',
            'vehicle',
            'venture',
            'venture capital',
            'video',
            'video game',
            'villafrechos',
            'virgin',
            'virtual international authority file',
            'wales',
            'warehouse',
            'warehouse workers',
            'warren buffet',
            'washington referendum 74',
            'washington state',
            'washington state income',
            'wealth',
            'wealth index',
            'weather',
            'web',
            'web services',
            'web services arm',
            'werner vogels',
            'wife',
            'wired magazine',
            'wired website',
            'withoutabox',
            'woot',
            'worked',
            'workers',
            'workplace',
            'world',
            'worldcat',
            'yasser arafat',
            'year',
            'years',
            'yitzhak rabin',
            'york',
            'york times',
            'york times piece',
            'zappos'
        ],
        'description': 'Jeffrey Preston Bezos (né Jorgensen; born January 12, 1964) is an American technology entrepreneur, investor, and philanthropist. He is the founder, chairman, CEO, and president of Amazon.\nBezos was born in Albuquerque, New Mexico, and raised in Houston, Texas. He graduated from Princeton University in 1986 with degrees in electrical engineering and computer science. He worked on Wall Street in a variety of related fields from 1986 to early 1994. He founded Amazon in late 1994 on a cross-country road trip from New York City to Seattle. The company began as an online bookstore and has expanded to a variety of products and services, including video and audio streaming. It is currently the world\'s largest online sales company, as well as the world\'s largest provider of cloud infrastructure services via its Amazon Web Services arm.',
        'employers': [
            {
                'finchId': 1454825144322,
                'label': 'Amazon',
                'permId': 4295905494
            },
            {
                'label': 'Bankers Trust'
            },
            {
                'finchId': 1319592067074,
                'label': 'D. E. Shaw & Co.'
            }
        ],
        'familyNames': [
            'Bezos',
            'Jorgensen'
        ],
        'genders': [
            'male'
        ],
        'givenNames': [
            'Preston',
            'Jeffrey'
        ],
        'heldPositions': [
            'chairperson',
            'chief executive officer',
            'president'
        ],
        'id': '358999261185',
        'imageUrls': [
            'https://upload.wikimedia.org/wikipedia/commons/6/6c/Jeff_Bezos_at_Amazon_Spheres_Grand_Opening_in_Seattle_-_2018_%2839074799225%29_%28cropped%29.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/3/33/Jeff_Bezos_2016.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/6/6b/Jeff_Bezos%27_iconic_laugh.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/7/7a/Jeff_Bezos_2005.jpg'
        ],
        'label': 'Jeff Bezos',
        'languageFields': [
            {
                'description': 'Jeffrey Preston Bezos (né Jorgensen; January 12, 1964) is an American technology entrepreneur, investor, and philanthropist. He is best known as the founder, chairman, and CEO of Amazon.\nBezos was born in Albuquerque, New Mexico and raised in Houston, Texas. He graduated from Princeton University in 1986 with degrees in electrical engineering and computer science. He worked on Wall Street in a variety of related fields from 1986 to early 1994. He founded Amazon in late 1994 on a cross-country road trip from New York City to Seattle. The company began as an online bookstore and has expanded to a variety of products and services, including video and audio streaming. It is currently the world\'s largest online sales company, as well as the world\'s largest provider of cloud infrastructure services via its Amazon Web Services arm.',
                'label': 'Jeff Bezos',
                'langCode': 'en',
                'urls': [
                    'https://en.wikipedia.org/wiki/Jeff_Bezos'
                ]
            },
            {
                'description': 'Amerikaans ondernemer',
                'label': 'Jeff Bezos',
                'langCode': 'nl',
                'urls': [
                    'https://nl.wikipedia.org/wiki/Jeff_Bezos'
                ]
            },
            {
                'description': 'amerikanischer Unternehmer',
                'label': 'Jeff Bezos',
                'langCode': 'de',
                'urls': [
                    'https://de.wikipedia.org/wiki/Jeff_Bezos'
                ]
            },
            {
                'description': 'Empresario Estadounidense',
                'label': 'Jeff Bezos',
                'langCode': 'es',
                'urls': [
                    'https://es.wikipedia.org/wiki/Jeff_Bezos'
                ]
            },
            {
                'description': 'entrepreneur américain, fondateur et dirigeant d\'Amazon',
                'label': 'Jeff Bezos',
                'langCode': 'fr',
                'urls': [
                    'https://fr.wikipedia.org/wiki/Jeff_Bezos'
                ]
            },
            {
                'description': 'Empresário, fundador e CEO americano da Amazon.com, Inc.',
                'label': 'Jeff Bezos',
                'langCode': 'pt',
                'urls': [
                    'https://pt.wikipedia.org/wiki/Jeff_Bezos'
                ]
            },
            {
                'description': 'Предприниматель',
                'label': 'Безос, Джеффри',
                'langCode': 'ru',
                'urls': [
                    'https://ru.wikipedia.org/wiki/Безос,_Джефф'
                ]
            }
        ],
        'memberOf': [
            'National Academy of Engineering',
            'American Academy of Arts and Sciences',
            'Phi Beta Kappa Society'
        ],
        'numberOfChildren': 4,
        'occupations': [
            'computer scientist',
            'entrepreneur'
        ],
        'ownedOrganizations': [
            {
                'finchId': 1454825144322,
                'label': 'Amazon',
                'permId': 4295905494
            },
            {
                'finchId': 1454860337154,
                'label': 'The Washington Post'
            },
            {
                'label': 'Nash Holdings LLC'
            }
        ],
        'prominence': 0.8231,
        'residenceLocation': {
            'admin1Label': 'Miano',
            'countryLabel': 'Italy',
            'latitude': 42.61906,
            'longitude': 13.70705,
            'name': 'Miano'
        },
        'spousesNames': [
            'Mackenzie Bezos (1992)'
        ],
        'twitterNames': [
            'jeffbezos'
        ],
        'type': 'PERSON',
        'urls': [
            'https://en.wikipedia.org/wiki/Jeff_Bezos',
            'https://www.wikidata.org/wiki/Q312556',
            'https://twitter.com/jeffbezos',
            'https://www.instagram.com/jeffbezos',
            'https://g.co/kg/m/011z69',
            'https://www.quora.com/topic/Jeff-Bezos',
            'https://www.britannica.com/biography/Jeff-Bezos',
            'https://en.wikipedia.org/wiki/Jeff_Besos',
            'http://www.amazon.com',
            'http://dbpedia.org/resource/Jeff_Bezos'
        ],
        'version': '20.2.2'
    };

    const EXAMPLE_RESPONSE_V1_ENTITIES2 = {
        'categories': [
            'companies based in seattle washington',
            'internet companies of the united states',
            'american brands',
            'cloud computing providers',
            '1994 establishments in washington state',
            'arts and crafts retailers',
            'ios software',
            'companies established in 1994',
            'online music stores',
            'companies based in washington',
            'webby award winners',
            'bookstores of the united states',
            'organisation',
            'online companies',
            'book selling websites',
            'e book suppliers',
            'companies listed on nasdaq',
            'multinational companies headquartered in the united states',
            'companies in the nasdaq 100 index',
            'amazoncom',
            'review websites',
            '1994 establishments in washington',
            'universal windows platform apps',
            'software companies based in washington',
            'internet properties established in 1994',
            'company',
            'self publishing companies',
            'mobile phone manufacturers',
            'software companies based in washington state',
            'companies initially financed with venture capital',
            'commerce websites',
            'amazon com',
            'american websites',
            'android operating system software',
            'software companies based in seattle',
            'companies based in washington state',
            'online retailers of the united states',
            'online retail companies of the united states',
            '3d publishing',
            'american companies established in 1994',
            'android',
            'online marketplaces',
            'retail companies established in 1994',
            'software companies established in 1994',
            'technology companies established in 1994',
            'tvos software'
        ],
        'chairPersons': [
            'Jeff Bezos'
        ],
        'chiefExecutiveOfficers': [
            'Jeff Bezos'
        ],
        'ciks': [
            '0001018724'
        ],
        'contextKeywords': [
            '1 washington park',
            '1click',
            '2004 indian ocean earthquake and tsunami',
            '20 products',
            '21st century fox',
            '400 stores',
            '43 things',
            '4c',
            '4c media',
            '4fff n618',
            '60 minutes',
            'a2z',
            'a2z development',
            'a9com',
            'aashish gupta',
            'abebooks',
            'absolute',
            'absolute webstores',
            'academic journal publishing reform',
            'accenture',
            'access books',
            'acer inc',
            'aci gift cards',
            'activision blizzard',
            'administration',
            'adobe acrobat',
            'adobe digital editions',
            'adobe indesign',
            'adobe systems',
            'advanced micro devices',
            'affiliate program',
            'agfagevaert',
            'ahmedabad',
            'air',
            'air conditioning',
            'air drone',
            'air freight',
            'air patriots',
            'akamai technologies',
            'al',
            'alain',
            'alain moni',
            'alain monie',
            'alaska airlines',
            'alcatel mobile phones',
            'alcatellucent',
            'aldiko',
            'alex ereader',
            'alexion pharmaceuticals',
            'alibaba',
            'alibaba group',
            'altera',
            'am rica m vil',
            'amapedia',
            'amazon+india',
            'amazon affiliate program',
            'amazon app',
            'amazon appstore',
            'amazon breakthrough novel award',
            'amazon china',
            'amazon cloud drive',
            'amazon cloudfront',
            'amazon dash',
            'amazon dash button',
            'amazon deutschland',
            'amazon digital game store',
            'amazon digital services llc',
            'amazon dynamodb',
            'amazon echo',
            'amazon elastic block store',
            'amazon elastic compute cloud',
            'amazon elastic compute cloud amazon',
            'amazon fire tv',
            'amazon fishbowl',
            'amazon flexible payments service',
            'amazon fulfillment centers',
            'amazon germany',
            'amazon glacier',
            'amazon home services',
            'amazon hq1',
            'amazon instant video',
            'amazon instant video german',
            'amazon instant video uk',
            'amazon key',
            'amazon kindle',
            'amazon lab126',
            'amazon leases space',
            'amazon light',
            'amazon locker',
            'amazon machine image',
            'amazon marketplace',
            'amazon mechanical turk',
            'amazon music',
            'amazon payments',
            'amazon prime pantry',
            'amazon prime pantry amazonfresh',
            'amazon prime subscribers',
            'amazon product advertising api',
            'amazon product link',
            'amazon publishing',
            'amazon records data',
            'amazon relational database service',
            'amazon replenishment service',
            'amazon river',
            'amazon robotics',
            'amazon s3',
            'amazon silk',
            'amazon simple email service',
            'amazon simple queue service',
            'amazon simple queue service amazon',
            'amazon simple storage service amazon',
            'amazon simpledb',
            'amazon smile',
            'amazon standard identification number',
            'amazon studios',
            'amazon studios amazon studios',
            'amazon tax',
            'amazon unbox',
            'amazon video',
            'amazon vine',
            'amazon virtual private cloud',
            'amazoncom controversies',
            'amazons best books of the year',
            'america',
            'american',
            'american airlines group',
            'american red cross',
            'amgen',
            'amie',
            'amie street',
            'amsterdam',
            'analog devices',
            'andhra',
            'andhra pradesh',
            'andrew',
            'andrew crawford',
            'android operating system',
            'android software',
            'andy',
            'andy warhol',
            'annacis island',
            'annapurna',
            'annapurna labs',
            'aol',
            'aozora bunko',
            'api',
            'apoorva mehta',
            'apparel',
            'apparel company bonobos',
            'apple accessories',
            'apple tv',
            'application programming interface',
            'applied materials',
            'aquafadas',
            'asia',
            'askville',
            'asphalt 8',
            'asset',
            'association',
            'asus',
            'atlanta',
            'atlantis word processor',
            'atmosol',
            'atos',
            'att',
            'att mobility',
            'au',
            'audi',
            'audible',
            'audible com',
            'audiblecom',
            'audio',
            'audiobook',
            'austin texas',
            'australia',
            'autodesk',
            'automatic data processing',
            'automation',
            'avago technologies',
            'avaya',
            'avenel new jersey',
            'aviation',
            'badenwurttemberg',
            'baen free library',
            'baidu',
            'baltimore',
            'baltimore maryland',
            'bangalore',
            'bansal',
            'barnaby',
            'barnaby dorfman',
            'barnaby dorfman hulu',
            'barnes',
            'barnes noble nook',
            'basics',
            'basics toys',
            'batman',
            'battery electricity',
            'bavaria',
            'bbc news',
            'bbeb',
            'beacon hill seattle',
            'bebe',
            'bebe stores',
            'bed bath beyond',
            'bedfordshire',
            'beijing',
            'bell canada',
            'bellevue',
            'bellevue washington',
            'benefit cosmetics',
            'berlin',
            'bharti airtel',
            'big fish games',
            'biljon',
            'bing',
            'bing gordon',
            'binny bansal',
            'biogen idec',
            'bittorrent',
            'bl',
            'blackberry limited',
            'blio',
            'bloomberg businessweek',
            'bloomberg lp',
            'blu rays',
            'bluefire reader',
            'bluemel',
            'bluray',
            'body labs',
            'boignysurbionne',
            'boise idaho',
            'book',
            'book depository',
            'bookfindercom',
            'bookstore',
            'booktrack',
            'boox',
            'booz allen hamilton',
            'born this way album',
            'bourgogne',
            'box office mojo',
            'br',
            'brad stone journalist',
            'braille ebook',
            'brampton ontario',
            'brandenburg',
            'bratislava',
            'brazil',
            'brett',
            'brett witt',
            'brett witt wikinvest',
            'brian krueger',
            'brian mcbride director',
            'brian valentine',
            'brick and mortar',
            'brieselang',
            'brilliance',
            'brilliance audio brilliance audio',
            'british',
            'british columbia',
            'broadcom',
            'brooklyn new york',
            'bros',
            'bt global services',
            'bt group',
            'burrows',
            'business',
            'business insider',
            'business model',
            'business plan',
            'button',
            'buy',
            'byers',
            'byte',
            'c h robinson worldwide',
            'ca',
            'ca inc',
            'caci',
            'cadabra inc',
            'cagliari',
            'calibre software',
            'calligra suite',
            'cambridge',
            'cambridge massachusetts',
            'campbellsville kentucky',
            'canada',
            'canon inc',
            'cape',
            'cape town',
            'capgemini',
            'carbonado java',
            'carlisle pennsylvania',
            'carolina',
            'carrollton texas',
            'castel san giovanni',
            'catamaran corporation',
            'caufield',
            'cdnow',
            'cebu',
            'celestica',
            'celgene',
            'center',
            'centers',
            'central',
            'central bedfordshire',
            'centurylink',
            'cerner',
            'cgi group',
            'chakrabarti',
            'chambersburg pennsylvania',
            'charleston south carolina',
            'charleston tennessee',
            'charlie',
            'charlie cheever',
            'charter communications',
            'chattanooga tennessee',
            'check point',
            'checkout lines',
            'cheever',
            'chengdu',
            'chennai',
            'chester virginia',
            'chiba',
            'chiba prefecture',
            'chicago illinois',
            'chicago tribune',
            'china mobile',
            'china telecom',
            'china unicom',
            'choice in ecommerce',
            'chris',
            'chris pinkham',
            'christmas holiday season',
            'christopher north businessman',
            'chromecast',
            'cisco systems',
            'citrix systems',
            'claude',
            'claude monet',
            'cloud',
            'cloud computing',
            'cnet',
            'cockfight',
            'codesgoodyear',
            'coffeyville kansas',
            'cognizant',
            'columbia',
            'com',
            'comcast',
            'comic book archive',
            'comics',
            'comixology',
            'commission',
            'communications',
            'compact disc',
            'compal electronics',
            'companies',
            'companies in the nasdaq100 index',
            'comparison of ebook formats',
            'comparison of ebook readers',
            'comparison of ios ebook reader software',
            'compute',
            'computer hardware',
            'computer sciences corporation',
            'computer software',
            'computer world',
            'comunidad de madrid',
            'concord north carolina',
            'connecticut',
            'consulting',
            'content removal',
            'contiguous united states',
            'contract workers',
            'convenience stores',
            'convergence',
            'convergence corporation',
            'cooler',
            'coppell texas',
            'cork',
            'cork city',
            'corporation',
            'cosmetics',
            'costco',
            'council',
            'country code',
            'crawford',
            'credit card account',
            'crm software',
            'crosby',
            'cross',
            'crymlyn',
            'crymlyn burrows',
            'cupertino california',
            'curbside pickup locations',
            'customer buyer behavior',
            'cutler',
            'cutler pickering',
            'cybook',
            'd e shaw co',
            'daito osaka',
            'dakota',
            'dallas texas',
            'darigold',
            'darren',
            'darren vengroff',
            'dash',
            'data',
            'data centers',
            'data mining',
            'dave',
            'dave schappell',
            'davenport florida',
            'david risher',
            'dc',
            'deal of the day',
            'defamation',
            'delaware',
            'delivery',
            'delivery boy',
            'delivery service',
            'dell',
            'deloitte',
            'delta british columbia',
            'demand',
            'demeraramahaica',
            'deutsche telekom',
            'development',
            'dhl',
            'dhl express',
            'diana l bl',
            'diapers com',
            'diaperscom',
            'digest',
            'digital',
            'digital china',
            'digital distribution',
            'digital photography review',
            'digital reader 1000',
            'digital rights management',
            'directv',
            'discovery communications',
            'dish network',
            'distribution',
            'distribution centers',
            'district',
            'dog fighting',
            'dollar tree',
            'domain name',
            'doncaster',
            'doral florida',
            'dorfman',
            'dorr',
            'dorr alain moni',
            'dotcom bubble',
            'double helix games',
            'douglas',
            'douglas hofstadter',
            'downtown seattle building',
            'dpreviewcom',
            'draft amazon key',
            'dresden',
            'drone',
            'drop shippers',
            'drop shipping',
            'drugstorecom',
            'dublin',
            'dunfermline',
            'dupont',
            'dupont washington',
            'dvd',
            'dynamo storage system',
            'e commerce',
            'e ink',
            'earnings before interest and taxes',
            'east point georgia',
            'eastman kodak',
            'ebook',
            'ebook lending',
            'ebook reader',
            'ebook suppliers',
            'ecatalog',
            'ecommerce',
            'eddie bauer',
            'edinburgh',
            'edinburgh scotland asia india',
            'elastic',
            'elastic ip address',
            'electronic arts',
            'electronic publishing',
            'elonex ebook',
            'emc corporation',
            'emi',
            'emiliaromagna',
            'endlesscom',
            'engadget',
            'engine yard',
            'entertainment',
            'entourage edge',
            'entrepreneur',
            'epub',
            'equity finance',
            'ereader',
            'ericsson',
            'eslick',
            'eu',
            'europe',
            'evdo',
            'evi software',
            'exchange',
            'expedia',
            'expeditors international',
            'explore',
            'explore consulting',
            'express scripts',
            'faa',
            'faa federal aviation administration',
            'fast company magazine',
            'fastenal',
            'federal',
            'feedbooks',
            'fernley nevada',
            'fictionbook',
            'fife',
            'fillz',
            'financial times',
            'findory',
            'fire',
            'fire os',
            'fire phone',
            'fire tv',
            'fiscal year',
            'fiserv',
            'flepia',
            'flextronics',
            'flipkart',
            'fluid concepts',
            'fluid concepts and creative analogies',
            'food',
            'foodistacom',
            'for dummies',
            'forbes',
            'fort worth texas',
            'fortune 1000',
            'founded',
            'foxconn',
            'fr',
            'france',
            'freescale semiconductor',
            'fujitsu',
            'fulfillment',
            'fulfillment centers',
            'gafam',
            'gamasutra',
            'garmin',
            'george packer',
            'georgia',
            'geoworks',
            'gigaom',
            'gilead sciences',
            'gillis',
            'glenrothes',
            'globalfoundries',
            'golden globe awards',
            'goodyear arizona',
            'google play',
            'google play books',
            'gordon',
            'gourock',
            'gowebbaby',
            'graben bavaria',
            'grand forks north dakota',
            'graphiq',
            'green',
            'greg',
            'greg linden',
            'greg linden flipkart',
            'group',
            'guangdong',
            'guangxi',
            'guangxi zhuang',
            'guangzhou',
            'gujarat',
            'gupta',
            'gurgaon',
            'gurupa',
            'haerbin',
            'hale',
            'hampshire',
            'hanlin ereader',
            'hardcover',
            'harrisburg pennsylvania',
            'haryana',
            'hathitrust',
            'hazafon',
            'hazleton pennsylvania',
            'hcl technologies',
            'hebron kentucky',
            'heilongjiang',
            'hemel hempstead',
            'henry schein',
            'heredia',
            'hertfordshire',
            'hewlett',
            'hewlett packard',
            'hewlettpackard',
            'history of amazon',
            'history of amazon com',
            'hitachi consulting',
            'hitachi data systems',
            'hofstadter',
            'hokkaido',
            'holden',
            'holding',
            'home',
            'homegrocercom',
            'hp enterprise services',
            'hp software division',
            'htc',
            'http www amazon com',
            'huawei',
            'hulu',
            'humble',
            'humble texas',
            'huntington west virginia',
            'hurricane',
            'hurricane katrina',
            'hurricane sandy',
            'hussein',
            'hutchison asia telecommunications',
            'hybris company',
            'hyderabad',
            'hyderabad india',
            'hypertext transfer protocol',
            'ia i',
            'iacinteractivecorp',
            'iasi',
            'ibm',
            'ibm global services',
            'ibooks',
            'ibooks author',
            'ibooks store',
            'ichikawa chiba',
            'idaho',
            'iliad',
            'illinois',
            'illumina company',
            'imdb com inc',
            'inc',
            'incorporated',
            'indian arm',
            'indiana',
            'indianapolis indiana',
            'indra sistemas',
            'infibeam',
            'infineon technologies',
            'information technology',
            'informationweek',
            'infosys',
            'ingram',
            'ingram book',
            'ingram content group',
            'ingram micro',
            'initial public offering',
            'integrated authority file',
            'integrated microelectronics inc',
            'intel',
            'international digital publishing forum',
            'international standard book number',
            'internationalization and localization',
            'internet',
            'internet archive',
            'internet forum',
            'internet shopping mall',
            'intuit',
            'intuitive surgical',
            'inverclyde',
            'ireland',
            'iriver story',
            'irvine california',
            'israel',
            'issuu',
            'ivona',
            'ivona software',
            'jabil circuit',
            'jackson',
            'jadida',
            'jaipur',
            'jambool',
            'japan',
            'jason',
            'jason kilar',
            'jason olim',
            'java programming language',
            'jdcom',
            'jeff bezos quora',
            'jeff holden',
            'jeff lawson',
            'jeff lawson entrepreneur',
            'jeffersonville indiana',
            'jersey',
            'jersey marine',
            'jersey shore tv series',
            'jesse',
            'jesse robbins',
            'jetcom',
            'jewelry',
            'jiangsu',
            'jinan',
            'john ingram',
            'john r ingram businessman',
            'jones soda',
            'jos',
            'joyocom',
            'jp',
            'junglee com',
            'jungleecom',
            'juniper networks',
            'kansas',
            'karbonn mobiles',
            'karnataka',
            'katrina',
            'kaushalam',
            'kawagoe saitama',
            'kddi',
            'keith',
            'keith schorsch',
            'kennewick washington',
            'kenosha wisconsin',
            'kent washington',
            'kentucky',
            'keurig green mountain',
            'keyur',
            'keyur patel',
            'kilar',
            'kindle',
            'kindle fire',
            'kindle fire hd',
            'kindle fire hdx',
            'kindle single',
            'kingdom',
            'kingston technology',
            'kirkland washington',
            'kitabu',
            'kiva',
            'klatencor',
            'kleiner',
            'kleiner perkins caufield byers',
            'kloc',
            'kloc technologies',
            'koblenz',
            'kobo aura',
            'kobo aura hd',
            'kobo ereader',
            'kobo glo',
            'kobo inc',
            'kobo mini',
            'kobo touch',
            'konica minolta',
            'kpmg',
            'kpn',
            'kraft foods',
            'kt corporation',
            'kushal',
            'kushal chakrabarti',
            'kyocera',
            'kyoto',
            'l bl',
            'la times',
            'lab126',
            'labs',
            'lacoste',
            'lady gaga',
            'lafayette',
            'lakeland florida',
            'lam research',
            'lantern',
            'las vegas',
            'latex',
            'lauwinplanque',
            'lava mobiles',
            'lawson',
            'leads',
            'lebanon tennessee',
            'leep',
            'leep technology inc',
            'legislative',
            'leipzig',
            'lenexa kansas',
            'lenfant a la tasse',
            'lenovo',
            'lewisberry pennsylvania',
            'lexcycle',
            'lexington kentucky',
            'lexmark',
            'lg electronics',
            'lgbt',
            'lgbt book sales rank',
            'liaoning',
            'liberty global',
            'liberty interactive',
            'liberty media',
            'library catalogs',
            'librarything',
            'linden',
            'linear technology',
            'liquavista',
            'list of amazon subsidiaries',
            'list of book distributors',
            'list of companies based in seattle',
            'list of largest internet companies',
            'list of the largest information technology companies',
            'list of the largest software companies',
            'list of video game developers',
            'living social',
            'livingsocial',
            'localized',
            'london',
            'lore',
            'louisville kentucky',
            'lovefilm',
            'luxembourg',
            'luxembourg city',
            'luxor design',
            'm xico',
            'madison wisconsin',
            'madrid',
            'madrona',
            'mail order',
            'mail order catalogs',
            'maintenance repair and operations',
            'manfred',
            'manfred bluemel',
            'manhattan',
            'marc',
            'marc lore',
            'marc lore nimbula',
            'market capitalization',
            'market prices',
            'marketplace',
            'marks spencer',
            'marriott international',
            'marthas table',
            'marvell technology group',
            'mary s place',
            'maryland',
            'mashable',
            'massachusetts',
            'matt williams',
            'matt williams internet entrepreneur',
            'mattel',
            'matthew olim',
            'may',
            'mcdonald',
            'mcdonalds',
            'mcdonough',
            'mcdonough georgia',
            'media',
            'mediatek',
            'meguro tokyo',
            'mehta',
            'mercer island washington',
            'mexico',
            'miami',
            'michael jackson',
            'michael sha',
            'michael sha yellowleg com',
            'micromax mobile',
            'micron technology',
            'microsoft',
            'microsoft mobile',
            'microsoft reader',
            'microsoft windows',
            'middletown delaware',
            'mike daisey',
            'milton ontario',
            'mindcorps',
            'mindcorps incorporated',
            'mindoro',
            'minecraft',
            'mississauga',
            'mississauga ontario',
            'mitsubishi electric',
            'mobile',
            'mobipocket',
            'mobipocketcom',
            'mojo books',
            'mondel z international',
            'monet',
            'moni',
            'monster beverage',
            'mont limar',
            'montevideo',
            'moreno valley california',
            'mortar competitors',
            'mortar retailer',
            'mothercare',
            'motorola mobility',
            'motorola solutions',
            'mp3',
            'mts network provider',
            'mumbai',
            'munich',
            'munster indiana',
            'murfreesboro tennessee',
            'music',
            'music cds',
            'music industry',
            'music labels',
            'music unlimited',
            'mx',
            'mylan',
            'nadu',
            'nanning',
            'nasdaq',
            'nasdaq100',
            'nashua new hampshire',
            'nashville tennessee',
            'naver corporation',
            'ncr corporation',
            'nealpes',
            'neath',
            'neath port talbot',
            'nec',
            'neonazism',
            'net income',
            'netapp',
            'netease',
            'netflix',
            'netherlands',
            'nevada',
            'new',
            'new castle delaware',
            'new hampshire',
            'new jersey',
            'new south wales',
            'new york city',
            'new york new york',
            'new york times article',
            'newark california',
            'newark new jersey',
            'newegg',
            'nielsen bookscan service',
            'nikon',
            'nimbula',
            'nintendo',
            'nippon telegraph and telephone',
            'nl',
            'noble',
            'nokia networks',
            'noncompete clause',
            'nonperishable food',
            'noordholland',
            'nord',
            'nordstrom',
            'norman',
            'norman rockwell',
            'north',
            'north america',
            'north america united states of america fulfillment center codesgoodyear',
            'north carolina',
            'north dakota',
            'north las vegas nevada',
            'north rhinewestphalia',
            'ntt data',
            'ntt docomo',
            'nvidia',
            'nxp semiconductors',
            'obidos software',
            'occidental',
            'occidental mindoro',
            'oceania',
            'oclc',
            'october 2018 wage increase',
            'offer goods',
            'office workers',
            'oi telecommunications',
            'olympus corporation',
            'om malik',
            'on semiconductor',
            'online',
            'online advertising',
            'online bookstore',
            'online file storage',
            'online shopping',
            'ontario',
            'opds',
            'opencorporates',
            'opscode',
            'oracle',
            'oracle corporation',
            'orange business services',
            'orange county california',
            'orange sa',
            'order',
            'oreilly automotive',
            'osaka prefecture',
            'overdrive media console',
            'overstockcom',
            'paas',
            'paccar',
            'pacific medical center',
            'package delivery',
            'packard',
            'palm',
            'panasonic',
            'pantry',
            'parent company',
            'party company',
            'patel',
            'patriots',
            'patterson california',
            'paychex',
            'payments service',
            'pc world',
            'pedophilia',
            'pegatron',
            'pelago',
            'perfect 10 inc v amazoncom inc',
            'perishable food',
            'perkins',
            'peter kent',
            'peterborough',
            'petersburg virginia',
            'petscom',
            'pforzheim',
            'philadelphia pa',
            'phoenix arizona',
            'phrase extraction technique',
            'pickering',
            'pinkham',
            'pinzon',
            'pittsburgh pennsylvania',
            'plain text',
            'plainfield indiana',
            'planetall',
            'plastic logic',
            'platform as a service',
            'pocket edge',
            'pocketbook ereader',
            'point of sale',
            'poland',
            'port',
            'portable document format',
            'postal',
            'pradesh',
            'press',
            'price discrimination',
            'prime',
            'print on demand',
            'private label',
            'product business',
            'program',
            'project gutenberg',
            'provencealpesc',
            'provencealpesc tedazur',
            'public company',
            'publisher',
            'publishing',
            'puget sound energy',
            'puget sound region',
            'pushbutton',
            'qfc',
            'qina',
            'qisda es900',
            'qlick cart',
            'qualcomm',
            'quanta computer',
            'queue',
            'quidsi',
            'quora',
            'rajasthan',
            'rakuten',
            'ram shriram',
            'randall',
            'randall sullivan',
            'randstad',
            'randstad holding',
            'rating scale',
            'reader library',
            'readers',
            'readers digest association',
            'records data',
            'red',
            'red cross',
            'redlands california',
            'reflexive',
            'reflexive entertainment',
            'reflowable document',
            'regeneron',
            'region',
            'rei',
            'relentless com',
            'renesas electronics',
            'reno nevada',
            'replenishment',
            'reserve',
            'reuters',
            'revenue',
            'reza',
            'reza hussein',
            'rh',
            'rh nealpes',
            'rheinberg',
            'rhinelandpalatinate',
            'rhinewestphalia',
            'rick dalzell',
            'ricoh',
            'ridgmont',
            'ridgmont rugeley',
            'rijswijk',
            'ring',
            'robbins',
            'robbinsville new jersey',
            'rockwell',
            'ross stores',
            'ruby',
            'rugeley',
            'ruskin florida',
            's p 100',
            'sachin',
            'sachin bansal',
            'safeco',
            'saint',
            'saint andrew',
            'saitama',
            'saitama prefecture',
            'sakai osaka',
            'sala',
            'sala al jadida uk',
            'sale taxes',
            'salesforcecom',
            'samsung electronics',
            'samsung papyrus',
            'san',
            'san bernardino california',
            'san diego',
            'san fernando de henares madrid',
            'san francisco',
            'san francisco california',
            'san jos',
            'san luis obispo california',
            'sandisk',
            'sandy',
            'sanmina corporation',
            'sap se',
            'saran',
            'saran loiret',
            'sardinia',
            'saxony',
            'sba communications',
            'schappell',
            'schertz texas',
            'scholar',
            'schorsch',
            'scotland',
            'scotts valley california',
            'sdc',
            'sdc seattle distribution center',
            'seagate technology',
            'sears',
            'sears canada',
            'seatac washington',
            'seattle metropolitan area',
            'seattle times',
            'seattle tower',
            'seiko epson',
            'selfpublishing companies',
            'sellaband',
            'sellers',
            'semantic publishing',
            'semiconductor sales leaders by year',
            'service',
            'service company',
            'service economics',
            'services',
            'sevrey',
            'sha',
            'sha yellowleg',
            'shandong',
            'shanghai',
            'sharp corporation',
            'shenyang',
            'shepherdsville kentucky',
            'shopping service',
            'sichuan',
            'sigil application',
            'sigmaaldrich',
            'simple',
            'singapore',
            'sirius xm holdings',
            'sk hynix',
            'sk telecom',
            'slatecom',
            'slough',
            'smartphone',
            'smashwords',
            'smile',
            'social cataloging',
            'social media',
            'socialgold',
            'softbank mobile',
            'softbook',
            'software',
            'software engineer',
            'soho',
            'somerset',
            'songza',
            'sony',
            'sony mobile communications',
            'sony music',
            'sony reader',
            'sorsogon',
            'sothebys',
            'south',
            'south america',
            'south carolina',
            'south lake union seattle',
            'sovereign state',
            'sp 500',
            'spartanburg south carolina',
            'sponsor commercial',
            'sports equipment',
            'sprint',
            'sprint corporation',
            'staffordshire',
            'staples inc',
            'starbucks',
            'states',
            'statistically improbable phrases',
            'stdu viewer',
            'stericycle',
            'stmicroelectronics',
            'stock',
            'stock split',
            'stockton california',
            'storage',
            'storefront businesses',
            'stores',
            'stoughton massachusetts',
            'street',
            'studios',
            'sullivan',
            'sumner washington',
            'superman',
            'suzhou',
            'swansea',
            'sweden',
            'swedesboro new jersey',
            'symantec',
            'synapseindia',
            'systems',
            'tablet computer',
            'tag metadata',
            'talbot',
            'tamil',
            'tamil nadu',
            'tampa',
            'tampa bay area',
            'target',
            'target corporation',
            'tata consultancy services',
            'tcl corporation',
            'teachstreet',
            'team',
            'techcrunch',
            'technologies',
            'technology',
            'tedazur',
            'telecom italia',
            'telef nica',
            'tempe arizona',
            'tencent',
            'tennessee',
            'terabyte',
            'terms of service',
            'tesla motors',
            'texas instruments',
            'the book depository',
            'the hague',
            'the new york times',
            'the new yorker',
            'the next web',
            'the priceline group',
            'the sandman',
            'the slate group',
            'the unusuals',
            'the verge',
            'the walking dead video game',
            'tianjin',
            'ticker symbol',
            'time',
            'time magazine',
            'time person of the year',
            'tmobile us',
            'tmobile usa',
            'toby',
            'toby press',
            'tokyo',
            'tom szkutak',
            'tony hsieh',
            'toplevel domain',
            'toshiba',
            'toys',
            'toys games',
            'tpv technology',
            'tractor supply company',
            'tracy california',
            'trade',
            'trademark',
            'trademark infringement case',
            'transparent tv series',
            'tripadvisor',
            'trusera',
            'tsmc',
            'tsystems',
            'turkey',
            'turkish language versions',
            'tv',
            'twilio',
            'twitch website',
            'twitchtv',
            'twitter',
            'types of business entity',
            'u k civil aviation authority',
            'ubm plc',
            'uk civil aviation authority',
            'unionization',
            'unisys',
            'united',
            'united microelectronics corporation',
            'united states dollar',
            'united states patent and trademark office',
            'united states presidential election 2004',
            'universal',
            'universal music group',
            'unmanned aerial vehicle',
            'us congress',
            'us navy',
            'us state',
            'usc',
            'use taxes',
            'uspto',
            'v group',
            'van',
            'van biljon',
            'vengroff',
            'venture',
            'verisk analytics',
            'verizon',
            'verizon communications',
            'verizon wireless',
            'vertex pharmaceuticals',
            'vhs',
            'viacom',
            'video game',
            'video on demand',
            'vikas',
            'vikas gupta',
            'vimpelcom ltd',
            'virginia data centers',
            'virtual international authority file',
            'vishal',
            'vishal mehta',
            'visiting',
            'visiting scholar',
            'vittana',
            'vivendi',
            'vmware',
            'vodafone',
            'w3techs',
            'wage increase',
            'wales',
            'wales crymlyn burrows',
            'walgreens',
            'walgreens boots alliance',
            'warehouse conditions',
            'warhol',
            'warner',
            'warner bros',
            'warner bros records',
            'washington state',
            'watchmen',
            'web banner',
            'web hosting',
            'web hosting service',
            'web service',
            'webstores',
            'werne',
            'werner vogels',
            'west',
            'west columbia south carolina',
            'west virginia',
            'western',
            'western cape',
            'western digital',
            'weyerhaeuser',
            'whispernet',
            'whitestown indiana',
            'whole foods',
            'whrrl',
            'wiki',
            'wikibooks',
            'wikimedia endowment',
            'wikinvest',
            'wikisource',
            'willem',
            'willem van biljon',
            'williams',
            'willie',
            'willie gillis',
            'wilmer',
            'wilmer cutler pickering hale',
            'winchester kentucky',
            'windsor locks connecticut',
            'wipro',
            'wireless',
            'wisconsin',
            'wistron corporation',
            'withoutabox',
            'witt',
            'woleuntem',
            'woot',
            'wootcom',
            'wora',
            'wynn resorts',
            'xerox',
            'xhtml',
            'xiamen',
            'xian',
            'xiaomi',
            'xico',
            'xilinx',
            'xmdf ebook format',
            'xml',
            'xml service',
            'xolo company',
            'yachiyo chiba',
            'yahoo',
            'yandex',
            'yap company',
            'yellowleg',
            'yellowlegcom',
            'yokneam',
            'york',
            'yu televentures',
            'zapposcom',
            'zeitgeist research',
            'zhuang',
            'zip code',
            'zte',
            'zuidholland'
        ],
        'description': 'Amazon.com, Inc., doing business as Amazon, is a multinational technology company focusing in e-commerce, cloud computing, and artificial intelligence in Seattle, Washington. It is one of the Big Four or \'Four Horsemen\' of technology along with Google, Apple and Facebook due to its market capitalization, disruptive innovation, brand equity and hyper-competitive application process.',
        'employeeCount': 341400,
        'employerIdNumbers': [
            '91-1646860'
        ],
        'founders': [
            'Jeff Bezos'
        ],
        'id': '1454825144322',
        'imageUrls': [
            'https://upload.wikimedia.org/wikipedia/commons/4/43/Seattle_-_Arizona_Building_02.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/6/62/Amazon.com-Logo.svg',
            'https://upload.wikimedia.org/wikipedia/commons/b/bb/Amazon_warehouse_Glenrothes.jpg'
        ],
        'inceptionDate': '1994-07-06',
        'industries': [
            'retail'
        ],
        'instanceOf': [
            'public company',
            'e-commerce',
            'business enterprise'
        ],
        'isins': [
            'US0231351067'
        ],
        'label': 'Amazon',
        'languageFields': [
            {
                'description': 'Amazon.com, Inc., doing business as Amazon, is an American electronic commerce and cloud computing company based in Seattle, Washington that was founded by Jeff Bezos on July 5, 1994. The tech giant is the largest Internet retailer in the world as measured by revenue and market capitalization, and second largest after Alibaba Group in terms of total sales. The amazon.com website started as an online bookstore and later diversified to sell video downloads/streaming, MP3 downloads/streaming, audiobook downloads/streaming, software, video games, electronics, apparel, furniture, food, toys, and jewelry. The company also produces consumer electronics—Kindle e-readers, Fire tablets, Fire TV, and Echo—and is the world\'s largest provider of cloud infrastructure services (IaaS and PaaS). Amazon also sells certain low-end products under its in-house brand AmazonBasics.',
                'label': 'Amazon',
                'langCode': 'en',
                'urls': [
                    'https://en.wikipedia.org/wiki/Amazon_(company)'
                ]
            },
            {
                'description': 'Amazon.com is een Amerikaans e-commercebedrijf gevestigd in Seattle (Washington). Het was een van de eerste grote bedrijven die goederen over het internet verkochten en het werd opgericht in 1994 door Jeff Bezos. ',
                'label': 'Amazon.com',
                'langCode': 'nl',
                'urls': [
                    'https://nl.wikipedia.org/wiki/Amazon.com'
                ]
            },
            {
                'description': 'US-amerikanisches E-Commerce-Versandhaus',
                'label': 'Amazon.com',
                'langCode': 'de',
                'urls': [
                    'https://de.wikipedia.org/wiki/Amazon.com'
                ]
            },
            {
                'description': 'Compañía estadounidense de comercio electrónico y servicios de computación en la nube',
                'label': 'Amazon.com',
                'langCode': 'es',
                'urls': [
                    'https://es.wikipedia.org/wiki/Amazon'
                ]
            },
            {
                'description': 'entreprise américaine spécialisée dans la vente  en ligne',
                'label': 'Amazon.com',
                'langCode': 'fr',
                'urls': [
                    'https://fr.wikipedia.org/wiki/Amazon_(entreprise)'
                ]
            },
            {
                'description': 'американская компания по продаже товаров и услуг через Интернет',
                'label': 'Amazon.com',
                'langCode': 'ru',
                'urls': [
                    'https://ru.wikipedia.org/wiki/Amazon_(компания)'
                ]
            }
        ],
        'legalEntityIds': [
            'ZXTILKJKG63JELOEG630'
        ],
        'legalForms': [
            'public company'
        ],
        'location': {
            'admin1Label': 'Washington',
            'cityLabel': 'Seattle',
            'countryLabel': 'United States of America',
            'latitude': 47.6227,
            'longitude': -122.3362,
            'name': 'Seattle',
            'postalCode': '98101',
            'streetAddress': '410 Terry Avenue North'
        },
        'orgNames': [
            'amazon connect',
            'amazon india',
            'amazon jp',
            'amazon services',
            'beautybar com',
            'amazon com incorporated',
            'amazon com inc',
            'amazon inc',
            'amazon online',
            'createspace com',
            'amazonwebstore',
            'amazon fr',
            'amazoncom',
            'amazonbasics',
            'www amazon com',
            'amazon prime',
            'amazon store',
            'amazon astore',
            'amazon it',
            'amazon co jp',
            'amazon in',
            'amazon',
            'look com',
            'amazon internet retailer',
            'amazon game studios',
            'sound unwound',
            'amazon digital services',
            'amazon books',
            'wag com',
            'amazon dot com',
            'brilliance audio',
            'indigo starfish',
            'cadabra com',
            'amazon leadership principles',
            'amazonwireless',
            'amazon local',
            'amazonlocal',
            'amazon corp',
            'amazon uk',
            'yoyo com',
            'amazon co uk',
            'list of amazon com subsidiaries',
            'vine com',
            'amazon internet store',
            'amazon affiliates',
            'amzn',
            'soundunwound',
            'amazon prime day',
            'amazon software download',
            'createspace independent publishing platform',
            'amazon website',
            'bookworm com',
            'astore',
            'soundunwound com',
            'amazon com',
            'customflix',
            'amazon de',
            'amazon eu sarl',
            'afterschool com',
            'createspace',
            'booksurge',
            'casa com',
            'amazon ca',
            'amazoncom inc',
            'as16509',
            'booksurge llc',
            'amazon bookstore',
            'amazon company',
            'zshops',
            'amazon webstore',
            'amazon japan',
            'amazon com exclusive',
            'shopbop',
            'amazon jersey',
            'unboxed com',
            'myhabit com',
            'pinzon trademark',
            'amazon video direct',
            'amazon retailer',
            'amazon amzn'
        ],
        'owners': [
            'The Vanguard Group',
            'Jeff Bezos'
        ],
        'partOf': [
            'NASDAQ-100',
            'S&P 500'
        ],
        'permIds': [
            '4295905494'
        ],
        'prominence': 0.6173,
        'stocks': [
            {
                'exchange': 'NASDAQ',
                'tickerSymbol': 'AMZN'
            }
        ],
        'subType': 'COMPANY',
        'subsidiaries': [
            'A9.com',
            'Amazon Web Services',
            'Alexa',
            'Zappos.com',
            'Internet Movie Database',
            'Twitch',
            'Amazon Technologies',
            'Amazon Prime Air',
            'Souq.com',
            'Alexa Internet'
        ],
        'twitterNames': [
            'amazon'
        ],
        'type': 'ORGANIZATION',
        'urls': [
            'https://en.wikipedia.org/wiki/Amazon_(company)',
            'https://www.wikidata.org/wiki/Q3884',
            'https://permid.org/1-4295905494',
            'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=0001018724',
            'https://www.gleif.org/lei/ZXTILKJKG63JELOEG630',
            'https://twitter.com/amazon',
            'https://www.facebook.com/Amazon',
            'https://www.instagram.com/amazon',
            'https://plus.google.com/114493486650807637382',
            'https://www.youtube.com/channel/UCkLXELm63_pH7L-r-548kig',
            'https://g.co/kg/m/0mgkg',
            'https://www.quora.com/topic/Amazon-company',
            'https://www.britannica.com/topic/Amazoncom',
            'http://www.isin.org/isin-preview/?isin=US0231351067',
            'https://en.wikipedia.org/wiki/Amazon.com',
            'https://www.amazon.com',
            'https://www.amazon.de'
        ],
        'version': '19.3.2'
    };

    const EXAMPLE_RESPONSE_V1_ENTITIES3 = {
        'admin1DsgFeatureCode': 'ADM1',
        'admin1Fips': 'US11',
        'admin1Genc': 'US-DC',
        'admin1Label': 'District of Columbia',
        'admin2Label': 'District of Columbia',
        'boundingBox': {
            'maxLatitude': 39.133,
            'maxLongitude': -76.8287,
            'minLatitude': 38.6918,
            'minLongitude': -77.3268
        },
        'countryDsgFeatureCode': 'PCLI',
        'countryFips': 'US',
        'countryGenc2': 'US',
        'countryGenc3': 'USA',
        'countryGencCode': '840',
        'countryLabel': 'United States',
        'dsgFeatureClass': 'P',
        'dsgFeatureClassLabel': 'Populated place',
        'dsgFeatureCode': 'PPLC',
        'dsgFeatureCodeDescription': 'capital of a political entity',
        'dsgFeatureCodeLabel': 'national capital',
        'id': '243859456',
        'label': 'Washington',
        'latitude': 38.895,
        'longitude': -77.0367,
        'population': 572059,
        'type': 'GEO'
    };

    const EXAMPLE_RESPONSE_V1_LOCATION_FINDER_QUERY = {
        'enclosingViewBounds': {
            'maxLatitude': 53.01057055430997,
            'maxLongitude': 2.030354870576902,
            'minLatitude': 50.020029445690035,
            'minLongitude': -4.828315438850646
        },
        'locations': [
            {
                'admin1DsgFeatureCode': 'ADM1',
                'admin1Fips': 'UKP5',
                'admin1Genc': 'GB-WSM',
                'admin1Label': 'Westminster',
                'admin2Label': 'London',
                'boundingBox': {
                    'maxLatitude': 51.7205,
                    'maxLongitude': 0.281831,
                    'minLatitude': 51.2707,
                    'minLongitude': -0.496739
                },
                'countryDsgFeatureCode': 'PCLI',
                'countryFips': 'UK',
                'countryGenc2': 'GB',
                'countryGenc3': 'GBR',
                'countryGencCode': '826',
                'countryLabel': 'United Kingdom',
                'dsgFeatureClass': 'P',
                'dsgFeatureClassLabel': 'Populated place',
                'dsgFeatureCode': 'PPLC',
                'dsgFeatureCodeDescription': 'capital of a political entity designated as an independent state',
                'dsgFeatureCodeLabel': 'capital of an independent state',
                'id': '975749709824',
                'label': 'London',
                'latitude': 51.5081,
                'longitude': -0.12484,
                'population': 9304016,
                'type': 'GEO'
            }
        ]
    };

    const EXAMPLE_RESPONSE_V1_LOCATION_FINDER_GEOMETRY = {
        enclosingViewBounds: {
            maxLatitude: 53.01057055430997,
            maxLongitude: 2.030354870576902,
            minLatitude: 50.020029445690035,
            minLongitude: -4.828315438850646,
        },
        locations: [
            {
            admin1DsgFeatureCode: 'ADM1',
            admin1Fips: 'UKP5',
            admin1Genc: 'GB-WSM',
            admin1Label: 'Westminster',
            admin2Label: 'London',
            boundingBox: {
                maxLatitude: 51.7205,
                maxLongitude: 0.281831,
                minLatitude: 51.2707,
                minLongitude: -0.496739,
            },
            countryDsgFeatureCode: 'PCLI',
            countryFips: 'UK',
            countryGenc2: 'GB',
            countryGenc3: 'GBR',
            countryGencCode: '826',
            countryLabel: 'United Kingdom',
            dsgFeatureClass: 'P',
            dsgFeatureClassLabel: 'Populated place',
            dsgFeatureCode: 'PPLC',
            dsgFeatureCodeDescription:
                'capital of a political entity designated as an independent state',
            dsgFeatureCodeLabel: 'capital of an independent state',
            id: '975749709824',
            label: 'London',
            latitude: 51.5081,
            longitude: -0.12484,
            population: 9304016,
            type: 'GEO',
            }
        ],
    };

    const EXAMPLE_RESPONSE_V1_LOCATION_FINDER_BBOX = {
        enclosingViewBounds: {
          maxLatitude: 38.74754054449975,
          maxLongitude: -121.45246652285228,
          minLatitude: 36.8603314283324,
          minLongitude: -123.3477688810604,
        },
        locations: [
          {
            admin1DsgFeatureCode: 'ADM1',
            admin1Fips: 'US06',
            admin1Genc: 'US-CA',
            admin1Label: 'California',
            admin2DsgFeatureCode: 'ADM2',
            admin2Label: 'San Francisco',
            azimuthDegrees: '282.375998157',
            boundingBox: {
              maxLatitude: 38.6422,
              maxLongitude: -121.559,
              minLatitude: 36.9582,
              minLongitude: -123.243,
            },
            countryDsgFeatureCode: 'PCLI',
            countryFips: 'US',
            countryGenc2: 'US',
            countryGenc3: 'USA',
            countryGencCode: '840',
            countryLabel: 'United States',
            distanceKilometers: '0.0851824672843',
            dsgFeatureClass: 'L',
            dsgFeatureClassLabel: 'Locality or Area',
            dsgFeatureCode: 'PRK',
            dsgFeatureCodeDescription:
              'an area of defined limits which is set aside for human recreation and enjoyment and/or for historic preservation purposes, and is usually maintained in a natural, semi-natural, or ornamentally planted state',
            dsgFeatureCodeLabel: 'park',
            id: '194062188544',
            label: 'Northeast Waterfront Historic District',
            latitude: 37.8002,
            longitude: -122.401,
            type: 'GEO',
          },
        ],
      };

    const EXAMPLE_RESPONSE_V1_LOCATION_FINDER_RADIUS = {
        enclosingViewBounds: {
            maxLatitude: 38.65344324491702,
            maxLongitude: -121.53538865052498,
            minLatitude: 36.89147543432364,
            minLongitude: -123.31640564533912,
        },
        locations: [
            {
            admin1DsgFeatureCode: 'ADM1',
            admin1Fips: 'US06',
            admin1Genc: 'US-CA',
            admin1Label: 'California',
            admin2DsgFeatureCode: 'ADM2',
            admin2Label: 'San Francisco',
            azimuthDegrees: '336.944823657',
            boundingBox: {
                maxLatitude: 38.6161,
                maxLongitude: -121.578,
                minLatitude: 36.9339,
                minLongitude: -123.261,
            },
            countryDsgFeatureCode: 'PCLI',
            countryFips: 'US',
            countryGenc2: 'US',
            countryGenc3: 'USA',
            countryGencCode: '840',
            countryLabel: 'United States',
            distanceKilometers: '0.0157145670475',
            dsgFeatureClass: 'S',
            dsgFeatureClassLabel: 'Spot feature',
            dsgFeatureCode: 'XREST',
            dsgFeatureCodeDescription: 'a place where meals are served to the public',
            dsgFeatureCodeLabel: 'restaurant',
            id: '867905437696',
            label: 'All Star Cafe',
            latitude: 37.775,
            longitude: -122.419,
            type: 'GEO',
            },
        ],
    };

    const EXAMPLE_RESPONSE_V1_QUERY_PARSER = {
        'location': {
            'admin1Fips': 'US39',
            'admin1Genc': 'US-OH',
            'admin1Label': 'Ohio',
            'admin2Label': 'Montgomery',
            'boundingBox': {
                'maxLatitude': 39.845299,
                'maxLongitude': -84.027589,
                'minLatitude': 39.642623,
                'minLongitude': -84.312905
            },
            'boundingBoxDerivation': 'Geometry',
            'countryFips': 'US',
            'countryGenc2': 'US',
            'countryGenc3': 'USA',
            'countryGencCode': '840',
            'countryLabel': 'United States',
            'dsgFeatureClass': 'P',
            'dsgFeatureClassLabel': 'Populated place',
            'dsgFeatureCode': 'PPL',
            'dsgFeatureCodeDescription': 'city, town, village, or other agglomeration of buildings where people live and work',
            'dsgFeatureCodeLabel': 'populated place',
            'extractedText': 'Dayton',
            'fullName': 'Dayton, Ohio, United States',
            'id': '8544256000',
            'label': 'Dayton',
            'latitude': 39.7589,
            'locationScore': 0.554196,
            'longitude': -84.1916,
            'population': 166179,
            'queryConfidence': 0.420803,
            'type': 'GEO'
        },
        'remainingQuery': 'museums'
    };

    const EXAMPLE_REQUEST_V1_SENTIMENT1 = {
        'text': 'The White House on Tuesday vigorously defended President Trump’s budget...',
        'documentSentimentModel': 'news3'
    };

    const EXAMPLE_RESPONSE_V1_SENTIMENT1 = {
        'sentiment': {
            'class': 'negative',
            'classConfidence': 0.579,
            'score': -0.527,
            'sentences': [
                {
                    'class': 'negative',
                    'classConfidence': 0.579,
                    'position': [
                        0,
                        74
                    ],
                    'score': -0.527,
                    'text': 'The White House on Tuesday vigorously defended President Trump\'s budget...'
                }
            ]
        }
    };

    const EXAMPLE_REQUEST_V1_SENTIMENT2 = {
        'mediaType': 'blog',
        'documentId': '234526234',
        'languageCode': 'en',
        'documentSentimentModel': 'news3',
        'text': 'May be more genial than ingenious, but it gets the job done. Silence of the Lambs has excellent acting but a very depressing plot.'
    };

    const EXAMPLE_RESPONSE_V1_SENTIMENT2 = {
        'sentiment': {
            'class': 'positive',
            'classConfidence': 0.424,
            'score': 0.352,
            'sentences': [
                {
                    'class': 'positive',
                    'classConfidence': 0.343,
                    'position': [
                        0,
                        60
                    ],
                    'score': 0.261,
                    'text': 'May be more genial than ingenious, but it gets the job done.'
                },
                {
                    'class': 'negative',
                    'classConfidence': 0.475,
                    'position': [
                        61,
                        130
                    ],
                    'score': -0.41,
                    'text': 'Silence of the Lambs has excellent acting but a very depressing plot.'
                }
            ]
        }
    }

    const EXAMPLE_REQUEST_V1_SUMMARIZE = {
        'languageCode': 'en',
        'summaryModel': 'News',
        'text': 'The Dow dropped as many as 549 points, or 2%, on Tuesday after major US companies reported gloomy results and guidance. Disappointing numbers from Caterpillar and 3M reinforced ongoing concerns about how long blockbuster profits can last, especially given tariffs and rising costs.\nThe Dow was recently down about 400 points. The S&P 500 declined 1.8%, while the Nasdaq tumbled about 2.2%. The Nasdaq is at risk of closing in a technical correction -- a 10% decline from prior highs.\n\'Investors are skittish about whether we\'ve seen a peak in earnings,\' said Mark Luschini, chief market strategist at Janney Capital Management. \'It\'s a schizophrenic market environment where things that didn\'t matter suddenly do.\n\' It\'s been a scary month for investors. The Dow has plunged about 1,500 points, or 5.7%. That would be the index\'s steepest monthly percentage decline since August 2015, a period when China fears were front-and-center.\nOctober has been even worse for the Nasdaq. The index, down 9% this month, is on track for its worst month since November 2008 when it plummeted 11%. Tech stocks, once the bright spot in the market, continued to take the brunt of the selling on Tuesday. Netflix and Amazon slid about 3%, while Apple and Facebook declined 2%.\n\'The market is fragile,\' said Rich Guerrini, CEO of PNC Investments. \'But we\'re telling our investors to relax. We\'re in a correction. I think the market does have some legs left.\'\nThe VIX volatility index soared 16% on Tuesday. The CNN Business Fear & Greed Index slipped further into \'extreme fear.\' A month ago the gauge of market sentiment was flashing \'extreme greed.\'\nWall Street was also spooked by extreme turbulence in China, the epicenter of the trade war. The Shanghai Composite dropped 2.3% overnight. The sell-off wipes out a chunk of Monday\'s spike, the benchmark index\'s best day since March 2016.\nA number of large American companies with exposure to growing trade disputes reported their quarterly financial results Tuesday. Investors are worried that a slowing Chinese economy and an escalating trade war could pinch profits.\n\'The earnings are reflecting investors\' worst fears -- and it\'s exacerbating the selling,\' said Michael Arone, chief investment strategist at State Street Global Advisors.\n3M (MMM) shares plunged 8% after the maker of Post-it Notes reported a dip in sales and weaker-than-expected profits. Worse, the Dow component downgraded its earnings forecast for the year.\nCaterpillar (CAT), a closely-watched barometer of global growth, tumbled 9% as the maker of construction and mining equipment\'s record third-quarter profit was overshadowed by disappointing guidance. Caterpillar, also a member of the Dow, warned of \'higher material and freight costs, including tariffs.\'\nHarley-Davidson (HOG) shares lost 5% after posting a 13% plunge in US sales due to \'weakness\' in the market. It was Harley\'s biggest sales slump in eight years, Bloomberg News reported. The company, which plans to shift some manufacturing overseas in response to the threat of tariffs, also warned tariffs will increase costs by up to $48 million this year.\nThe results highlight lingering worries about whether the US economy and stock market can continue to grow rapidly.\n\'How long is this going to last?\' asked Luschini. \'Companies that only match earnings get punished. And ones that miss expectations get outright slayed.\'\nBut the news wasn\'t all gloom-and-doom from Corporate America. McDonald\'s shares spiked 7% after saying earnings and sales declined less than feared.\nUnited Technologies (UTX), another major global company, raised its outlook. And Verizon said it grew profit and revenue more than investors anticipated.\nOverall, Corporate America is still minting a ton of money thanks to the strong economy and tax cuts. S&P 500 companies are expected to grow per-share profits by nearly 20% this quarter, according to FactSet. And the vast majority of companies reporting results have beaten expectations.\nHowever, investors are bracing for a slowdown. S&P 500 profits are expected to decelerate to 16.5% in the fourth quarter and 6.8% in the second quarter, according to FactSet.\n\'Everyone sees that the rate of earnings growth is slowing. That becomes problematic,\' said State Street\'s Arone.\nGlobal growth concerns also weighted on the commodity markets. US oil prices tumbled nearly 3% to about $67.50 a barrel, pressuring energy stocks. Copper slid more than 1%.\nOverseas markets were sharply lower Tuesday. Hong Kong\'s Hang Seng index fell 3% in trading there, and Japan\'s Nikkei fell almost as much. The Dax in Germany was down 2%.'
    };

    const EXAMPLE_RESPONSE_V1_SUMMARIZE = {
        'summary': 'Dow drops as many as 549 points or 2%. Caterpillar and 3M reinforced ongoing concerns about how long blockbuster profits can last, especially given tariffs and rising costs. Dow was recently down about 400 points.',
        'summarySentences': [
            'dow drops as many as 549 points or 2 %.',
            'caterpillar and 3m reinforced ongoing concerns about how long blockbuster profits can last, especially given tariffs and rising costs.',
            'dow was recently down about 400 points.'
        ]
    };

    const EXAMPLE_REQUEST_V2_TAG = {
        'text': 'Allianz Trade predicts up to $135bn of combined lost global exports in 2025 and 2026 based on a ‘contained trade war’, where the US hikes tariffs against China to 25% on half of non-critical US imports and raises 5% tariffs on the rest of the world, excluding Canada, Mexico and critical goods.',
        'tagModels': ['iptc'],
        'languageCode': 'en',
        'maxTags': 3,
        'tagThresholdPositive': 0.2
    };

    const EXAMPLE_RESPONSE_V2_TAG = {
        'tagResults' : [
           {
              'model' : 'iptc',
              'tags' : [
                 {
                    'code' : '11000000',
                    'details' : {
                       'codePath' : '11000000',
                       'namePath' : 'politics'
                    },
                    'name' : 'politics',
                    'score' : 0.638
                 },
                 {
                    'code' : '20000384',
                    'details' : {
                       'codePath' : '04000000/20000344/20000346/20000384',
                       'namePath' : 'economy, business and finance/economy/macro economics/tariff'
                    },
                    'name' : 'tariff',
                    'score' : 0.608
                 },
                 {
                    'code' : '20000366',
                    'details' : {
                       'codePath' : '04000000/20000344/20000346/20000366',
                       'namePath' : 'economy, business and finance/economy/macro economics/exports'
                    },
                    'name' : 'exports',
                    'score' : 0.605
                 }
              ]
           }
        ]
     };

    const EXAMPLE_RESPONSE_V1_USERINFO = {
        'accountEnabled': true,
        'actualIntervalRequests': 3,
        'createDate': '2017-10-02T15:57:40Z',
        'expirationDate': '2038-01-01T00:00:00Z',
        'id': 'user@acme.com',
        'intervalSecondsRemaining': 34,
        'permissions': {
            'GDM': [
                'ihs'
            ],
            'SUML': [
                'News',
                'News-Base',
                'News-Eval',
                'TextRank'
            ],
            'endpoints': [
                '/api/v1/summarize',
                '/api/v1/convert-doc',
                '/api/v1/correct-text',
                '/api/v1/detect-language',
                '/api/v1/detect-languages',
                '/api/v1/doc-sentiment',
                '/api/v1/query-parser',
                '/api/v2/trit-enrich',
                '/api/v1/authenticate',
                '/api/v1/location-finder',
                '/api/v2/trit-sentiment',
                '/api/v1/enrich',
                '/api/v1/userinfo',
                '/api/v2/enrich',
                '/api/v2/entities'
            ],
            'entities': [
                'ORGANIZATION/COMPANY/TICKER',
                'THING/CHEMICAL',
                'URI',
                'DATETIME_RANGE',
                'MEASUREMENT',
                'DATETIME',
                'ORGANIZATION/SPORTS',
                'THING/LEGAL',
                'THING/EVENT',
                'THING/FACILITY',
                'LOCATION',
                'MONEY',
                'PHONE',
                'THING/MEDICAL',
                'THING/TECHNOLOGY',
                'ORGANIZATION',
                'ORGANIZATION/GOVERNMENT',
                'ORGANIZATION/NEWS',
                'TWITTER',
                'ACRONYM',
                'NATIONALITY',
                'ORGANIZATION/PERFORMING',
                'ORGANIZATION/COMPANY',
                'ORGANIZATION/CRIMINAL',
                'ORGANIZATION/EDUCATIONAL',
                'ORGANIZATION/TRUST',
                'PERSON',
                'THING',
                'THING/FINANCIAL',
                'THING/PRODUCT',
                'EMAIL',
                'GEO',
                'IPV4',
                'ORGANIZATION/FUND',
                'ORGANIZATION/SOCIALMEDIA'
            ],
            'features': [
                'EntityUpdate',
                'Tags',
                'TopicVector',
                'EntityCreate',
                'EntityDelete',
                'EntityRead',
                'EntitySentiment',
                'KeyPhrases',
                'Disambiguation',
                'DocumentSentiment'
            ],
            'language': [
                'nl',
                'ru',
                'ar',
                'en',
                'es',
                'fr'
            ],
            'sentimentModels': [
                'financial3',
                'news3'
            ],
            'tagging': [
                'dauTermStore'
            ],
            'taggingModels': [
                'dau',
                'news'
            ]
        },
        'rateIntervalRequests': 500,
        'rateIntervalSeconds': 60
    };

    const EXAMPLE_REQUEST_V2_ENRICH = {
        'text': 'Donald Trump congratulates Uhuru Kenyatta on win. Trump congratulates the people of Kenya on the successful conclusion of elections, and President Uhuru Kenyatta on his re-election.',
        'languageCode': 'en',
        'disambiguate': true,
        'mentions': true,
        'entities': ['*']
    };

    const EXAMPLE_RESPONSE_V2_ENRICH = {
        'entities': [
            {
                'attributes': {
                    'firstName': 'DONALD',
                    'gender': 'M',
                    'lastName': 'TRUMP'
                },
                'count': 2,
                'disambiguated': {
                    'id': '2938437633'
                },
                'label': 'Donald Trump',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.6646634597249503,
                        'extractedText': 'Donald Trump',
                        'extractionConfidence': 0.999692464111,
                        'position': [
                            0,
                            12
                        ]
                    },
                    {
                        'disambiguationConfidence': 0.6800360993068499,
                        'extractedText': 'Trump',
                        'extractionConfidence': 0.945626695189,
                        'position': [
                            50,
                            55
                        ]
                    }
                ],
                'type': 'PERSON'
            },
            {
                'attributes': {
                    'firstName': 'UHURU',
                    'gender': 'M',
                    'lastName': 'KENYATTA'
                },
                'count': 2,
                'disambiguated': {
                    'id': '248429215745'
                },
                'label': 'Uhuru Kenyatta',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.7542109532868398,
                        'extractedText': 'Uhuru Kenyatta',
                        'extractionConfidence': 0.945592033671,
                        'position': [
                            27,
                            41
                        ]
                    },
                    {
                        'disambiguationConfidence': 0.7642787909878239,
                        'extractedText': 'Uhuru Kenyatta',
                        'extractionConfidence': 0.937643819428,
                        'position': [
                            147,
                            161
                        ]
                    }
                ],
                'type': 'PERSON'
            },
            {
                'count': 1,
                'disambiguated': {
                    'id': '832153780224',
                    'location': {
                        'countryFips': 'KE',
                        'countryGenc2': 'KE',
                        'countryGenc3': 'KEN',
                        'countryGencCode': '404',
                        'countryLabel': 'Kenya',
                        'dsgFeatureClass': 'A',
                        'dsgFeatureCode': 'PCLI',
                        'latitude': 1,
                        'longitude': 38,
                        'population': 46050000
                    }
                },
                'label': 'Kenya',
                'mentions': [
                    {
                        'disambiguationConfidence': 0.999844,
                        'extractedText': 'Kenya',
                        'extractionConfidence': 0.93934,
                        'position': [
                            84,
                            89
                        ]
                    }
                ],
                'type': 'GEO'
            }
        ],
        'requestId': '3435f2d1-ee13-4ae1-844d-926bbfc42d9e',
        'text': 'Donald Trump congratulates Uhuru Kenyatta on win. Trump congratulates the people of Kenya on the successful conclusion of elections, and President Uhuru Kenyatta on his re-election.'
    };

    const EXAMPLE_RESPONSE_V2_ENTITIES1 = {
        'attendedSchools': [
            {
                'finchId': 1454828814338,
                'label': 'Princeton University',
                'permId': 4297381328
            },
            {
                'finchId': 1318348193794,
                'label': 'Miami Palmetto High School'
            }
        ],
        'birthDate': '1964-01-13',
        'birthLocation': {
            'admin1Label': 'New Mexico',
            'countryLabel': 'United States of America',
            'latitude': 35.12,
            'longitude': -106.62,
            'name': 'Albuquerque',
            'postalCode': '87196'
        },
        'birthName': 'Jeffrey Preston Jorgensen',
        'categories': [
            'american computer businesspeople',
            'people in the space industry',
            'american technology chief executives',
            'american libertarians',
            '1964 births',
            'tau beta pi',
            'american investors',
            'american hedge fund managers',
            'american billionaires',
            'online retailer founders',
            'princeton university alumni 198089',
            'princeton university alumni 1980 1989',
            'amazoncom people',
            'businesspeople from new mexico',
            'phi beta kappa',
            'fellows of the american academy of arts and sciences',
            'the washington post publishers',
            'people from albuquerque new mexico',
            'american mass media owners',
            'living people',
            'ted speakers',
            'american chairmen of corporations',
            'american technology company founders',
            'blue origin',
            '21st century american businesspeople',
            'american people of scandinavian descent',
            'amazon com people',
            'american adoptees',
            'american internet company founders',
            'american computer scientists',
            'princeton university alumni',
            'american online retailer founders',
            'businesspeople from albuquerque new mexico',
            'life extensionists',
            'phi beta kappa members',
            '21st-century american businesspeople',
            'amazon.com people',
            'businesspeople from albuquerque, new mexico',
            'blue origin people',
            'american aerospace businesspeople',
            'american philanthropists',
            'space advocates'
        ],
        'citizenshipCountries': [
            'United States of America'
        ],
        'contextKeywords': [
            '1000000000 number',
            '1997',
            '1997 equity',
            '1 academies',
            '1 academies fund',
            '1 families',
            '1 families fund',
            '1click',
            '2011',
            '2011 bilderberg',
            '2013',
            '2013 bilderberg conference',
            '2018',
            '2018 axel',
            '2018 axel springer',
            '21stcentury american businesspeople',
            '43 things',
            'a9com',
            'abebooks',
            'academies',
            'address',
            'advisory',
            'advisory board',
            'aerospace',
            'aerospace company',
            'aerospace company blue',
            'alexa internet',
            'also',
            'amapedia',
            'amazon appstore',
            'amazon breakthrough novel award',
            'amazon china',
            'amazon cloud drive',
            'amazon cloudfront',
            'amazon dash',
            'amazon digital game store',
            'amazon dynamodb',
            'amazon echo',
            'amazon elastic block store',
            'amazon elastic compute cloud',
            'amazon fire tv',
            'amazon fishbowl',
            'amazon flexible payments service',
            'amazon glacier',
            'amazon instant video',
            'amazon kindle',
            'amazon light',
            'amazon locker',
            'amazon machine image',
            'amazon marketplace',
            'amazon mechanical turk',
            'amazon music',
            'amazon payments',
            'amazon prime',
            'amazon product advertising api',
            'amazon publishing',
            'amazon relational database service',
            'amazon s3',
            'amazon silk',
            'amazon simple email service',
            'amazon simple queue service',
            'amazon simpledb',
            'amazon standard identification number',
            'amazon studios',
            'amazon tax',
            'amazon vine',
            'amazon virtual private cloud',
            'amazon warehouse',
            'amazon web',
            'amazoncom',
            'amazoncom controversies',
            'amazonfresh',
            'amazons best books of the year',
            'american',
            'american technology',
            'analytics',
            'apollo 11',
            'apple inc',
            'arm',
            'ash carter',
            'askville',
            'atomic',
            'attended',
            'audiblecom',
            'august',
            'australia',
            'award',
            'axel',
            'axel springer',
            'axel springer award',
            'bachelor of science in engineering',
            'bankers',
            'became',
            'best',
            'bezos d',
            'bezos dzhieff',
            'bezos dzhieffri',
            'bezos dzhiefri',
            'bezos expeditions',
            'bezoss',
            'biezos dzhieff',
            'biezos dzhieffri',
            'bike',
            'bike shop',
            'bilderberg',
            'bilderberg conference',
            'billionaires',
            'billionaires index',
            'bloomberg billionaires',
            'bloomberg billionaires index',
            'blue',
            'blue origin test',
            'board',
            'boom',
            'bownsville',
            'bownsville herald',
            'box office mojo',
            'brian',
            'brian krueger',
            'brian mcbride director',
            'brian valentine',
            'business',
            'business insider',
            'business magnate',
            'business review',
            'businesspeople',
            'businessperson',
            'campaign',
            'campaign finance',
            'capital',
            'capital fund',
            'capital vehicle',
            'carbonado java',
            'care',
            'care centers',
            'carnegie',
            'cdnow',
            'centers',
            'chain',
            'chain routes',
            'channels',
            'childhood',
            'christopher north businessman',
            'clock of the long now',
            'cloud',
            'cloud infrastructure',
            'college',
            'college scholarship',
            'columbia',
            'comixology',
            'commercialization',
            'commission',
            'committee',
            'company blue',
            'company blue origin',
            'company distribution',
            'computer',
            'confederation',
            'conference',
            'council',
            'country',
            'country singer',
            'country singer george',
            'court',
            'cspan',
            'cuban people',
            'culture',
            'customer',
            'd bezos',
            'dallas',
            'dallas morning news the',
            'darpa',
            'database',
            'david ho scientist',
            'david risher',
            'day',
            'day 1',
            'day 1 academies',
            'day 1 families',
            'day care',
            'defense',
            'defense advanced research projects agency',
            'defense innovation',
            'defense innovation advisory',
            'degrees',
            'department of defense',
            'depletion',
            'diaperscom',
            'digital photography review',
            'distribution',
            'district',
            'donald e graham',
            'double helix games',
            'dynamo storage system',
            'dzhieff bezos',
            'dzhieff biezos',
            'dzhieffri bezos',
            'dzhieffri biezos',
            'dzhiefri bezos',
            'early',
            'earth',
            'ecommerce',
            'economy',
            'editorial',
            'education',
            'electrical engineering and computer science',
            'elementary',
            'elementary school',
            'email',
            'employees',
            'endlesscom',
            'energy',
            'engineering',
            'equity',
            'equity offering',
            'executive',
            'exploration',
            'f w de klerk',
            'face',
            'face recognition',
            'families',
            'finance records',
            'fire',
            'fire os',
            'fire phone',
            'first',
            'flight',
            'food',
            'food economy',
            'forbes list of billionaires',
            'forbes magazine',
            'forbes wealth',
            'forbes wealth index',
            'fortune magazine',
            'founded',
            'founders',
            'fund',
            'galactic',
            'game',
            'game simulations',
            'goodreads',
            'graubnden',
            'group',
            'group new',
            'group new food',
            'gurupa',
            'harvard',
            'harvard business',
            'headquarters',
            'headquarters tour',
            'health',
            'healthcare',
            'hedge',
            'hedge fund',
            'herald',
            'high',
            'high school',
            'holdings',
            'home',
            'honolulu staradvertiser',
            'honorary doctorate',
            'human spaceflight',
            'immigrants',
            'imperialistic',
            'imperialistic business',
            'inc',
            'including',
            'income',
            'income tax',
            'increase',
            'index',
            'infant bed',
            'infrastructure',
            'infrastructure services',
            'innovation',
            'innovation advisory',
            'innovation advisory board',
            'integrated authority file',
            'interests',
            'international',
            'international standard book number',
            'international trade',
            'international trade union',
            'internet',
            'internet movie database',
            'investments',
            'invitation',
            'jeff besos',
            'jeff jorgensen',
            'jeff preston bezos',
            'jeffery bezos',
            'jeffrey bezos',
            'jeffrey khalil jorgensen',
            'jeffrey p bezos',
            'jeffrey pbezos',
            'jeffrey preston jeff bezos',
            'jersey',
            'jobs',
            'july',
            'jungleecom',
            'kindle',
            'kindle fire',
            'kindle fire hd',
            'kindle fire hdx',
            'kingdom',
            'known',
            'lab126',
            'labor',
            'lasalle county',
            'leadership',
            'lech wa sa',
            'lexcycle',
            'library of congress control number',
            'librarything',
            'life',
            'liquavista',
            'list',
            'listing',
            'livingsocial',
            'logistik hall of fame',
            'lovefilm',
            'mackenzie besos',
            'magazine',
            'market',
            'meetings',
            'mellon',
            'mexico',
            'miami palmetto',
            'miami palmetto high',
            'micromanager',
            'miguel mike bezos',
            'mike bezos',
            'million',
            'minneapolis startribune',
            'mobipocket',
            'mohammed bin salman',
            'morning',
            'named',
            'narendra modi',
            'nash',
            'national',
            'national diet library',
            'national merit scholarship program',
            'nelson mandela',
            'new food',
            'new shepard space',
            'new south wales',
            'news',
            'newspace',
            'newspaper',
            'night',
            'nndb',
            'number',
            'oaks',
            'oaks elementary',
            'oaks elementary school',
            'obidos software',
            'online',
            'opportunities',
            'origin',
            'origin test',
            'origin test flight',
            'outlets',
            'outstripped',
            'owner',
            'palmetto',
            'palmetto high',
            'palmetto high school',
            'paul allen',
            'peace makers',
            'people from medina washington',
            'perfect 10 inc v amazoncom inc',
            'person',
            'personal',
            'personal computer',
            'philosophy',
            'piece',
            'planetall',
            'pope john paul ii',
            'practices',
            'prioritize',
            'private spaceflight',
            'profile',
            'program',
            'quill corp v north dakota',
            'ram shriram',
            'recognition',
            'records',
            'reflexive entertainment',
            'report',
            'resource',
            'retailer',
            'review',
            'rick dalzell',
            'rights',
            'river',
            'river oaks',
            'river oaks elementary',
            'river oaks elementary houston',
            'rocket',
            'rocketdyne f1',
            'room',
            'routes',
            'ruhollah khomeini',
            's1c',
            'said',
            'sales',
            'saturn v',
            'scale',
            'scholarship',
            'scholarship fund',
            'school',
            'science',
            'science training',
            'science training program',
            'sellaband',
            'senior',
            'service',
            'services',
            'services arm',
            'sharan burrow',
            'shawn mccoy',
            'shelfari',
            'shelters',
            'shepard space',
            'shepard space vehicle',
            'shop',
            'shop owner',
            'silver knight awards',
            'simulations',
            'singer',
            'singer george',
            'singer george strait',
            'slatecom',
            'software',
            'songza',
            'south',
            'space vehicle',
            'spaceflight',
            'spaceflight startup',
            'spent',
            'springer',
            'springer award',
            'st moritz',
            'stacy palmer',
            'startribune',
            'startup',
            'startup company',
            'state',
            'state income',
            'state income tax',
            'states',
            'statistically improbable phrases',
            'street',
            'strikes',
            'student',
            'student science',
            'student science training',
            'students for the exploration and development of space',
            'style',
            'supply',
            'supply chain',
            'supreme',
            'syst me universitaire de documentation',
            'tail',
            'tasked',
            'tax',
            'technology entrepreneur',
            'ted conference',
            'test',
            'test flight',
            'the',
            'the book depository',
            'the business council',
            'the dallas morning news',
            'the economist',
            'the new york times',
            'the seattle times',
            'tickets',
            'time person of the year',
            'times',
            'times piece',
            'tom szkutak',
            'tony hsieh',
            'tour',
            'tour invitation',
            'trade union',
            'trade union confederation',
            'training',
            'training program',
            'travel',
            'trust',
            'twitchtv',
            'undocumented',
            'union',
            'union confederation',
            'united',
            'united states atomic energy commission',
            'university',
            'us atomic energy commission',
            'us government',
            'us news world report',
            'us supreme court',
            'valladolid',
            'valladolid spain',
            'vehicle',
            'venture',
            'venture capital',
            'video',
            'video game',
            'villafrechos',
            'virgin',
            'virtual international authority file',
            'wales',
            'warehouse',
            'warehouse workers',
            'warren buffet',
            'washington referendum 74',
            'washington state',
            'washington state income',
            'wealth',
            'wealth index',
            'weather',
            'web',
            'web services',
            'web services arm',
            'werner vogels',
            'wife',
            'wired magazine',
            'wired website',
            'withoutabox',
            'woot',
            'worked',
            'workers',
            'workplace',
            'world',
            'worldcat',
            'yasser arafat',
            'year',
            'years',
            'yitzhak rabin',
            'york',
            'york times',
            'york times piece',
            'zappos'
        ],
        'description': 'Jeffrey Preston Bezos (né Jorgensen; born January 12, 1964) is an American technology entrepreneur, investor, and philanthropist. He is the founder, chairman, CEO, and president of Amazon.\nBezos was born in Albuquerque, New Mexico, and raised in Houston, Texas. He graduated from Princeton University in 1986 with degrees in electrical engineering and computer science. He worked on Wall Street in a variety of related fields from 1986 to early 1994. He founded Amazon in late 1994 on a cross-country road trip from New York City to Seattle. The company began as an online bookstore and has expanded to a variety of products and services, including video and audio streaming. It is currently the world\'s largest online sales company, as well as the world\'s largest provider of cloud infrastructure services via its Amazon Web Services arm.',
        'employers': [
            {
                'finchId': 1454825144322,
                'label': 'Amazon',
                'permId': 4295905494
            },
            {
                'label': 'Bankers Trust'
            },
            {
                'finchId': 1319592067074,
                'label': 'D. E. Shaw & Co.'
            }
        ],
        'familyNames': [
            'Bezos',
            'Jorgensen'
        ],
        'genders': [
            'male'
        ],
        'givenNames': [
            'Preston',
            'Jeffrey'
        ],
        'heldPositions': [
            'chairperson',
            'chief executive officer',
            'president'
        ],
        'id': '358999261185',
        'imageUrls': [
            'https://upload.wikimedia.org/wikipedia/commons/6/6c/Jeff_Bezos_at_Amazon_Spheres_Grand_Opening_in_Seattle_-_2018_%2839074799225%29_%28cropped%29.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/3/33/Jeff_Bezos_2016.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/6/6b/Jeff_Bezos%27_iconic_laugh.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/7/7a/Jeff_Bezos_2005.jpg'
        ],
        'label': 'Jeff Bezos',
        'languageFields': [
            {
                'description': 'Jeffrey Preston Bezos (né Jorgensen; January 12, 1964) is an American technology entrepreneur, investor, and philanthropist. He is best known as the founder, chairman, and CEO of Amazon.\nBezos was born in Albuquerque, New Mexico and raised in Houston, Texas. He graduated from Princeton University in 1986 with degrees in electrical engineering and computer science. He worked on Wall Street in a variety of related fields from 1986 to early 1994. He founded Amazon in late 1994 on a cross-country road trip from New York City to Seattle. The company began as an online bookstore and has expanded to a variety of products and services, including video and audio streaming. It is currently the world\'s largest online sales company, as well as the world\'s largest provider of cloud infrastructure services via its Amazon Web Services arm.',
                'label': 'Jeff Bezos',
                'langCode': 'en',
                'urls': [
                    'https://en.wikipedia.org/wiki/Jeff_Bezos'
                ]
            },
            {
                'description': 'Amerikaans ondernemer',
                'label': 'Jeff Bezos',
                'langCode': 'nl',
                'urls': [
                    'https://nl.wikipedia.org/wiki/Jeff_Bezos'
                ]
            },
            {
                'description': 'amerikanischer Unternehmer',
                'label': 'Jeff Bezos',
                'langCode': 'de',
                'urls': [
                    'https://de.wikipedia.org/wiki/Jeff_Bezos'
                ]
            },
            {
                'description': 'Empresario Estadounidense',
                'label': 'Jeff Bezos',
                'langCode': 'es',
                'urls': [
                    'https://es.wikipedia.org/wiki/Jeff_Bezos'
                ]
            },
            {
                'description': 'entrepreneur américain, fondateur et dirigeant d\'Amazon',
                'label': 'Jeff Bezos',
                'langCode': 'fr',
                'urls': [
                    'https://fr.wikipedia.org/wiki/Jeff_Bezos'
                ]
            },
            {
                'description': 'Empresário, fundador e CEO americano da Amazon.com, Inc.',
                'label': 'Jeff Bezos',
                'langCode': 'pt',
                'urls': [
                    'https://pt.wikipedia.org/wiki/Jeff_Bezos'
                ]
            },
            {
                'description': 'Предприниматель',
                'label': 'Безос, Джеффри',
                'langCode': 'ru',
                'urls': [
                    'https://ru.wikipedia.org/wiki/Безос,_Джефф'
                ]
            }
        ],
        'memberOf': [
            'National Academy of Engineering',
            'American Academy of Arts and Sciences',
            'Phi Beta Kappa Society'
        ],
        'nameVariations': [
            'Jeff Preston Bezos',
            'Jeffrey Preston Bezos',
            'Jeffrey Preston Jorgensen',
            'Jeffrey Preston \'Jeff\' Bezos',
            'Jeff Bezos',
            'nash holdings',
            'jeff besos',
            'jeffrey p bezos',
            'jeffrey pbezos',
            'jeffrey bezos',
            'bezos expeditions',
            'jeffrey khalil jorgensen'
        ],
        'numberOfChildren': 4,
        'occupations': [
            'computer scientist',
            'entrepreneur'
        ],
        'ownedOrganizations': [
            {
                'finchId': 1454825144322,
                'label': 'Amazon',
                'permId': 4295905494
            },
            {
                'finchId': 1454860337154,
                'label': 'The Washington Post'
            },
            {
                'label': 'Nash Holdings LLC'
            }
        ],
        'prominence': 0.8231,
        'residenceLocation': {
            'admin1Label': 'Miano',
            'countryLabel': 'Italy',
            'latitude': 42.61906,
            'longitude': 13.70705,
            'name': 'Miano'
        },
        'spousesNames': [
            'Mackenzie Bezos (1992)'
        ],
        'twitterNames': [
            'jeffbezos'
        ],
        'type': 'PERSON',
        'urls': [
            'https://en.wikipedia.org/wiki/Jeff_Bezos',
            'https://www.wikidata.org/wiki/Q312556',
            'https://twitter.com/jeffbezos',
            'https://www.instagram.com/jeffbezos',
            'https://g.co/kg/m/011z69',
            'https://www.quora.com/topic/Jeff-Bezos',
            'https://www.britannica.com/biography/Jeff-Bezos',
            'https://en.wikipedia.org/wiki/Jeff_Besos',
            'http://www.amazon.com',
            'http://dbpedia.org/resource/Jeff_Bezos'
        ],
        'version': '20.2.2'
    };

    const EXAMPLE_RESPONSE_V2_ENTITIES2 = {
        'categories': [
            'companies based in seattle washington',
            'internet companies of the united states',
            'american brands',
            'cloud computing providers',
            '1994 establishments in washington state',
            'arts and crafts retailers',
            'ios software',
            'companies established in 1994',
            'online music stores',
            'companies based in washington',
            'webby award winners',
            'bookstores of the united states',
            'organisation',
            'online companies',
            'book selling websites',
            'e book suppliers',
            'companies listed on nasdaq',
            'multinational companies headquartered in the united states',
            'companies in the nasdaq 100 index',
            'amazoncom',
            'review websites',
            '1994 establishments in washington',
            'universal windows platform apps',
            'software companies based in washington',
            'internet properties established in 1994',
            'company',
            'self publishing companies',
            'mobile phone manufacturers',
            'software companies based in washington state',
            'companies initially financed with venture capital',
            'commerce websites',
            'amazon com',
            'american websites',
            'android operating system software',
            'software companies based in seattle',
            'companies based in washington state',
            'online retailers of the united states',
            'online retail companies of the united states',
            '3d publishing',
            'american companies established in 1994',
            'android',
            'online marketplaces',
            'retail companies established in 1994',
            'software companies established in 1994',
            'technology companies established in 1994',
            'tvos software'
        ],
        'chairPersons': [
            'Jeff Bezos'
        ],
        'chiefExecutiveOfficers': [
            'Jeff Bezos'
        ],
        'ciks': [
            '0001018724'
        ],
        'contextKeywords': [
            '1 washington park',
            '1click',
            '2004 indian ocean earthquake and tsunami',
            '20 products',
            '21st century fox',
            '400 stores',
            '43 things',
            '4c',
            '4c media',
            '4fff n618',
            '60 minutes',
            'a2z',
            'a2z development',
            'a9com',
            'aashish gupta',
            'abebooks',
            'absolute',
            'absolute webstores',
            'academic journal publishing reform',
            'accenture',
            'access books',
            'acer inc',
            'aci gift cards',
            'activision blizzard',
            'administration',
            'adobe acrobat',
            'adobe digital editions',
            'adobe indesign',
            'adobe systems',
            'advanced micro devices',
            'affiliate program',
            'agfagevaert',
            'ahmedabad',
            'air',
            'air conditioning',
            'air drone',
            'air freight',
            'air patriots',
            'akamai technologies',
            'al',
            'alain',
            'alain moni',
            'alain monie',
            'alaska airlines',
            'alcatel mobile phones',
            'alcatellucent',
            'aldiko',
            'alex ereader',
            'alexion pharmaceuticals',
            'alibaba',
            'alibaba group',
            'altera',
            'am rica m vil',
            'amapedia',
            'amazon+india',
            'amazon affiliate program',
            'amazon app',
            'amazon appstore',
            'amazon breakthrough novel award',
            'amazon china',
            'amazon cloud drive',
            'amazon cloudfront',
            'amazon dash',
            'amazon dash button',
            'amazon deutschland',
            'amazon digital game store',
            'amazon digital services llc',
            'amazon dynamodb',
            'amazon echo',
            'amazon elastic block store',
            'amazon elastic compute cloud',
            'amazon elastic compute cloud amazon',
            'amazon fire tv',
            'amazon fishbowl',
            'amazon flexible payments service',
            'amazon fulfillment centers',
            'amazon germany',
            'amazon glacier',
            'amazon home services',
            'amazon hq1',
            'amazon instant video',
            'amazon instant video german',
            'amazon instant video uk',
            'amazon key',
            'amazon kindle',
            'amazon lab126',
            'amazon leases space',
            'amazon light',
            'amazon locker',
            'amazon machine image',
            'amazon marketplace',
            'amazon mechanical turk',
            'amazon music',
            'amazon payments',
            'amazon prime pantry',
            'amazon prime pantry amazonfresh',
            'amazon prime subscribers',
            'amazon product advertising api',
            'amazon product link',
            'amazon publishing',
            'amazon records data',
            'amazon relational database service',
            'amazon replenishment service',
            'amazon river',
            'amazon robotics',
            'amazon s3',
            'amazon silk',
            'amazon simple email service',
            'amazon simple queue service',
            'amazon simple queue service amazon',
            'amazon simple storage service amazon',
            'amazon simpledb',
            'amazon smile',
            'amazon standard identification number',
            'amazon studios',
            'amazon studios amazon studios',
            'amazon tax',
            'amazon unbox',
            'amazon video',
            'amazon vine',
            'amazon virtual private cloud',
            'amazoncom controversies',
            'amazons best books of the year',
            'america',
            'american',
            'american airlines group',
            'american red cross',
            'amgen',
            'amie',
            'amie street',
            'amsterdam',
            'analog devices',
            'andhra',
            'andhra pradesh',
            'andrew',
            'andrew crawford',
            'android operating system',
            'android software',
            'andy',
            'andy warhol',
            'annacis island',
            'annapurna',
            'annapurna labs',
            'aol',
            'aozora bunko',
            'api',
            'apoorva mehta',
            'apparel',
            'apparel company bonobos',
            'apple accessories',
            'apple tv',
            'application programming interface',
            'applied materials',
            'aquafadas',
            'asia',
            'askville',
            'asphalt 8',
            'asset',
            'association',
            'asus',
            'atlanta',
            'atlantis word processor',
            'atmosol',
            'atos',
            'att',
            'att mobility',
            'au',
            'audi',
            'audible',
            'audible com',
            'audiblecom',
            'audio',
            'audiobook',
            'austin texas',
            'australia',
            'autodesk',
            'automatic data processing',
            'automation',
            'avago technologies',
            'avaya',
            'avenel new jersey',
            'aviation',
            'badenwurttemberg',
            'baen free library',
            'baidu',
            'baltimore',
            'baltimore maryland',
            'bangalore',
            'bansal',
            'barnaby',
            'barnaby dorfman',
            'barnaby dorfman hulu',
            'barnes',
            'barnes noble nook',
            'basics',
            'basics toys',
            'batman',
            'battery electricity',
            'bavaria',
            'bbc news',
            'bbeb',
            'beacon hill seattle',
            'bebe',
            'bebe stores',
            'bed bath beyond',
            'bedfordshire',
            'beijing',
            'bell canada',
            'bellevue',
            'bellevue washington',
            'benefit cosmetics',
            'berlin',
            'bharti airtel',
            'big fish games',
            'biljon',
            'bing',
            'bing gordon',
            'binny bansal',
            'biogen idec',
            'bittorrent',
            'bl',
            'blackberry limited',
            'blio',
            'bloomberg businessweek',
            'bloomberg lp',
            'blu rays',
            'bluefire reader',
            'bluemel',
            'bluray',
            'body labs',
            'boignysurbionne',
            'boise idaho',
            'book',
            'book depository',
            'bookfindercom',
            'bookstore',
            'booktrack',
            'boox',
            'booz allen hamilton',
            'born this way album',
            'bourgogne',
            'box office mojo',
            'br',
            'brad stone journalist',
            'braille ebook',
            'brampton ontario',
            'brandenburg',
            'bratislava',
            'brazil',
            'brett',
            'brett witt',
            'brett witt wikinvest',
            'brian krueger',
            'brian mcbride director',
            'brian valentine',
            'brick and mortar',
            'brieselang',
            'brilliance',
            'brilliance audio brilliance audio',
            'british',
            'british columbia',
            'broadcom',
            'brooklyn new york',
            'bros',
            'bt global services',
            'bt group',
            'burrows',
            'business',
            'business insider',
            'business model',
            'business plan',
            'button',
            'buy',
            'byers',
            'byte',
            'c h robinson worldwide',
            'ca',
            'ca inc',
            'caci',
            'cadabra inc',
            'cagliari',
            'calibre software',
            'calligra suite',
            'cambridge',
            'cambridge massachusetts',
            'campbellsville kentucky',
            'canada',
            'canon inc',
            'cape',
            'cape town',
            'capgemini',
            'carbonado java',
            'carlisle pennsylvania',
            'carolina',
            'carrollton texas',
            'castel san giovanni',
            'catamaran corporation',
            'caufield',
            'cdnow',
            'cebu',
            'celestica',
            'celgene',
            'center',
            'centers',
            'central',
            'central bedfordshire',
            'centurylink',
            'cerner',
            'cgi group',
            'chakrabarti',
            'chambersburg pennsylvania',
            'charleston south carolina',
            'charleston tennessee',
            'charlie',
            'charlie cheever',
            'charter communications',
            'chattanooga tennessee',
            'check point',
            'checkout lines',
            'cheever',
            'chengdu',
            'chennai',
            'chester virginia',
            'chiba',
            'chiba prefecture',
            'chicago illinois',
            'chicago tribune',
            'china mobile',
            'china telecom',
            'china unicom',
            'choice in ecommerce',
            'chris',
            'chris pinkham',
            'christmas holiday season',
            'christopher north businessman',
            'chromecast',
            'cisco systems',
            'citrix systems',
            'claude',
            'claude monet',
            'cloud',
            'cloud computing',
            'cnet',
            'cockfight',
            'codesgoodyear',
            'coffeyville kansas',
            'cognizant',
            'columbia',
            'com',
            'comcast',
            'comic book archive',
            'comics',
            'comixology',
            'commission',
            'communications',
            'compact disc',
            'compal electronics',
            'companies',
            'companies in the nasdaq100 index',
            'comparison of ebook formats',
            'comparison of ebook readers',
            'comparison of ios ebook reader software',
            'compute',
            'computer hardware',
            'computer sciences corporation',
            'computer software',
            'computer world',
            'comunidad de madrid',
            'concord north carolina',
            'connecticut',
            'consulting',
            'content removal',
            'contiguous united states',
            'contract workers',
            'convenience stores',
            'convergence',
            'convergence corporation',
            'cooler',
            'coppell texas',
            'cork',
            'cork city',
            'corporation',
            'cosmetics',
            'costco',
            'council',
            'country code',
            'crawford',
            'credit card account',
            'crm software',
            'crosby',
            'cross',
            'crymlyn',
            'crymlyn burrows',
            'cupertino california',
            'curbside pickup locations',
            'customer buyer behavior',
            'cutler',
            'cutler pickering',
            'cybook',
            'd e shaw co',
            'daito osaka',
            'dakota',
            'dallas texas',
            'darigold',
            'darren',
            'darren vengroff',
            'dash',
            'data',
            'data centers',
            'data mining',
            'dave',
            'dave schappell',
            'davenport florida',
            'david risher',
            'dc',
            'deal of the day',
            'defamation',
            'delaware',
            'delivery',
            'delivery boy',
            'delivery service',
            'dell',
            'deloitte',
            'delta british columbia',
            'demand',
            'demeraramahaica',
            'deutsche telekom',
            'development',
            'dhl',
            'dhl express',
            'diana l bl',
            'diapers com',
            'diaperscom',
            'digest',
            'digital',
            'digital china',
            'digital distribution',
            'digital photography review',
            'digital reader 1000',
            'digital rights management',
            'directv',
            'discovery communications',
            'dish network',
            'distribution',
            'distribution centers',
            'district',
            'dog fighting',
            'dollar tree',
            'domain name',
            'doncaster',
            'doral florida',
            'dorfman',
            'dorr',
            'dorr alain moni',
            'dotcom bubble',
            'double helix games',
            'douglas',
            'douglas hofstadter',
            'downtown seattle building',
            'dpreviewcom',
            'draft amazon key',
            'dresden',
            'drone',
            'drop shippers',
            'drop shipping',
            'drugstorecom',
            'dublin',
            'dunfermline',
            'dupont',
            'dupont washington',
            'dvd',
            'dynamo storage system',
            'e commerce',
            'e ink',
            'earnings before interest and taxes',
            'east point georgia',
            'eastman kodak',
            'ebook',
            'ebook lending',
            'ebook reader',
            'ebook suppliers',
            'ecatalog',
            'ecommerce',
            'eddie bauer',
            'edinburgh',
            'edinburgh scotland asia india',
            'elastic',
            'elastic ip address',
            'electronic arts',
            'electronic publishing',
            'elonex ebook',
            'emc corporation',
            'emi',
            'emiliaromagna',
            'endlesscom',
            'engadget',
            'engine yard',
            'entertainment',
            'entourage edge',
            'entrepreneur',
            'epub',
            'equity finance',
            'ereader',
            'ericsson',
            'eslick',
            'eu',
            'europe',
            'evdo',
            'evi software',
            'exchange',
            'expedia',
            'expeditors international',
            'explore',
            'explore consulting',
            'express scripts',
            'faa',
            'faa federal aviation administration',
            'fast company magazine',
            'fastenal',
            'federal',
            'feedbooks',
            'fernley nevada',
            'fictionbook',
            'fife',
            'fillz',
            'financial times',
            'findory',
            'fire',
            'fire os',
            'fire phone',
            'fire tv',
            'fiscal year',
            'fiserv',
            'flepia',
            'flextronics',
            'flipkart',
            'fluid concepts',
            'fluid concepts and creative analogies',
            'food',
            'foodistacom',
            'for dummies',
            'forbes',
            'fort worth texas',
            'fortune 1000',
            'founded',
            'foxconn',
            'fr',
            'france',
            'freescale semiconductor',
            'fujitsu',
            'fulfillment',
            'fulfillment centers',
            'gafam',
            'gamasutra',
            'garmin',
            'george packer',
            'georgia',
            'geoworks',
            'gigaom',
            'gilead sciences',
            'gillis',
            'glenrothes',
            'globalfoundries',
            'golden globe awards',
            'goodyear arizona',
            'google play',
            'google play books',
            'gordon',
            'gourock',
            'gowebbaby',
            'graben bavaria',
            'grand forks north dakota',
            'graphiq',
            'green',
            'greg',
            'greg linden',
            'greg linden flipkart',
            'group',
            'guangdong',
            'guangxi',
            'guangxi zhuang',
            'guangzhou',
            'gujarat',
            'gupta',
            'gurgaon',
            'gurupa',
            'haerbin',
            'hale',
            'hampshire',
            'hanlin ereader',
            'hardcover',
            'harrisburg pennsylvania',
            'haryana',
            'hathitrust',
            'hazafon',
            'hazleton pennsylvania',
            'hcl technologies',
            'hebron kentucky',
            'heilongjiang',
            'hemel hempstead',
            'henry schein',
            'heredia',
            'hertfordshire',
            'hewlett',
            'hewlett packard',
            'hewlettpackard',
            'history of amazon',
            'history of amazon com',
            'hitachi consulting',
            'hitachi data systems',
            'hofstadter',
            'hokkaido',
            'holden',
            'holding',
            'home',
            'homegrocercom',
            'hp enterprise services',
            'hp software division',
            'htc',
            'http www amazon com',
            'huawei',
            'hulu',
            'humble',
            'humble texas',
            'huntington west virginia',
            'hurricane',
            'hurricane katrina',
            'hurricane sandy',
            'hussein',
            'hutchison asia telecommunications',
            'hybris company',
            'hyderabad',
            'hyderabad india',
            'hypertext transfer protocol',
            'ia i',
            'iacinteractivecorp',
            'iasi',
            'ibm',
            'ibm global services',
            'ibooks',
            'ibooks author',
            'ibooks store',
            'ichikawa chiba',
            'idaho',
            'iliad',
            'illinois',
            'illumina company',
            'imdb com inc',
            'inc',
            'incorporated',
            'indian arm',
            'indiana',
            'indianapolis indiana',
            'indra sistemas',
            'infibeam',
            'infineon technologies',
            'information technology',
            'informationweek',
            'infosys',
            'ingram',
            'ingram book',
            'ingram content group',
            'ingram micro',
            'initial public offering',
            'integrated authority file',
            'integrated microelectronics inc',
            'intel',
            'international digital publishing forum',
            'international standard book number',
            'internationalization and localization',
            'internet',
            'internet archive',
            'internet forum',
            'internet shopping mall',
            'intuit',
            'intuitive surgical',
            'inverclyde',
            'ireland',
            'iriver story',
            'irvine california',
            'israel',
            'issuu',
            'ivona',
            'ivona software',
            'jabil circuit',
            'jackson',
            'jadida',
            'jaipur',
            'jambool',
            'japan',
            'jason',
            'jason kilar',
            'jason olim',
            'java programming language',
            'jdcom',
            'jeff bezos quora',
            'jeff holden',
            'jeff lawson',
            'jeff lawson entrepreneur',
            'jeffersonville indiana',
            'jersey',
            'jersey marine',
            'jersey shore tv series',
            'jesse',
            'jesse robbins',
            'jetcom',
            'jewelry',
            'jiangsu',
            'jinan',
            'john ingram',
            'john r ingram businessman',
            'jones soda',
            'jos',
            'joyocom',
            'jp',
            'junglee com',
            'jungleecom',
            'juniper networks',
            'kansas',
            'karbonn mobiles',
            'karnataka',
            'katrina',
            'kaushalam',
            'kawagoe saitama',
            'kddi',
            'keith',
            'keith schorsch',
            'kennewick washington',
            'kenosha wisconsin',
            'kent washington',
            'kentucky',
            'keurig green mountain',
            'keyur',
            'keyur patel',
            'kilar',
            'kindle',
            'kindle fire',
            'kindle fire hd',
            'kindle fire hdx',
            'kindle single',
            'kingdom',
            'kingston technology',
            'kirkland washington',
            'kitabu',
            'kiva',
            'klatencor',
            'kleiner',
            'kleiner perkins caufield byers',
            'kloc',
            'kloc technologies',
            'koblenz',
            'kobo aura',
            'kobo aura hd',
            'kobo ereader',
            'kobo glo',
            'kobo inc',
            'kobo mini',
            'kobo touch',
            'konica minolta',
            'kpmg',
            'kpn',
            'kraft foods',
            'kt corporation',
            'kushal',
            'kushal chakrabarti',
            'kyocera',
            'kyoto',
            'l bl',
            'la times',
            'lab126',
            'labs',
            'lacoste',
            'lady gaga',
            'lafayette',
            'lakeland florida',
            'lam research',
            'lantern',
            'las vegas',
            'latex',
            'lauwinplanque',
            'lava mobiles',
            'lawson',
            'leads',
            'lebanon tennessee',
            'leep',
            'leep technology inc',
            'legislative',
            'leipzig',
            'lenexa kansas',
            'lenfant a la tasse',
            'lenovo',
            'lewisberry pennsylvania',
            'lexcycle',
            'lexington kentucky',
            'lexmark',
            'lg electronics',
            'lgbt',
            'lgbt book sales rank',
            'liaoning',
            'liberty global',
            'liberty interactive',
            'liberty media',
            'library catalogs',
            'librarything',
            'linden',
            'linear technology',
            'liquavista',
            'list of amazon subsidiaries',
            'list of book distributors',
            'list of companies based in seattle',
            'list of largest internet companies',
            'list of the largest information technology companies',
            'list of the largest software companies',
            'list of video game developers',
            'living social',
            'livingsocial',
            'localized',
            'london',
            'lore',
            'louisville kentucky',
            'lovefilm',
            'luxembourg',
            'luxembourg city',
            'luxor design',
            'm xico',
            'madison wisconsin',
            'madrid',
            'madrona',
            'mail order',
            'mail order catalogs',
            'maintenance repair and operations',
            'manfred',
            'manfred bluemel',
            'manhattan',
            'marc',
            'marc lore',
            'marc lore nimbula',
            'market capitalization',
            'market prices',
            'marketplace',
            'marks spencer',
            'marriott international',
            'marthas table',
            'marvell technology group',
            'mary s place',
            'maryland',
            'mashable',
            'massachusetts',
            'matt williams',
            'matt williams internet entrepreneur',
            'mattel',
            'matthew olim',
            'may',
            'mcdonald',
            'mcdonalds',
            'mcdonough',
            'mcdonough georgia',
            'media',
            'mediatek',
            'meguro tokyo',
            'mehta',
            'mercer island washington',
            'mexico',
            'miami',
            'michael jackson',
            'michael sha',
            'michael sha yellowleg com',
            'micromax mobile',
            'micron technology',
            'microsoft',
            'microsoft mobile',
            'microsoft reader',
            'microsoft windows',
            'middletown delaware',
            'mike daisey',
            'milton ontario',
            'mindcorps',
            'mindcorps incorporated',
            'mindoro',
            'minecraft',
            'mississauga',
            'mississauga ontario',
            'mitsubishi electric',
            'mobile',
            'mobipocket',
            'mobipocketcom',
            'mojo books',
            'mondel z international',
            'monet',
            'moni',
            'monster beverage',
            'mont limar',
            'montevideo',
            'moreno valley california',
            'mortar competitors',
            'mortar retailer',
            'mothercare',
            'motorola mobility',
            'motorola solutions',
            'mp3',
            'mts network provider',
            'mumbai',
            'munich',
            'munster indiana',
            'murfreesboro tennessee',
            'music',
            'music cds',
            'music industry',
            'music labels',
            'music unlimited',
            'mx',
            'mylan',
            'nadu',
            'nanning',
            'nasdaq',
            'nasdaq100',
            'nashua new hampshire',
            'nashville tennessee',
            'naver corporation',
            'ncr corporation',
            'nealpes',
            'neath',
            'neath port talbot',
            'nec',
            'neonazism',
            'net income',
            'netapp',
            'netease',
            'netflix',
            'netherlands',
            'nevada',
            'new',
            'new castle delaware',
            'new hampshire',
            'new jersey',
            'new south wales',
            'new york city',
            'new york new york',
            'new york times article',
            'newark california',
            'newark new jersey',
            'newegg',
            'nielsen bookscan service',
            'nikon',
            'nimbula',
            'nintendo',
            'nippon telegraph and telephone',
            'nl',
            'noble',
            'nokia networks',
            'noncompete clause',
            'nonperishable food',
            'noordholland',
            'nord',
            'nordstrom',
            'norman',
            'norman rockwell',
            'north',
            'north america',
            'north america united states of america fulfillment center codesgoodyear',
            'north carolina',
            'north dakota',
            'north las vegas nevada',
            'north rhinewestphalia',
            'ntt data',
            'ntt docomo',
            'nvidia',
            'nxp semiconductors',
            'obidos software',
            'occidental',
            'occidental mindoro',
            'oceania',
            'oclc',
            'october 2018 wage increase',
            'offer goods',
            'office workers',
            'oi telecommunications',
            'olympus corporation',
            'om malik',
            'on semiconductor',
            'online',
            'online advertising',
            'online bookstore',
            'online file storage',
            'online shopping',
            'ontario',
            'opds',
            'opencorporates',
            'opscode',
            'oracle',
            'oracle corporation',
            'orange business services',
            'orange county california',
            'orange sa',
            'order',
            'oreilly automotive',
            'osaka prefecture',
            'overdrive media console',
            'overstockcom',
            'paas',
            'paccar',
            'pacific medical center',
            'package delivery',
            'packard',
            'palm',
            'panasonic',
            'pantry',
            'parent company',
            'party company',
            'patel',
            'patriots',
            'patterson california',
            'paychex',
            'payments service',
            'pc world',
            'pedophilia',
            'pegatron',
            'pelago',
            'perfect 10 inc v amazoncom inc',
            'perishable food',
            'perkins',
            'peter kent',
            'peterborough',
            'petersburg virginia',
            'petscom',
            'pforzheim',
            'philadelphia pa',
            'phoenix arizona',
            'phrase extraction technique',
            'pickering',
            'pinkham',
            'pinzon',
            'pittsburgh pennsylvania',
            'plain text',
            'plainfield indiana',
            'planetall',
            'plastic logic',
            'platform as a service',
            'pocket edge',
            'pocketbook ereader',
            'point of sale',
            'poland',
            'port',
            'portable document format',
            'postal',
            'pradesh',
            'press',
            'price discrimination',
            'prime',
            'print on demand',
            'private label',
            'product business',
            'program',
            'project gutenberg',
            'provencealpesc',
            'provencealpesc tedazur',
            'public company',
            'publisher',
            'publishing',
            'puget sound energy',
            'puget sound region',
            'pushbutton',
            'qfc',
            'qina',
            'qisda es900',
            'qlick cart',
            'qualcomm',
            'quanta computer',
            'queue',
            'quidsi',
            'quora',
            'rajasthan',
            'rakuten',
            'ram shriram',
            'randall',
            'randall sullivan',
            'randstad',
            'randstad holding',
            'rating scale',
            'reader library',
            'readers',
            'readers digest association',
            'records data',
            'red',
            'red cross',
            'redlands california',
            'reflexive',
            'reflexive entertainment',
            'reflowable document',
            'regeneron',
            'region',
            'rei',
            'relentless com',
            'renesas electronics',
            'reno nevada',
            'replenishment',
            'reserve',
            'reuters',
            'revenue',
            'reza',
            'reza hussein',
            'rh',
            'rh nealpes',
            'rheinberg',
            'rhinelandpalatinate',
            'rhinewestphalia',
            'rick dalzell',
            'ricoh',
            'ridgmont',
            'ridgmont rugeley',
            'rijswijk',
            'ring',
            'robbins',
            'robbinsville new jersey',
            'rockwell',
            'ross stores',
            'ruby',
            'rugeley',
            'ruskin florida',
            's p 100',
            'sachin',
            'sachin bansal',
            'safeco',
            'saint',
            'saint andrew',
            'saitama',
            'saitama prefecture',
            'sakai osaka',
            'sala',
            'sala al jadida uk',
            'sale taxes',
            'salesforcecom',
            'samsung electronics',
            'samsung papyrus',
            'san',
            'san bernardino california',
            'san diego',
            'san fernando de henares madrid',
            'san francisco',
            'san francisco california',
            'san jos',
            'san luis obispo california',
            'sandisk',
            'sandy',
            'sanmina corporation',
            'sap se',
            'saran',
            'saran loiret',
            'sardinia',
            'saxony',
            'sba communications',
            'schappell',
            'schertz texas',
            'scholar',
            'schorsch',
            'scotland',
            'scotts valley california',
            'sdc',
            'sdc seattle distribution center',
            'seagate technology',
            'sears',
            'sears canada',
            'seatac washington',
            'seattle metropolitan area',
            'seattle times',
            'seattle tower',
            'seiko epson',
            'selfpublishing companies',
            'sellaband',
            'sellers',
            'semantic publishing',
            'semiconductor sales leaders by year',
            'service',
            'service company',
            'service economics',
            'services',
            'sevrey',
            'sha',
            'sha yellowleg',
            'shandong',
            'shanghai',
            'sharp corporation',
            'shenyang',
            'shepherdsville kentucky',
            'shopping service',
            'sichuan',
            'sigil application',
            'sigmaaldrich',
            'simple',
            'singapore',
            'sirius xm holdings',
            'sk hynix',
            'sk telecom',
            'slatecom',
            'slough',
            'smartphone',
            'smashwords',
            'smile',
            'social cataloging',
            'social media',
            'socialgold',
            'softbank mobile',
            'softbook',
            'software',
            'software engineer',
            'soho',
            'somerset',
            'songza',
            'sony',
            'sony mobile communications',
            'sony music',
            'sony reader',
            'sorsogon',
            'sothebys',
            'south',
            'south america',
            'south carolina',
            'south lake union seattle',
            'sovereign state',
            'sp 500',
            'spartanburg south carolina',
            'sponsor commercial',
            'sports equipment',
            'sprint',
            'sprint corporation',
            'staffordshire',
            'staples inc',
            'starbucks',
            'states',
            'statistically improbable phrases',
            'stdu viewer',
            'stericycle',
            'stmicroelectronics',
            'stock',
            'stock split',
            'stockton california',
            'storage',
            'storefront businesses',
            'stores',
            'stoughton massachusetts',
            'street',
            'studios',
            'sullivan',
            'sumner washington',
            'superman',
            'suzhou',
            'swansea',
            'sweden',
            'swedesboro new jersey',
            'symantec',
            'synapseindia',
            'systems',
            'tablet computer',
            'tag metadata',
            'talbot',
            'tamil',
            'tamil nadu',
            'tampa',
            'tampa bay area',
            'target',
            'target corporation',
            'tata consultancy services',
            'tcl corporation',
            'teachstreet',
            'team',
            'techcrunch',
            'technologies',
            'technology',
            'tedazur',
            'telecom italia',
            'telef nica',
            'tempe arizona',
            'tencent',
            'tennessee',
            'terabyte',
            'terms of service',
            'tesla motors',
            'texas instruments',
            'the book depository',
            'the hague',
            'the new york times',
            'the new yorker',
            'the next web',
            'the priceline group',
            'the sandman',
            'the slate group',
            'the unusuals',
            'the verge',
            'the walking dead video game',
            'tianjin',
            'ticker symbol',
            'time',
            'time magazine',
            'time person of the year',
            'tmobile us',
            'tmobile usa',
            'toby',
            'toby press',
            'tokyo',
            'tom szkutak',
            'tony hsieh',
            'toplevel domain',
            'toshiba',
            'toys',
            'toys games',
            'tpv technology',
            'tractor supply company',
            'tracy california',
            'trade',
            'trademark',
            'trademark infringement case',
            'transparent tv series',
            'tripadvisor',
            'trusera',
            'tsmc',
            'tsystems',
            'turkey',
            'turkish language versions',
            'tv',
            'twilio',
            'twitch website',
            'twitchtv',
            'twitter',
            'types of business entity',
            'u k civil aviation authority',
            'ubm plc',
            'uk civil aviation authority',
            'unionization',
            'unisys',
            'united',
            'united microelectronics corporation',
            'united states dollar',
            'united states patent and trademark office',
            'united states presidential election 2004',
            'universal',
            'universal music group',
            'unmanned aerial vehicle',
            'us congress',
            'us navy',
            'us state',
            'usc',
            'use taxes',
            'uspto',
            'v group',
            'van',
            'van biljon',
            'vengroff',
            'venture',
            'verisk analytics',
            'verizon',
            'verizon communications',
            'verizon wireless',
            'vertex pharmaceuticals',
            'vhs',
            'viacom',
            'video game',
            'video on demand',
            'vikas',
            'vikas gupta',
            'vimpelcom ltd',
            'virginia data centers',
            'virtual international authority file',
            'vishal',
            'vishal mehta',
            'visiting',
            'visiting scholar',
            'vittana',
            'vivendi',
            'vmware',
            'vodafone',
            'w3techs',
            'wage increase',
            'wales',
            'wales crymlyn burrows',
            'walgreens',
            'walgreens boots alliance',
            'warehouse conditions',
            'warhol',
            'warner',
            'warner bros',
            'warner bros records',
            'washington state',
            'watchmen',
            'web banner',
            'web hosting',
            'web hosting service',
            'web service',
            'webstores',
            'werne',
            'werner vogels',
            'west',
            'west columbia south carolina',
            'west virginia',
            'western',
            'western cape',
            'western digital',
            'weyerhaeuser',
            'whispernet',
            'whitestown indiana',
            'whole foods',
            'whrrl',
            'wiki',
            'wikibooks',
            'wikimedia endowment',
            'wikinvest',
            'wikisource',
            'willem',
            'willem van biljon',
            'williams',
            'willie',
            'willie gillis',
            'wilmer',
            'wilmer cutler pickering hale',
            'winchester kentucky',
            'windsor locks connecticut',
            'wipro',
            'wireless',
            'wisconsin',
            'wistron corporation',
            'withoutabox',
            'witt',
            'woleuntem',
            'woot',
            'wootcom',
            'wora',
            'wynn resorts',
            'xerox',
            'xhtml',
            'xiamen',
            'xian',
            'xiaomi',
            'xico',
            'xilinx',
            'xmdf ebook format',
            'xml',
            'xml service',
            'xolo company',
            'yachiyo chiba',
            'yahoo',
            'yandex',
            'yap company',
            'yellowleg',
            'yellowlegcom',
            'yokneam',
            'york',
            'yu televentures',
            'zapposcom',
            'zeitgeist research',
            'zhuang',
            'zip code',
            'zte',
            'zuidholland'
        ],
        'description': 'Amazon.com, Inc., doing business as Amazon, is a multinational technology company focusing in e-commerce, cloud computing, and artificial intelligence in Seattle, Washington. It is one of the Big Four or \'Four Horsemen\' of technology along with Google, Apple and Facebook due to its market capitalization, disruptive innovation, brand equity and hyper-competitive application process.',
        'employeeCount': 341400,
        'employerIdNumbers': [
            '91-1646860'
        ],
        'founders': [
            'Jeff Bezos'
        ],
        'id': '1454825144322',
        'imageUrls': [
            'https://upload.wikimedia.org/wikipedia/commons/4/43/Seattle_-_Arizona_Building_02.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/6/62/Amazon.com-Logo.svg',
            'https://upload.wikimedia.org/wikipedia/commons/b/bb/Amazon_warehouse_Glenrothes.jpg'
        ],
        'inceptionDate': '1994-07-06',
        'industries': [
            'retail'
        ],
        'instanceOf': [
            'public company',
            'e-commerce',
            'business enterprise'
        ],
        'isins': [
            'US0231351067'
        ],
        'label': 'Amazon',
        'languageFields': [
            {
                'description': 'Amazon.com, Inc., doing business as Amazon, is an American electronic commerce and cloud computing company based in Seattle, Washington that was founded by Jeff Bezos on July 5, 1994. The tech giant is the largest Internet retailer in the world as measured by revenue and market capitalization, and second largest after Alibaba Group in terms of total sales. The amazon.com website started as an online bookstore and later diversified to sell video downloads/streaming, MP3 downloads/streaming, audiobook downloads/streaming, software, video games, electronics, apparel, furniture, food, toys, and jewelry. The company also produces consumer electronics—Kindle e-readers, Fire tablets, Fire TV, and Echo—and is the world\'s largest provider of cloud infrastructure services (IaaS and PaaS). Amazon also sells certain low-end products under its in-house brand AmazonBasics.',
                'label': 'Amazon',
                'langCode': 'en',
                'urls': [
                    'https://en.wikipedia.org/wiki/Amazon_(company)'
                ]
            },
            {
                'description': 'Amazon.com is een Amerikaans e-commercebedrijf gevestigd in Seattle (Washington). Het was een van de eerste grote bedrijven die goederen over het internet verkochten en het werd opgericht in 1994 door Jeff Bezos. ',
                'label': 'Amazon.com',
                'langCode': 'nl',
                'urls': [
                    'https://nl.wikipedia.org/wiki/Amazon.com'
                ]
            },
            {
                'description': 'US-amerikanisches E-Commerce-Versandhaus',
                'label': 'Amazon.com',
                'langCode': 'de',
                'urls': [
                    'https://de.wikipedia.org/wiki/Amazon.com'
                ]
            },
            {
                'description': 'Compañía estadounidense de comercio electrónico y servicios de computación en la nube',
                'label': 'Amazon.com',
                'langCode': 'es',
                'urls': [
                    'https://es.wikipedia.org/wiki/Amazon'
                ]
            },
            {
                'description': 'entreprise américaine spécialisée dans la vente  en ligne',
                'label': 'Amazon.com',
                'langCode': 'fr',
                'urls': [
                    'https://fr.wikipedia.org/wiki/Amazon_(entreprise)'
                ]
            },
            {
                'description': 'американская компания по продаже товаров и услуг через Интернет',
                'label': 'Amazon.com',
                'langCode': 'ru',
                'urls': [
                    'https://ru.wikipedia.org/wiki/Amazon_(компания)'
                ]
            }
        ],
        'legalEntityIds': [
            'ZXTILKJKG63JELOEG630'
        ],
        'legalForms': [
            'public company'
        ],
        'location': {
            'admin1Label': 'Washington',
            'cityLabel': 'Seattle',
            'countryLabel': 'United States of America',
            'latitude': 47.6227,
            'longitude': -122.3362,
            'name': 'Seattle',
            'postalCode': '98101',
            'streetAddress': '410 Terry Avenue North'
        },
        'nameVariations': [
            'Amazon books',
            'ACI Gift Cards',
            'Amazon Com Inc',
            '@amazon',
            'AmazonWireless',
            'Casa.com',
            'Amazon (store)',
            'Soundunwound',
            'CreateSpace Independent Publishing Platform',
            'Amazon HQ1',
            'Amazon Digital Services LLC',
            'Amazon (online)',
            'Amazon.co.jp',
            'Amazon (company)',
            'Amazoncom',
            'Amazon (online retailer)',
            'Amazon.fr',
            'Brilliance Audio',
            'BeautyBar.com',
            'Amazon Services',
            'Amazon Local',
            'AMZN (NASDAQ)',
            'Amazon Deutschland',
            'Amazon jp',
            'Amazon',
            'Amazon Dot Com',
            'Amazon store',
            'Amazon (website)',
            'Amazon astore',
            'Amazon.com Inc',
            'History of Amazon.com',
            'Amazon Corp.',
            'ZShops',
            'Wag.com',
            'Amazon App',
            'BookSurge LLC',
            'Amazon.de',
            'Amazon.com exclusive',
            'Amazon Webstore',
            'Junglee.com',
            'Amazon Affiliates',
            'AMZN',
            'Amazon app',
            'Amazon.com Incorporated',
            'Junglee (company)',
            'AfterSchool.com',
            'Amazon.com/',
            'Unboxed.com',
            'Relentless.com',
            'CreateSpace.com',
            'Amazon.com, Inc.',
            'Amazon.ca',
            'AStore',
            'Yoyo.com',
            'Sound Unwound',
            'Amazon Inc',
            'Amazon Software Download',
            'AmazonWebstore',
            'Amazon Internet store',
            'Indigo Starfish',
            'Cadabra.com',
            'Amazon leadership principles',
            'Amazon.com, Inc',
            'Bookworm.com',
            'Amazon (bookstore)',
            'Amazon.co.uk',
            'Amazon.co.UK',
            'Amazon Inc.',
            'Amazon EU SARL',
            'Amazon dot com',
            'SoundUnwound',
            'Amazon.com Inc.',
            'Amazon Japan',
            'History of Amazon',
            'Amazon Internet retailer',
            'Amazon Jersey',
            'Look.com',
            'SoundUnwound.com',
            'Sound unwound',
            'Amazon.it',
            'Amazon.in',
            'Amazon.com',
            'Soundunwound.com',
            'AmazonLocal',
            'Myhabit.com',
            'Amazon com',
            'Amazon+India',
            'Amazon (retailer)',
            'Amazon UK',
            'Http://www.amazon.com',
            'Www.amazon.com',
            'Amazon Germany',
            'Amazon company',
            'Amazon.Com',
            'Booksurge',
            'List of Amazon.com subsidiaries',
            'Amazon Digital Services',
            'amazon connect',
            'amazon india',
            'amazon online',
            'amazonbasics',
            'amazon prime',
            'amazon game studios',
            'vine com',
            'amazon prime day',
            'amazon website',
            'customflix',
            'createspace',
            'amazoncom inc',
            'as16509',
            'amazon bookstore',
            'shopbop',
            'pinzon trademark',
            'amazon video direct',
            'amazon retailer',
            'amazon amzn'
        ],
        'owners': [
            'The Vanguard Group',
            'Jeff Bezos'
        ],
        'partOf': [
            'NASDAQ-100',
            'S&P 500'
        ],
        'permIds': [
            '4295905494'
        ],
        'prominence': 0.6173,
        'stocks': [
            {
                'exchange': 'NASDAQ',
                'tickerSymbol': 'AMZN'
            }
        ],
        'subType': 'COMPANY',
        'subsidiaries': [
            'A9.com',
            'Amazon Web Services',
            'Alexa',
            'Zappos.com',
            'Internet Movie Database',
            'Twitch',
            'Amazon Technologies',
            'Amazon Prime Air',
            'Souq.com',
            'Alexa Internet'
        ],
        'twitterNames': [
            'amazon'
        ],
        'type': 'ORGANIZATION',
        'urls': [
            'https://en.wikipedia.org/wiki/Amazon_(company)',
            'https://www.wikidata.org/wiki/Q3884',
            'https://permid.org/1-4295905494',
            'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=0001018724',
            'https://www.gleif.org/lei/ZXTILKJKG63JELOEG630',
            'https://twitter.com/amazon',
            'https://www.facebook.com/Amazon',
            'https://www.instagram.com/amazon',
            'https://plus.google.com/114493486650807637382',
            'https://www.youtube.com/channel/UCkLXELm63_pH7L-r-548kig',
            'https://g.co/kg/m/0mgkg',
            'https://www.quora.com/topic/Amazon-company',
            'https://www.britannica.com/topic/Amazoncom',
            'http://www.isin.org/isin-preview/?isin=US0231351067',
            'https://en.wikipedia.org/wiki/Amazon.com',
            'https://www.amazon.com',
            'https://www.amazon.de'
        ],
        'version': '19.3.2'
    };

    const EXAMPLE_RESPONSE_V2_ENTITIES3 = {
        'admin1DsgFeatureCode': 'ADM1',
        'admin1Fips': 'US11',
        'admin1Genc': 'US-DC',
        'admin1Label': 'District of Columbia',
        'admin2Label': 'District of Columbia',
        'boundingBox': {
            'maxLatitude': 39.133,
            'maxLongitude': -76.8287,
            'minLatitude': 38.6918,
            'minLongitude': -77.3268
        },
        'countryDsgFeatureCode': 'PCLI',
        'countryFips': 'US',
        'countryGenc2': 'US',
        'countryGenc3': 'USA',
        'countryGencCode': '840',
        'countryLabel': 'United States',
        'dsgFeatureClass': 'P',
        'dsgFeatureClassLabel': 'Populated place',
        'dsgFeatureCode': 'PPLC',
        'dsgFeatureCodeDescription': 'capital of a political entity',
        'dsgFeatureCodeLabel': 'national capital',
        'id': '243859456',
        'label': 'Washington',
        'latitude': 38.895,
        'longitude': -77.0367,
        'population': 572059,
        'type': 'GEO'
    };

    const EXAMPLE_RESPONSE_V2_ENTITIES4 = {
        'results': [
           {
              'document': {
                 'id': '2938437633',
                 'label': 'Donald Trump',
                 'urls': [
                    'https://en.wikipedia.org/wiki/Donald_Trump',
                    'https://www.wikidata.org/wiki/Q22686',
                    'https://twitter.com/realdonaldtrump',
                    'https://twitter.com/potus',
                    'https://www.facebook.com/DonaldTrump',
                    'https://www.facebook.com/POTUS',
                    'https://www.instagram.com/realdonaldtrump',
                    'https://plus.google.com/+DonaldJTrumpforPresident',
                    'https://g.co/kg/m/0cqt90',
                    'https://www.quora.com/topic/Donald-Trump-politician-business-person',
                    'https://www.britannica.com/biography/Donald-J-Trump',
                    'https://www.britannica.com/biography/Donald-Trump',
                    'https://www.bbc.co.uk/things/78080d81-2849-497e-bc3a-bf364626456b',
                    'https://www.donaldjtrump.com',
                    'https://www.whitehouse.gov/administration/president-trump'
                 ]
              },
              'score': 0.9989590163934426
           },
           {
              'document': {
                 'id': '538002718721',
                 'label': 'Donald Trump',
                 'urls': [
                    'https://en.wikipedia.org/wiki/Donald_L._Trump',
                    'https://www.wikidata.org/wiki/Q27947481',
                    'https://twitter.com/doctorskippy',
                    'https://www.linkedin.com/in/donald-l-trump-md-facp-bb295642'
                 ]
              },
              'score': 0.9918032786885247
           },
           {
              'document': {
                 'id': '535401005057',
                 'label': 'family of Donald Trump',
                 'urls': [
                    'https://en.wikipedia.org/wiki/Family_of_Donald_Trump',
                    'https://www.wikidata.org/wiki/Q27907344',
                    'https://twitter.com/barron_pmurt',
                    'https://en.wikipedia.org/wiki/Family_of_Donald_Trump#Barron_Trump',
                    'http://www.townandcountrymag.com/society/a9595701/barron-trump-facts'
                 ]
              },
              'score': 0.9739508196721312
           },
           {
              'document': {
                 'id': '540679864321',
                 'label': 'Trump',
                 'urls': [
                    'https://en.wikipedia.org/wiki/Trump_(video_game_player)',
                    'https://www.wikidata.org/wiki/Q16973370',
                    'https://en.wikipedia.org/wiki/Trump_(video_gamer)'
                 ]
              },
              'score': 0.9721311475409836
           },
           {
              'document': {
                 'id': '344804753409',
                 'label': 'Donald Trump Jr.',
                 'urls': [
                    'https://en.wikipedia.org/wiki/Donald_Trump_Jr.',
                    'https://www.wikidata.org/wiki/Q3713655',
                    'https://twitter.com/donaldjtrumpjr',
                    'https://www.facebook.com/DonaldJTrumpJr',
                    'https://www.instagram.com/donaldjtrumpjr',
                    'https://g.co/kg/m/0dzqp5',
                    'https://www.quora.com/topic/Donald-Trump-Jr',
                    'https://www.bbc.co.uk/things/2b078a07-2526-4fec-bfda-6d4e292b08b9'
                 ]
              },
              'score': 0.969303598041303
           },
           {
              'document': {
                 'id': '18682019841',
                 'label': 'Donald Sumpter',
                 'urls': [
                    'https://en.wikipedia.org/wiki/Donald_Sumpter',
                    'https://www.wikidata.org/wiki/Q3713649',
                    'https://g.co/kg/m/026g801',
                    'http://dbpedia.org/resource/Donald_Sumpter'
                 ]
              },
              'score': 0.9541723653395785
           },
           {
              'document': {
                 'id': '32395952129',
                 'label': 'Kelly Trump',
                 'urls': [
                    'https://en.wikipedia.org/wiki/Kelly_Trump',
                    'https://www.wikidata.org/wiki/Q62276',
                    'https://twitter.com/kellytrump_',
                    'https://g.co/kg/m/07cm6l',
                    'http://www.kellytrump.de',
                    'http://dbpedia.org/resource/Kelly_Trump'
                 ]
              },
              'score': 0.9470976486173207
           },
           {
              'document': {
                 'id': '353919631361',
                 'label': 'J. Donald Crump',
                 'urls': [
                    'https://en.wikipedia.org/wiki/Donald_Crump',
                    'https://www.wikidata.org/wiki/Q16019022',
                    'https://g.co/kg/m/0gmcfnc'
                 ]
              },
              'score': 0.9447362260250898
           },
           {
              'document': {
                 'id': '344521834497',
                 'label': 'Donald Antrim',
                 'urls': [
                    'https://en.wikipedia.org/wiki/Donald_Antrim',
                    'https://www.wikidata.org/wiki/Q714153',
                    'https://g.co/kg/m/06dkb0'
                 ]
              },
              'score': 0.94386444547687
           },
           {
              'document': {
                 'id': '344523210753',
                 'label': 'Donald Burt',
                 'urls': [
                    'https://en.wikipedia.org/wiki/Donald_Burt',
                    'https://www.wikidata.org/wiki/Q5294098',
                    'https://g.co/kg/m/0415rwn'
                 ]
              },
              'score': 0.9436528359779084
           }
        ]
     };

    const EXAMPLE_RESPONSE_V2_ENTITIES5 = {
        'inMemorySize': 3981837596,
        'name': 'PEOPLE',
        'recordCount': 1268802
    };

    const EXAMPLE_RESPONSE_V2_ENTITIES6 = {
        'collections': [
            {
                'inMemorySize': 2450518868,
                'name': 'ORGANIZATIONS',
                'recordCount': 1016386
            },
            {
                'inMemorySize': 3981837596,
                'name': 'PEOPLE',
                'recordCount': 1268802
            },
            {
                'inMemorySize': 27279156,
                'name': 'THINGS',
                'recordCount': 16659
            }
        ]
    };

    const EXAMPLE_REQUEST_V2_ENTITIES_CREATE = {
        'label': 'Opel Rekord P3',
        'document': 'The Opel Olympia Rekord was introduced in March 1953 as successor to the Opel Olympia, a pre-World War II design dating back to 1935. The Opel Olympia Rekord was built until 1957 in four different versions. Around 580,000 units were produced. Styling of the 1953-54 sedans resembled scaled-down versions of the contemporary Chevrolet in the U.S. Both cars were of course, products of General Motors.',
        'description': 'The Opel Olympia Rekord was a two-door family car which replaced the Opel Olympia in March 1953. Innovations included the strikingly modern Ponton format body-work incorporating numerous styling features from the United States and large amounts of chrome decoration both on the outside and on the inside.',
        'prominence': 0.45,
        'nameVariations': ['Opel Rekord P3', 'RekordP3']
    };

    const EXAMPLE_RESPONSE_V2_ENTITIES_CREATE = {
        'document': 'The Opel Olympia Rekord was introduced in March 1953 as successor to the Opel Olympia, a pre-World War II design dating back to 1935. The Opel Olympia Rekord was built until 1957 in four different versions. Around 580,000 units were produced. Styling of the 1953-54 sedans resembled scaled-down versions of the contemporary Chevrolet in the U.S. Both cars were of course, products of General Motors.',
        'description': 'The Opel Olympia Rekord was a two-door family car which replaced the Opel Olympia in March 1953. Innovations included the strikingly modern Ponton format body-work incorporating numerous styling features from the United States and large amounts of chrome decoration both on the outside and on the inside.',
        'id': '1142506930472551406',
        'label': 'Opel Rekord P3',
        'nameVariations': [
           'Opel Rekord P3',
            'RekordP3'
        ],
        'languageFields': [
            {
               'description' : 'The Opel Olympia Rekord was a two-door family car which replaced the Opel Olympia in March 1953. Innovations included the strikingly modern Ponton format body-work incorporating numerous styling features from the United States and large amounts of chrome decoration both on the outside and on the inside.',
               'label' : 'Opel Rekord P3',
               'langCode' : 'en',
               'urls' : [ ]
            }
        ],
        'prominence': 0.45,
        'type': 'THING',
        'urls': [],
        'version': '1.0.0.58473'
    };

    const EXAMPLE_REQUEST_V2_ENTITIES_UPDATE = {
        'label': 'Opel Rekord P3',
        'id': '1142506930472551406',
        'version': '1.0.0.58473',
        'document': 'The Opel Olympia Rekord was introduced in March 1953 as successor to the Opel Olympia, a pre-World War II design dating back to 1935. The Opel Olympia Rekord was built until 1957 in four different versions. Around 580,000 units were produced. Styling of the 1953-54 sedans resembled scaled-down versions of the contemporary Chevrolet in the U.S. Both cars were of course, products of General Motors.',
        'description': 'The Opel Olympia Rekord was a two-door family car which replaced the Opel Olympia in March 1953. Innovations included the strikingly modern Ponton format body-work incorporating numerous styling features from the United States and large amounts of chrome decoration both on the outside and on the inside.',
        'prominence': 0.55,
        'nameVariations': ['Opel Rekord P3', 'RekordP3']
    };

    const EXAMPLE_RESPONSE_V2_ENTITIES_UPDATE = {
        'document': 'The Opel Olympia Rekord was introduced in March 1953 as successor to the Opel Olympia, a pre-World War II design dating back to 1935. The Opel Olympia Rekord was built until 1957 in four different versions. Around 580,000 units were produced. Styling of the 1953-54 sedans resembled scaled-down versions of the contemporary Chevrolet in the U.S. Both cars were of course, products of General Motors.',
        'description': 'The Opel Olympia Rekord was a two-door family car which replaced the Opel Olympia in March 1953. Innovations included the strikingly modern Ponton format body-work incorporating numerous styling features from the United States and large amounts of chrome decoration both on the outside and on the inside.',
        'id': '1142506930472551406',
        'label': 'Opel Rekord P3',
        'nameVariations': [
           'Opel Rekord P3',
            'RekordP3'
        ],
        'languageFields': [
            {
               'description' : 'The Opel Olympia Rekord was a two-door family car which replaced the Opel Olympia in March 1953. Innovations included the strikingly modern Ponton format body-work incorporating numerous styling features from the United States and large amounts of chrome decoration both on the outside and on the inside.',
               'label' : 'Opel Rekord P3',
               'langCode' : 'en',
               'urls' : [ ]
            }
        ],
        'prominence': 0.55,
        'type': 'THING',
        'urls': [],
        'version': '1.0.1.58473'
    };

    const EXAMPLE_RESPONSE_V1_INFORMATION_EXTRACTION_PROMPTS = {
        'promptTemplates': [
            {
                'description': 'Component Extraction Prompt',
                'name': 'Components'
            },
            {
                'description': 'High Recall Prompt',
                'name': 'HighRecall'
            },
            {
                'description': 'Example description of what the prompt does',
                'name': 'PromptName'
            },
        ]
    };

    const EXAMPLE_RESPONSE_V1_USAGE = {
        'accountId': 'some-account',
        'requestKey': 'some-userid',
        'requestLevel': 'user',
        'interval': 'daily',
        'begin': '2019-04-01T00:00:00Z',
        'end': '2019-04-02T23:00:00Z',
        'usage': {
            'some-userid ': {
                'environments': {
                    'prod': {
                        'endpoints': {
                            '/api/v1/entities': {
                                'transactionSummaries': {
                                    '2019-04-01': {
                                        'transactionCount': 8,
                                        'averageResponseTime': 5.5,
                                        'maxResponseTime': 11,
                                        'minResponseTime': 1,
                                        'averageResponseSize': 1651.125,
                                        'maxResponseSize': 3699,
                                        'minResponseSize': 668,
                                        'averageRequestSize': 0,
                                        'maxRequestSize': 0,
                                        'minRequestSize': 0
                                    },
                                    '2019-04-01T00:00:00Z - 2019-04-02T23:00:00Z': {
                                        'transactionCount': 8,
                                        'averageResponseTime': 5.5,
                                        'maxResponseTime': 11,
                                        'minResponseTime': 1,
                                        'averageResponseSize': 1651.125,
                                        'maxResponseSize': 3699,
                                        'minResponseSize': 668,
                                        'averageRequestSize': 0,
                                        'maxRequestSize': 0,
                                        'minRequestSize': 0
                                    }
                                }
                            },
                            '/api/v2/enrich': {
                                'transactionSummaries': {
                                    '2019-04-01': {
                                        'transactionCount': 91535,
                                        'averageResponseTime': 435.9316,
                                        'maxResponseTime': 40194,
                                        'minResponseTime': 12,
                                        'averageResponseSize': 11539.957,
                                        'maxResponseSize': 509032,
                                        'minResponseSize': 0,
                                        'averageRequestSize': 3269.7312,
                                        'maxRequestSize': 199141,
                                        'minRequestSize': 166
                                    },
                                    '2019-04-01T00:00:00Z - 2019-04-02T23:00:00Z': {
                                        'transactionCount': 193917,
                                        'averageResponseTime': 468.05496,
                                        'maxResponseTime': 40194,
                                        'minResponseTime': 12,
                                        'averageResponseSize': 11857.888,
                                        'maxResponseSize': 623473,
                                        'minResponseSize': 0,
                                        'averageRequestSize': 3352.8357,
                                        'maxRequestSize': 239517,
                                        'minRequestSize': 166
                                    },
                                    '2019-04-02': {
                                        'transactionCount': 102382,
                                        'averageResponseTime': 500.17822,
                                        'maxResponseTime': 36230,
                                        'minResponseTime': 13,
                                        'averageResponseSize': 12175.82,
                                        'maxResponseSize': 623473,
                                        'minResponseSize': 91,
                                        'averageRequestSize': 3435.9397,
                                        'maxRequestSize': 239517,
                                        'minRequestSize': 268
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    };

    const EXAMPLE_RESPONSE_V1_ADMIN_RESTART = {
        'code': 200,
        'message': 'Servlet reloaded successfully'
    };

    const EXAMPLE_RESPONSE_V1_ADMIN_SYSINFO = {
        'agent_deployment:': {
            'endpoints': [
                {
                    'POST': {
                        'optionalheaders': {},
                        'optionalparameters': {
                            'documentSentiment': 'true to include sentiment at document and sentence level. Default=false',
                            'finchOutput': 'true to return Finch formatted output with sentiment. Default=false',
                            'instanceSentiment': 'true to include sentiment at entity instance level. Default=false'
                        },
                        'requiredheaders': {
                            'Content-Type': 'application/json'
                        },
                        'requiredparameters': {
                            'model': 'Sentiment model to use'
                        }
                    },
                    'description': 'Return OpenCalais (OC) results with sentiment added',
                    'path': 'api/v1/sentiment/:model:'
                },
                {
                    'POST': {
                        'optionalheaders': {},
                        'optionalparameters': {
                            'finchRequest': {
                                'documentSentiment': 'true to include sentiment at document and sentence level. Default=false',
                                'finchOutput': 'true to return Finch formatted output with sentiment. Default=false',
                                'instanceSentiment': 'true to include sentiment at entity instance level. Default=false',
                                'sentimentModel': 'Sentiment model to use. Required if sentiment requested.'
                            }
                        },
                        'requiredheaders': {
                            'Content-Type': 'application/json'
                        },
                        'requiredparameters': {}
                    },
                    'description': 'Return OpenCalais (OC) results with sentiment added',
                    'path': 'api/v2/sentiment'
                },
                {
                    'POST': {
                        'optionalheaders': {},
                        'optionalparameters': {
                            'finchRequest': {
                                'documentSentiment': 'true to include sentiment at document and sentence level. Default=false',
                                'entities': 'An array of entity types of interest.',
                                'finchOutput': 'true to return Finch formatted output with sentiment. Default=false',
                                'instanceSentiment': 'true to include sentiment at entity instance level. Default=false',
                                'keyPhrases': 'true to return the articles extracted key phrases. Default=false',
                                'languageCode': 'Language in which the text must be analyzed. Specified as an ISO 639-1 code. Default=en',
                                'sentimentModel': 'Sentiment model to use. Required if sentiment requested.',
                                'textCorrections': 'An array of text corrections. Options include case, punctuation and token.',
                                'topicModel': 'The topic model chosen for topic vector analysis. Required if topicVector requested.',
                                'topicVector': 'true to include a topic vector. Default=false'
                            }
                        },
                        'requiredheaders': {
                            'Content-Type': 'application/json'
                        },
                        'requiredparameters': {}
                    },
                    'description': 'Return OpenCalais (OC) results with Finch For Text enrichments added',
                    'path': 'api/v2/enrich'
                }
            ],
            'environment': {
                'fftUrl': 'http://combo-dev-1.aws.finchcomputing.com:8080/enrich/v3',
                'sentimentUrl': 'http://docker-dev-1.aws.finchcomputing.com:8484/api/v1/sentiment'
            },
            'name': 'FinchComputing TRIT Agent',
            'tornado': '6.0.2',
            'version': '2.8.1'
        },
        'deployment': {
            'authfile_refresh_interval': 60000000000,
            'build_date': '2019-09-30T20:23:38Z',
            'correct_text_sysinfo': 'http://docker-dev-1.aws.finchcomputing.com:8787/sysinfo',
            'correct_text_url': 'http://docker-dev-1.aws.finchcomputing.com:8787/api/v1/correctText',
            'detail_log': '/var/log/fft_ws/trans-detail.log',
            'detect_lang_base_url': 'http://docker-dev-1.aws.finchcomputing.com:8888',
            'detect_lang_sysinfo': 'http://docker-dev-1.aws.finchcomputing.com:8888/sysinfo',
            'diag_log': '/var/log/fft_ws/diag.log',
            'diag_log_level': 'info',
            'encrypted_input': true,
            'fdb_url': 'tcp://brat-finchdb-dev-1.aws.finchcomputing.com:40000',
            'fft_base_url': 'http://combo-dev-1.aws.finchcomputing.com:8080',
            'geo_services_url': 'http://brat-metacarta-dev-1.aws.finchcomputing.com/services',
            'kb_dms_url': 'http://brat-finchdb-dev-1.aws.finchcomputing.com:8083',
            'log_all_detail': true,
            'log_rotate_interval': '15m',
            'max_request_size_kb': 1024,
            'metrics_blacklist_emails': 'none',
            'metrics_push_interval': 60000000000,
            'metrics_redis_host': 'none',
            'ops_env': 'dev',
            'package_info_file': 'none',
            'port': 8200,
            'redis_conn': 'localhost:6379',
            'sentiment_sysinfo': 'http://docker-dev-1.aws.finchcomputing.com:8484/sysinfo',
            'sentiment_url': 'http://docker-dev-1.aws.finchcomputing.com:8484/api/v1/doc-sentiment',
            'summarize_sysinfo': 'http://docker-dev-1.aws.finchcomputing.com:8989/sysinfo',
            'summarize_url': 'http://docker-dev-1.aws.finchcomputing.com:8989/api/v1/summarize',
            'tika_service_url': 'http://finch-operations-cluster.aws.finchcomputing.com:9998',
            'trans_log': '/var/log/fft_ws/trans.log',
            'trit_agent_url': 'http://docker-dev-1.aws.finchcomputing.com:8585',
            'trit_enrich_url': 'http://docker-dev-1.aws.finchcomputing.com:8585/api/v2/enrich',
            'trit_sentiment_url': 'http://docker-dev-1.aws.finchcomputing.com:8585/api/v2/sentiment',
            'usage_db_conn': 'readonly-metrics:2VXKi14ecyuVjSXYtbbY@tcp(infrastructure-db1.aws.finchcomputing.com:3306)/metrics?tls=skip-verify',
            'user_conn': 'file:/opt/fft_ws/data/users.json',
            'version': 'ea6fdc5',
            'wikipedia_url_pattern': 'none',
            'zabbix_target_nostname': 'raptor-dev-1',
            'zabbix_url': 'zabbix.finchcomputing.com:10051'
        },
        'language_detection_deployment': {
            'version': '1.0.4'
        },
        'sentiment_deployment': {
            'backlog': 32,
            'models': [
                'news3',
                'financial3',
                'earningsCall'
            ],
            'threads': 8,
            'version': '3.15.4'
        },
        'summarize_deployment': {
            'backlog': 32,
            'models': [
                'summarizer::news::en',
                'summarizer::news-nyt::en',
                'summarizer::news-pseudo::en',
                'summarizer::gensim::en'
            ],
            'threads': 1,
            'version': '1.1.4'
        },
        'text_correction_deployment': {
            'version': '1.0.9'
        }
    };

    const EXAMPLE_RESPONSE_V1_VERSION = {
        'current': {
            'package': 95,
            'revisions': [
                'Demo Site: Added knowledgebase edit UI for on-prem deployments',
                'Security upadate for Sentiment, Summarize and TextCorrect services',
                'Minor improvements to Financial3 sentiment model',
                'Remove duplicate ORG entities from the knowledgebase',
                'Updates to PERSON and ORG knowledgebases',
                'Minor improvements to THING, GEO, ORGANIZATION and PEOPLE extraction',
                'Regular data update to provide more complete and accurate Geo IP enrichment'
            ]
        }
    };

    const EXAMPLE_REQUEST_V2_ENTITIES_LINK = {
        'maxAnswers': 5,
        'scoreThreshold': 0.5,
        'requestType': 'search',
        'document':{
            'description': 'IBM Canada\'s head offices are currently located in Markham, Ontario and have been there since the early 1980s. The current building IBM occupies is located at 3600 Steeles Avenue East and was completed in 1995.  IBM Canada\'s previous head office was located across the street at 3500 Steeles Avenue East (now Liberty Centre, Markham).',
            'label': 'IBM Canada Head Office Building',
            'type': 'ORGANIZATION',
            'instanceOf': [
                'building'
            ]
        }
    };

    const EXAMPLE_RESPONSE_V2_ENTITIES_LINK = {
        'results': [
            {
                'id': '4618509680642',
                'label': 'IBM Canada Head Office Building',
                'score': '0.7898303574260938'
            }
        ]
    };

    const EXAMPLE_RESPONSE_V1_EXTRACT_ARTICLE = {
        'authors': [
            'Amy Mcgorry'
        ],
        'body': 'NEW You can now listen to Fox News articles!\n\nDr. Alexander Thomas Augusta faced many challenges being the first Black surgeon commissioned in the Union Army during the Civil War. He was eventually recognized for his merits and was the first Black officer-rank soldier to be buried at Arlington Cemetery.\n\nDespite being named senior surgeon at Camp Stanton in Maryland in February 1864, during the Civil War, Augusta still faced racism from medical colleagues he worked with helping soldiers during the war, according to Dr. Heather Butts, a Harvard alumnus who studied public health. Butts is the Director of the Honors College at Long Island University, Brookville, New York, and wrote the book \"African American Medicine in Washington, D.C.: Healing the Capital During the Civil War Era,\" which depicted the surgeon’s life.\n\n\"Some of the white surgeons that reported to Augusta wrote to President Lincoln informing him of their displeasure at having to report to Augusta. They requested \'most respectfully yet earnestly\' that this \'unexpected, unusual and most unpleasant relationship in which we have been placed\' come to an end.\" Their letter also stated:\n\n\"\'But we cannot ... willingly compromise what we consider ... proper self-respect, nor do we deem that the interests of either the country or of the colored race can demand this of us.\' Dr. Augusta was transferred out of Camp Stanton,\" Dr. Butts wrote in a statement to Fox News.\n\nBLACK HISTORY THROUGH THE YEARS: 10 FAMOUS FIGURES IN THE US\n\nAccording to a published report in the National Medical Association, Dr. Augusta was born a free man in 1825, in Norfolk, Va. He learned to read secretly and moved to Baltimore, Md., where he studied medicine with tutors, since it was against the law to teach people of color, the article said.\n\nThe article recounted how Augusta worked with Dr. William Gibson of the University of Pennsylvania but was denied admittance to the university\'s medical school. He eventually went to Canada, where he received his bachelor of medicine degree, with full honors, from Trinity Medical College of the University of Toronto in 1856.\n\nAugusta returned to the states and wrote a letter to President Abraham Lincoln requesting to be appointed as a surgeon for one of the black regiments formed by the Union Army. He was granted a surgeon\'s commission in the Union Army in 1863, according to the article.\n\nButts described how this preeminent surgeon faced and triumphed over the bigotry. \"Through it all, he faced this adversity in a way that allowed him to give back to his patients, and society,\" Dr. Butts told Fox News.\n\nWhile traveling to testify in a court-martial on February 1, 1864, Augusta was delayed due to a racially-charged incident on a trolley car incident. According to Butts, Augusta attempted to enter the trolley but was told he had to ride on the front of the car since it was against the rules for colored persons to ride inside. The surgeon was kicked off the trolley when he refused to ride outside the car and had to walk to the courthouse, where he was late to the hearing.\n\nThe incident caught the attention of Senator Charles Sumner of Massachusetts who helped pass a resolution before Congress that resulted in the desegregation of trolley cars in Washington, D.C. in the 1860s.\n\nDr. Augusta not only helped soldiers heal on the front lines during the Civil War, but also helped pave the path for Black Americans pursuing careers in the medical field. In 1868 Augusta was the first African American to be appointed to the faculty of Howard University and the first to any medical college in the United States.\n\nCLICK HERE TO GET THE FOX NEWS APP\n\n\"My hope is that there will be many more stories and books and articles about Dr. Augusta and the other brave African American surgeons who served during the war, and that their stories and their legacy will get the attention they so richly deserve,\" Dr. Butts told Fox News.',
        'image': 'https://static.foxnews.com/foxnews.com/content/uploads/2022/02/The_Freedmens_Bureau_-_Drawn_by_A.R._Waud._LCCN92514996.tif.jpg',
        'keywords': [
            'wrote',
            'surgeon',
            'university',
            'war',
            'black',
            'thomas',
            'history',
            'butts',
            'fox',
            'civil',
            'medical',
            'trolley',
            'dr',
            'honor',
            'month',
            'augusta'
        ],
        'published': '2022-02-18 16:43:54',
        'summary': 'Dr. Alexander Thomas Augusta faced many challenges being the first black surgeon commissioned in the Union Army during the Civil War',
        'title': 'In honor of Black History Month: Dr. Alexander Thomas Augusta, first Black surgeon in Civil War',
        'videos': []
    };

    return {
        EXAMPLE_RESPONSE_ACRONYM,
        EXAMPLE_RESPONSE_DATETIME1,
        EXAMPLE_RESPONSE_DATETIME2,
        EXAMPLE_RESPONSE_DATETIME3,
        EXAMPLE_RESPONSE_DATETIMERANGE1,
        EXAMPLE_RESPONSE_DATETIMERANGE2,
        EXAMPLE_RESPONSE_DATETIMERANGE3,
        EXAMPLE_RESPONSE_EMAIL1,
        EXAMPLE_RESPONSE_EMAIL2,
        EXAMPLE_RESPONSE_GEO1,
        EXAMPLE_RESPONSE_GEO2,
        EXAMPLE_RESPONSE_IPV41,
        EXAMPLE_RESPONSE_IPV42,
        EXAMPLE_RESPONSE_MEASURE1,
        EXAMPLE_RESPONSE_MEASURE2,
        EXAMPLE_RESPONSE_MEASURE3,
        EXAMPLE_RESPONSE_MONEY1,
        EXAMPLE_RESPONSE_MONEY2,
        EXAMPLE_RESPONSE_LANGUAGE,
        EXAMPLE_RESPONSE_NATIONALITY,
        EXAMPLE_RESPONSE_ORG1,
        EXAMPLE_RESPONSE_ORG2,
        EXAMPLE_RESPONSE_ORG3,
        EXAMPLE_RESPONSE_PERSON1,
        EXAMPLE_RESPONSE_PERSON2,
        EXAMPLE_RESPONSE_PERSON3,
        EXAMPLE_RESPONSE_PHONE1,
        EXAMPLE_RESPONSE_PHONE2,
        EXAMPLE_RESPONSE_THING,
        EXAMPLE_RESPONSE_TWITTER,
        EXAMPLE_RESPONSE_URI1,
        EXAMPLE_RESPONSE_URI2,
        EXAMPLE_RESPONSE_POSITION1,

        EXAMPLE_RESPONSE_V2_CONVERT_DOC,
        EXAMPLE_REQUEST_CORRECT_TEXT,
        EXAMPLE_RESPONSE_CORRECT_TEXT,
        EXAMPLE_REQUEST_DETECT_LANGUAGE1,
        EXAMPLE_RESPONSE_DETECT_LANGUAGE1,
        EXAMPLE_REQUEST_DETECT_LANGUAGE2,
        EXAMPLE_RESPONSE_DETECT_LANGUAGE2,
        EXAMPLE_REQUEST_DETECT_LANGUAGE2_1,
        EXAMPLE_RESPONSE_DETECT_LANGUAGE2_1,
        EXAMPLE_REQUEST_DETECT_LANGUAGES,
        EXAMPLE_RESPONSE_DETECT_LANGUAGES,
        EXAMPLE_RESPONSE_V1_ENTITIES1,
        EXAMPLE_RESPONSE_V1_ENTITIES2,
        EXAMPLE_RESPONSE_V1_ENTITIES3,
        EXAMPLE_RESPONSE_V1_LOCATION_FINDER_QUERY,
        EXAMPLE_RESPONSE_V1_LOCATION_FINDER_GEOMETRY,
        EXAMPLE_RESPONSE_V1_LOCATION_FINDER_BBOX,
        EXAMPLE_RESPONSE_V1_LOCATION_FINDER_RADIUS,
        EXAMPLE_RESPONSE_V1_QUERY_PARSER,
        EXAMPLE_REQUEST_V1_SENTIMENT1,
        EXAMPLE_RESPONSE_V1_SENTIMENT1,
        EXAMPLE_REQUEST_V1_SENTIMENT2,
        EXAMPLE_RESPONSE_V1_SENTIMENT2,
        EXAMPLE_REQUEST_V1_SUMMARIZE,
        EXAMPLE_RESPONSE_V1_SUMMARIZE,
        EXAMPLE_REQUEST_V2_TAG,
        EXAMPLE_RESPONSE_V2_TAG,
        EXAMPLE_RESPONSE_V1_USERINFO,
        EXAMPLE_REQUEST_V2_ENRICH,
        EXAMPLE_RESPONSE_V2_ENRICH,
        EXAMPLE_RESPONSE_V2_ENTITIES1,
        EXAMPLE_RESPONSE_V2_ENTITIES2,
        EXAMPLE_RESPONSE_V2_ENTITIES3,
        EXAMPLE_RESPONSE_V2_ENTITIES4,
        EXAMPLE_RESPONSE_V2_ENTITIES5,
        EXAMPLE_RESPONSE_V2_ENTITIES6,
        EXAMPLE_REQUEST_V2_ENTITIES_CREATE,
        EXAMPLE_RESPONSE_V2_ENTITIES_CREATE,
        EXAMPLE_REQUEST_V2_ENTITIES_UPDATE,
        EXAMPLE_RESPONSE_V2_ENTITIES_UPDATE,
        EXAMPLE_RESPONSE_V1_INFORMATION_EXTRACTION_PROMPTS,
        EXAMPLE_RESPONSE_V1_USAGE,
        EXAMPLE_RESPONSE_V1_VERSION,
        EXAMPLE_REQUEST_V2_ENTITIES_LINK,
        EXAMPLE_RESPONSE_V2_ENTITIES_LINK,
        EXAMPLE_REQUEST_TRANSLATE,
        EXAMPLE_RESPONSE_TRANSLATE,
        EXAMPLE_RESPONSE_V1_EXTRACT_ARTICLE,
        
        EXAMPLE_RESPONSE_V1_ADMIN_RESTART,
        EXAMPLE_RESPONSE_V1_ADMIN_SYSINFO,


        EXAMPLE_REQUEST_INSERT,
        EXAMPLE_REQUEST_VALIDATE,
        EXAMPLE_REQUEST_DELETE,

        EXAMPLE_REQUEST_REGEX_DELETE,
        EXAMPLE_REQUEST_REGEX_VALIDATE,
        EXAMPLE_REQUEST_REGEX_INSERT,
        EXAMPLE_RESPONSE_REGEX_INSERT,
        EXAMPLE_RESPONSE_REGEX_INSERT_ERROR,
        EXAMPLE_RESPONSE_REGEX_VALIDATE_DETAILS,
        EXAMPLE_RESPONSE_REGEX_VALIDATE_NO_DETAILS,
        EXAMPLE_RESPONSE_REGEX_DELETE_ALL,
        EXAMPLE_RESPONSE_REGEX_DELETE,
        EXAMPLE_RESPONSE_REGEX_DELETE_WARNING,
        EXAMPLE_RESPONSE_REGEX_DELETE_ERROR,
        EXAMPLE_ADVANCED_REGEX,
        EXAMPLE_BASIC_REGEX,

        EXAMPLE_RESPONSE_EXTRACTION_INSERT,
        EXAMPLE_RESPONSE_EXTRACTION_INSERT_ERROR,
        EXAMPLE_RESPONSE_EXTRACTION_VALIDATE_DETAILS,
        EXAMPLE_RESPONSE_EXTRACTION_VALIDATE_NO_DETAILS,
        EXAMPLE_RESPONSE_EXTRACTION_DELETE,
        EXAMPLE_RESPONSE_EXTRACTION_DELETE_WARNING,
        EXAMPLE_RESPONSE_EXTRACTION_DELETE_ERROR,
        EXAMPLE_RESPONSE_EXTRACTION_DELETE_ALL,
    };
})();
